//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PARROT_API_BASE_URL = new InjectionToken<string>('PARROT_API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PARROT_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCoordonneesComptesBancairesPrelevement(body: GetCoordonneesComptesBancairesPrelevementRequest | undefined): Observable<GetCoordonneesComptesBancairesPrelevementResponse> {
        let url_ = this.baseUrl + "/api/WsCoordonneesBancaires/getCoordonneesComptesBancairesPrelevement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordonneesComptesBancairesPrelevement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordonneesComptesBancairesPrelevement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCoordonneesComptesBancairesPrelevementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCoordonneesComptesBancairesPrelevementResponse>;
        }));
    }

    protected processGetCoordonneesComptesBancairesPrelevement(response: HttpResponseBase): Observable<GetCoordonneesComptesBancairesPrelevementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoordonneesComptesBancairesPrelevementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoordonneesComptesBancairesPrelevementResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateForNewSourcePrelevement(body: UpdateForNewSourcePrelevementRequest | undefined): Observable<UpdateForNewSourcePrelevementResponse> {
        let url_ = this.baseUrl + "/api/WsCoordonneesBancaires/updateForNewSourcePrelevement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForNewSourcePrelevement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForNewSourcePrelevement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateForNewSourcePrelevementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateForNewSourcePrelevementResponse>;
        }));
    }

    protected processUpdateForNewSourcePrelevement(response: HttpResponseBase): Observable<UpdateForNewSourcePrelevementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateForNewSourcePrelevementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateForNewSourcePrelevementResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCoordonneesComptesBancairesReglement(body: GetCoordonneesComptesBancairesReglementRequest | undefined): Observable<GetCoordonneesComptesBancairesReglementResponse> {
        let url_ = this.baseUrl + "/api/WsCoordonneesBancaires/getCoordonneesComptesBancairesReglement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordonneesComptesBancairesReglement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordonneesComptesBancairesReglement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCoordonneesComptesBancairesReglementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCoordonneesComptesBancairesReglementResponse>;
        }));
    }

    protected processGetCoordonneesComptesBancairesReglement(response: HttpResponseBase): Observable<GetCoordonneesComptesBancairesReglementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoordonneesComptesBancairesReglementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoordonneesComptesBancairesReglementResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllPays(body: GetAllPaysRequest | undefined): Observable<GetAllPaysResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getAllPays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPaysResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPaysResponse>;
        }));
    }

    protected processGetAllPays(response: HttpResponseBase): Observable<GetAllPaysResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPaysResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllPaysResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getClientByNumeroClientA(body: GetClientByNumeroClientARequest | undefined): Observable<GetClientByNumeroClientAResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getClientByNumeroClientA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByNumeroClientA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByNumeroClientA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientByNumeroClientAResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientByNumeroClientAResponse>;
        }));
    }

    protected processGetClientByNumeroClientA(response: HttpResponseBase): Observable<GetClientByNumeroClientAResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientByNumeroClientAResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientByNumeroClientAResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getMotifsCSP(body: GetMotifsCSPRequest | undefined): Observable<GetMotifsCSPResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getMotifsCSP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotifsCSP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotifsCSP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMotifsCSPResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMotifsCSPResponse>;
        }));
    }

    protected processGetMotifsCSP(response: HttpResponseBase): Observable<GetMotifsCSPResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMotifsCSPResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMotifsCSPResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllReference(body: GetAllReferenceRequest | undefined): Observable<GetAllReferenceResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getAllReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllReferenceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllReferenceResponse>;
        }));
    }

    protected processGetAllReference(response: HttpResponseBase): Observable<GetAllReferenceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllReferenceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllReferenceResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFilleuls(body: GetFilleulsRequest | undefined): Observable<GetFilleulsResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getFilleuls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilleuls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilleuls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFilleulsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFilleulsResponse>;
        }));
    }

    protected processGetFilleuls(response: HttpResponseBase): Observable<GetFilleulsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFilleulsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFilleulsResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getMotifsPPE(body: GetMotifsPPERequest | undefined): Observable<GetMotifsPPEResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getMotifsPPE";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMotifsPPE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMotifsPPE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMotifsPPEResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMotifsPPEResponse>;
        }));
    }

    protected processGetMotifsPPE(response: HttpResponseBase): Observable<GetMotifsPPEResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMotifsPPEResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMotifsPPEResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getClientByIdCrm(body: GetClientByIdCrmRequest | undefined): Observable<GetClientByIdCrmResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/getClientByIdCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByIdCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByIdCrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientByIdCrmResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientByIdCrmResponse>;
        }));
    }

    protected processGetClientByIdCrm(response: HttpResponseBase): Observable<GetClientByIdCrmResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientByIdCrmResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientByIdCrmResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    prospectToClient(body: ProspectToClientRequest | undefined): Observable<ProspetToClientResponse> {
        let url_ = this.baseUrl + "/api/WsCRMClient/prospectToClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProspectToClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProspectToClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProspetToClientResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProspetToClientResponse>;
        }));
    }

    protected processProspectToClient(response: HttpResponseBase): Observable<ProspetToClientResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProspetToClientResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProspetToClientResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    creationIdentite(body: CreationIdentiteRequest | undefined): Observable<CreationIdentiteResponse> {
        let url_ = this.baseUrl + "/api/WsCRMIdentite/creationIdentite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreationIdentite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreationIdentite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreationIdentiteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreationIdentiteResponse>;
        }));
    }

    protected processCreationIdentite(response: HttpResponseBase): Observable<CreationIdentiteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreationIdentiteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreationIdentiteResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getIBAN(body: GetIBANRequest | undefined): Observable<GetIBANResponse> {
        let url_ = this.baseUrl + "/api/WsCRMIdentite/getIBAN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIBAN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIBAN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIBANResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIBANResponse>;
        }));
    }

    protected processGetIBAN(response: HttpResponseBase): Observable<GetIBANResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIBANResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIBANResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getScoring(body: GetScoringRequest | undefined): Observable<GetScoringResponse> {
        let url_ = this.baseUrl + "/api/WsCRMIdentite/getScoring";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScoring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScoring(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetScoringResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetScoringResponse>;
        }));
    }

    protected processGetScoring(response: HttpResponseBase): Observable<GetScoringResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetScoringResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetScoringResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    modificationIdentite(body: ModificationIdentiteRequest | undefined): Observable<ModificationIdentiteResponse> {
        let url_ = this.baseUrl + "/api/WsCRMIdentite/modificationIdentite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModificationIdentite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModificationIdentite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModificationIdentiteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModificationIdentiteResponse>;
        }));
    }

    protected processModificationIdentite(response: HttpResponseBase): Observable<ModificationIdentiteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModificationIdentiteResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModificationIdentiteResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    creationDemandeDocumentation(body: CreationDemandeDocumentationRequest | undefined): Observable<CreationDemandeDocumentationResponse> {
        let url_ = this.baseUrl + "/api/WsCRMInteractions/creationDemandeDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreationDemandeDocumentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreationDemandeDocumentation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreationDemandeDocumentationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreationDemandeDocumentationResponse>;
        }));
    }

    protected processCreationDemandeDocumentation(response: HttpResponseBase): Observable<CreationDemandeDocumentationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreationDemandeDocumentationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreationDemandeDocumentationResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    creationAbandonSouscription(body: CreationAbandonSouscriptionRequest | undefined): Observable<CreationAbandonSouscriptionResponse> {
        let url_ = this.baseUrl + "/api/WsCRMInteractions/creationAbandonSouscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreationAbandonSouscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreationAbandonSouscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreationAbandonSouscriptionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreationAbandonSouscriptionResponse>;
        }));
    }

    protected processCreationAbandonSouscription(response: HttpResponseBase): Observable<CreationAbandonSouscriptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreationAbandonSouscriptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreationAbandonSouscriptionResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createResultatQuestionnaire(body: CreateResultatQuestionnaireRequest | undefined): Observable<CreateResultatQuestionnaireResponse> {
        let url_ = this.baseUrl + "/api/WsCRMQuestionnaire/createResultatQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateResultatQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateResultatQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResultatQuestionnaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResultatQuestionnaireResponse>;
        }));
    }

    protected processCreateResultatQuestionnaire(response: HttpResponseBase): Observable<CreateResultatQuestionnaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateResultatQuestionnaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateResultatQuestionnaireResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getQuestionnaire(body: GetQuestionnaireRequest | undefined): Observable<GetQuestionnaireResponse> {
        let url_ = this.baseUrl + "/api/WsCRMQuestionnaire/getQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionnaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionnaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuestionnaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuestionnaireResponse>;
        }));
    }

    protected processGetQuestionnaire(response: HttpResponseBase): Observable<GetQuestionnaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetQuestionnaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuestionnaireResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getInfosProfilEpargnant(body: GetInfosProfilEpargnantRequest | undefined): Observable<GetInfosProfilEpargnantResponse> {
        let url_ = this.baseUrl + "/api/WsCRMQuestionnaire/getInfosProfilEpargnant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfosProfilEpargnant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfosProfilEpargnant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInfosProfilEpargnantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInfosProfilEpargnantResponse>;
        }));
    }

    protected processGetInfosProfilEpargnant(response: HttpResponseBase): Observable<GetInfosProfilEpargnantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInfosProfilEpargnantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInfosProfilEpargnantResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeMiseEnPlaceVersementProgramme(body: SendDemandeMiseEnPlaceVersementProgrammeRequest | undefined): Observable<SendDemandeMiseEnPlaceVersementProgrammeResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeMiseEnPlaceVersementProgramme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeMiseEnPlaceVersementProgramme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeMiseEnPlaceVersementProgramme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeMiseEnPlaceVersementProgrammeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeMiseEnPlaceVersementProgrammeResponse>;
        }));
    }

    protected processSendDemandeMiseEnPlaceVersementProgramme(response: HttpResponseBase): Observable<SendDemandeMiseEnPlaceVersementProgrammeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeMiseEnPlaceVersementProgrammeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeMiseEnPlaceVersementProgrammeResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeModificationHorizonCERU(body: SendDemandeModificationHorizonCERURequest | undefined): Observable<SendDemandeModificationHorizonCERUResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeModificationHorizonCERU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeModificationHorizonCERU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeModificationHorizonCERU(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeModificationHorizonCERUResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeModificationHorizonCERUResponse>;
        }));
    }

    protected processSendDemandeModificationHorizonCERU(response: HttpResponseBase): Observable<SendDemandeModificationHorizonCERUResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeModificationHorizonCERUResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeModificationHorizonCERUResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandePrelevementImmediat(body: SendDemandePrelevementImmediatRequest | undefined): Observable<SendDemandePrelevementImmediatResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandePrelevementImmediat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandePrelevementImmediat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandePrelevementImmediat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandePrelevementImmediatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandePrelevementImmediatResponse>;
        }));
    }

    protected processSendDemandePrelevementImmediat(response: HttpResponseBase): Observable<SendDemandePrelevementImmediatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandePrelevementImmediatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandePrelevementImmediatResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeModificationVersementProgramme(body: SendDemandeModificationVersementProgrammeRequest | undefined): Observable<SendDemandeModificationVersementProgrammeResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeModificationVersementProgramme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeModificationVersementProgramme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeModificationVersementProgramme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeModificationVersementProgrammeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeModificationVersementProgrammeResponse>;
        }));
    }

    protected processSendDemandeModificationVersementProgramme(response: HttpResponseBase): Observable<SendDemandeModificationVersementProgrammeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeModificationVersementProgrammeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeModificationVersementProgrammeResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeRachatPartiel(body: SendDemandeRachatPartielRequest | undefined): Observable<SendDemandeRachatPartielResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeRachatPartiel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeRachatPartiel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeRachatPartiel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeRachatPartielResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeRachatPartielResponse>;
        }));
    }

    protected processSendDemandeRachatPartiel(response: HttpResponseBase): Observable<SendDemandeRachatPartielResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeRachatPartielResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeRachatPartielResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeAjoutCoordonneeBancaire(body: SendDemandeAjoutCoordonneeBancaireRequest | undefined): Observable<SendDemandeAjoutCoordonneeBancaireResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeAjoutCoordonneeBancaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeAjoutCoordonneeBancaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeAjoutCoordonneeBancaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeAjoutCoordonneeBancaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeAjoutCoordonneeBancaireResponse>;
        }));
    }

    protected processSendDemandeAjoutCoordonneeBancaire(response: HttpResponseBase): Observable<SendDemandeAjoutCoordonneeBancaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeAjoutCoordonneeBancaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeAjoutCoordonneeBancaireResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeArbitrage(body: SendDemandeArbitrageRequest | undefined): Observable<SendDemandeArbitrageResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeArbitrage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeArbitrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeArbitrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeArbitrageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeArbitrageResponse>;
        }));
    }

    protected processSendDemandeArbitrage(response: HttpResponseBase): Observable<SendDemandeArbitrageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeArbitrageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeArbitrageResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendDemandeAdhesion(body: SendDemandeAdhesionRequest | undefined): Observable<SendDemandeAdhesionResponse> {
        let url_ = this.baseUrl + "/api/WsDemarchesGestion/sendDemandeAdhesion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDemandeAdhesion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDemandeAdhesion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDemandeAdhesionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDemandeAdhesionResponse>;
        }));
    }

    protected processSendDemandeAdhesion(response: HttpResponseBase): Observable<SendDemandeAdhesionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDemandeAdhesionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendDemandeAdhesionResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercheComplementAdresse(body: RechercheComplementAdresseRequest | undefined): Observable<RechercheComplementAdresseResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/rechercheComplementAdresse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheComplementAdresse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheComplementAdresse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheComplementAdresseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheComplementAdresseResponse>;
        }));
    }

    protected processRechercheComplementAdresse(response: HttpResponseBase): Observable<RechercheComplementAdresseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheComplementAdresseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheComplementAdresseResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercheAdresse(body: RechercheAdresseRequest | undefined): Observable<RechercheAdresseResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/rechercheAdresse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheAdresse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheAdresse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheAdresseResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheAdresseResponse>;
        }));
    }

    protected processRechercheAdresse(response: HttpResponseBase): Observable<RechercheAdresseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheAdresseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheAdresseResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercheVille(body: RechercheVilleRequest | undefined): Observable<RechercheVilleResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/rechercheVille";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheVille(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheVille(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheVilleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheVilleResponse>;
        }));
    }

    protected processRechercheVille(response: HttpResponseBase): Observable<RechercheVilleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheVilleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheVilleResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    validationEmail(body: ValidationEmailRequest | undefined): Observable<ValidationEmailResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/validationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationEmailResponse>;
        }));
    }

    protected processValidationEmail(response: HttpResponseBase): Observable<ValidationEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationEmailResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    controleFormulaire(body: ControleFormulaireRequest | undefined): Observable<ControleFormulaireResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/controleFormulaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processControleFormulaire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processControleFormulaire(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ControleFormulaireResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ControleFormulaireResponse>;
        }));
    }

    protected processControleFormulaire(response: HttpResponseBase): Observable<ControleFormulaireResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControleFormulaireResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ControleFormulaireResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercheGeolocalisation(body: RechercheGeolocalisationRequest | undefined): Observable<RechercheGeolocalisationResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/rechercheGeolocalisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheGeolocalisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheGeolocalisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheGeolocalisationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheGeolocalisationResponse>;
        }));
    }

    protected processRechercheGeolocalisation(response: HttpResponseBase): Observable<RechercheGeolocalisationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheGeolocalisationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheGeolocalisationResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    validationNumTel(body: ValidationNumTelRequest | undefined): Observable<ValidationNumTelResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/validationNumTel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationNumTel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationNumTel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationNumTelResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationNumTelResponse>;
        }));
    }

    protected processValidationNumTel(response: HttpResponseBase): Observable<ValidationNumTelResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationNumTelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationNumTelResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercheComplementAdresseSaisie(body: RechercheComplementAdresseSaisieRequest | undefined): Observable<RechercheComplementAdresseSaisieResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/rechercheComplementAdresseSaisie";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheComplementAdresseSaisie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheComplementAdresseSaisie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheComplementAdresseSaisieResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheComplementAdresseSaisieResponse>;
        }));
    }

    protected processRechercheComplementAdresseSaisie(response: HttpResponseBase): Observable<RechercheComplementAdresseSaisieResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheComplementAdresseSaisieResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheComplementAdresseSaisieResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    autoCompletionEmail(body: AutoCompletionEmailRequest | undefined): Observable<AutoCompletionEmailResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/autoCompletionEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoCompletionEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoCompletionEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutoCompletionEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutoCompletionEmailResponse>;
        }));
    }

    protected processAutoCompletionEmail(response: HttpResponseBase): Observable<AutoCompletionEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutoCompletionEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AutoCompletionEmailResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercheRue(body: RechercheRueRequest | undefined): Observable<RechercheRueResponse> {
        let url_ = this.baseUrl + "/api/WsDQE/rechercheRue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercheRue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercheRue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheRueResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheRueResponse>;
        }));
    }

    protected processRechercheRue(response: HttpResponseBase): Observable<RechercheRueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheRueResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheRueResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPolices(body: GetPolicesRequest | undefined): Observable<GetPolicesResponse> {
        let url_ = this.baseUrl + "/api/WsGetPolices/getPolices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolicesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolicesResponse>;
        }));
    }

    protected processGetPolices(response: HttpResponseBase): Observable<GetPolicesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolicesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPolicesResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getContratsTransferablesFourgous(body: GetContratsTransferablesFourgousRequest | undefined): Observable<GetContratsTransferablesFourgousResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/getContratsTransferablesFourgous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContratsTransferablesFourgous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContratsTransferablesFourgous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContratsTransferablesFourgousResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContratsTransferablesFourgousResponse>;
        }));
    }

    protected processGetContratsTransferablesFourgous(response: HttpResponseBase): Observable<GetContratsTransferablesFourgousResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContratsTransferablesFourgousResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContratsTransferablesFourgousResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getSupportsContrat(body: GetSupportsContratRequest | undefined): Observable<GetSupportsContratResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/getSupportsContrat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportsContrat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportsContrat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSupportsContratResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSupportsContratResponse>;
        }));
    }

    protected processGetSupportsContrat(response: HttpResponseBase): Observable<GetSupportsContratResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupportsContratResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSupportsContratResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getClientByNumeroContrat(body: GetClientByNumeroContratRequest | undefined): Observable<GetClientByNumeroContratResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/getClientByNumeroContrat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientByNumeroContrat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientByNumeroContrat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClientByNumeroContratResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClientByNumeroContratResponse>;
        }));
    }

    protected processGetClientByNumeroContrat(response: HttpResponseBase): Observable<GetClientByNumeroContratResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientByNumeroContratResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientByNumeroContratResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getPolices2(body: GetPolicesRequest2 | undefined): Observable<GetPolicesResponse2> {
        let url_ = this.baseUrl + "/api/WsPolices/getPolices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPolices2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPolices2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPolicesResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPolicesResponse2>;
        }));
    }

    protected processGetPolices2(response: HttpResponseBase): Observable<GetPolicesResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPolicesResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPolicesResponse2>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercherRachat(body: RechercheRachatRequest | undefined): Observable<RechercheRachatResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/rechercherRachat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherRachat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherRachat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheRachatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheRachatResponse>;
        }));
    }

    protected processRechercherRachat(response: HttpResponseBase): Observable<RechercheRachatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheRachatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheRachatResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDemarchesEnCours(body: GetDemarchesEnCoursRequest | undefined): Observable<GetDemarchesEnCoursResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/getDemarchesEnCours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDemarchesEnCours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDemarchesEnCours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDemarchesEnCoursResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDemarchesEnCoursResponse>;
        }));
    }

    protected processGetDemarchesEnCours(response: HttpResponseBase): Observable<GetDemarchesEnCoursResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDemarchesEnCoursResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDemarchesEnCoursResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getRepartitionContratMultisupport(body: GetRepartitionContratMultisupportRequest | undefined): Observable<GetRepartitionContratMultisupportResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/getRepartitionContratMultisupport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepartitionContratMultisupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepartitionContratMultisupport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRepartitionContratMultisupportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRepartitionContratMultisupportResponse>;
        }));
    }

    protected processGetRepartitionContratMultisupport(response: HttpResponseBase): Observable<GetRepartitionContratMultisupportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRepartitionContratMultisupportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRepartitionContratMultisupportResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    rechercherAvenantNantissement(body: RechercheAvenantNantissementRequest | undefined): Observable<RechercheAvenantNantissementResponse> {
        let url_ = this.baseUrl + "/api/WsPolices/rechercherAvenantNantissement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRechercherAvenantNantissement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRechercherAvenantNantissement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RechercheAvenantNantissementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RechercheAvenantNantissementResponse>;
        }));
    }

    protected processRechercherAvenantNantissement(response: HttpResponseBase): Observable<RechercheAvenantNantissementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RechercheAvenantNantissementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RechercheAvenantNantissementResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getTarifsPrevoyanceGFD(body: GetTarifsPrevoyanceGFDRequest | undefined): Observable<GetTarifsPrevoyanceGFDResponse> {
        let url_ = this.baseUrl + "/api/WsPrevoyanceGFD/getTarifsPrevoyanceGFD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTarifsPrevoyanceGFD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTarifsPrevoyanceGFD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTarifsPrevoyanceGFDResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTarifsPrevoyanceGFDResponse>;
        }));
    }

    protected processGetTarifsPrevoyanceGFD(response: HttpResponseBase): Observable<GetTarifsPrevoyanceGFDResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTarifsPrevoyanceGFDResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTarifsPrevoyanceGFDResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getTarifsPrevoyanceGPA(body: GetTarifsPrevoyanceGPARequest | undefined): Observable<GetTarifsPrevoyanceGPAResponse> {
        let url_ = this.baseUrl + "/api/WsPrevoyanceGPA/getTarifsPrevoyanceGPA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTarifsPrevoyanceGPA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTarifsPrevoyanceGPA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTarifsPrevoyanceGPAResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTarifsPrevoyanceGPAResponse>;
        }));
    }

    protected processGetTarifsPrevoyanceGPA(response: HttpResponseBase): Observable<GetTarifsPrevoyanceGPAResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTarifsPrevoyanceGPAResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTarifsPrevoyanceGPAResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getListeReferencesMetier(body: ListeReferencesMetierRequest | undefined): Observable<ListeReferencesMetierResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getListeReferencesMetier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListeReferencesMetier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListeReferencesMetier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListeReferencesMetierResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListeReferencesMetierResponse>;
        }));
    }

    protected processGetListeReferencesMetier(response: HttpResponseBase): Observable<ListeReferencesMetierResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListeReferencesMetierResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListeReferencesMetierResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getTypePDFDocumentProduit(body: GetTypePDFDocumentProduitRequest | undefined): Observable<GetTypePDFDocumentProduitResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getTypePDFDocumentProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypePDFDocumentProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypePDFDocumentProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypePDFDocumentProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypePDFDocumentProduitResponse>;
        }));
    }

    protected processGetTypePDFDocumentProduit(response: HttpResponseBase): Observable<GetTypePDFDocumentProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypePDFDocumentProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTypePDFDocumentProduitResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getCodeCommune(body: GetCodeCommuneRequest | undefined): Observable<GetCodeCommuneResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getCodeCommune";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodeCommune(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodeCommune(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCodeCommuneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCodeCommuneResponse>;
        }));
    }

    protected processGetCodeCommune(response: HttpResponseBase): Observable<GetCodeCommuneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCodeCommuneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCodeCommuneResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getProfils(body: GetProfils | undefined): Observable<GetProfilsResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getProfils";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfils(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfils(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilsResponse>;
        }));
    }

    protected processGetProfils(response: HttpResponseBase): Observable<GetProfilsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilsResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getTypesDocuments(body: GetTypesDocumentsRequest | undefined): Observable<GetTypesDocumentsResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getTypesDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypesDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypesDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTypesDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTypesDocumentsResponse>;
        }));
    }

    protected processGetTypesDocuments(response: HttpResponseBase): Observable<GetTypesDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypesDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTypesDocumentsResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFondsProduit(body: GetFondsProduitRequest | undefined): Observable<GetFondsProduitResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getFondsProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFondsProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFondsProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFondsProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFondsProduitResponse>;
        }));
    }

    protected processGetFondsProduit(response: HttpResponseBase): Observable<GetFondsProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFondsProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFondsProduitResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDocumentsPackProduit(body: GetDocumentPackProduitRequest | undefined): Observable<GetDocumentPackProduitResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDocumentsPackProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsPackProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsPackProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentPackProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentPackProduitResponse>;
        }));
    }

    protected processGetDocumentsPackProduit(response: HttpResponseBase): Observable<GetDocumentPackProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentPackProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentPackProduitResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDonneesVersement(body: GetDonneesVersementRequest | undefined): Observable<GetDonneesVersementResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDonneesVersement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonneesVersement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonneesVersement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonneesVersementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonneesVersementResponse>;
        }));
    }

    protected processGetDonneesVersement(response: HttpResponseBase): Observable<GetDonneesVersementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonneesVersementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonneesVersementResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getListeDocuments(body: GetListeDocumentsRequest | undefined): Observable<GetListeDocumentsResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getListeDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListeDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListeDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetListeDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetListeDocumentsResponse>;
        }));
    }

    protected processGetListeDocuments(response: HttpResponseBase): Observable<GetListeDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetListeDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetListeDocumentsResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFraisVersement(body: GetFraisVersementRequest | undefined): Observable<GetFraisVersementResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getFraisVersement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFraisVersement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFraisVersement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFraisVersementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFraisVersementResponse>;
        }));
    }

    protected processGetFraisVersement(response: HttpResponseBase): Observable<GetFraisVersementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFraisVersementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFraisVersementResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDonneesRachat(body: GetDonneesRachatRequest | undefined): Observable<GetDonneesRachatResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDonneesRachat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonneesRachat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonneesRachat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonneesRachatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonneesRachatResponse>;
        }));
    }

    protected processGetDonneesRachat(response: HttpResponseBase): Observable<GetDonneesRachatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonneesRachatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonneesRachatResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getMandatGestion(body: MandatGestionRequest | undefined): Observable<MandatGestionResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getMandatGestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMandatGestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMandatGestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MandatGestionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MandatGestionResponse>;
        }));
    }

    protected processGetMandatGestion(response: HttpResponseBase): Observable<MandatGestionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MandatGestionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MandatGestionResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDonneesArbitrage(body: GetDonneesArbitrageRequest | undefined): Observable<GetDonneesArbitrageResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDonneesArbitrage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDonneesArbitrage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonneesArbitrage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDonneesArbitrageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDonneesArbitrageResponse>;
        }));
    }

    protected processGetDonneesArbitrage(response: HttpResponseBase): Observable<GetDonneesArbitrageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDonneesArbitrageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDonneesArbitrageResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getProduits(body: GetProduitsRequest | undefined): Observable<GetProduitsResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getProduits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProduitsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProduitsResponse>;
        }));
    }

    protected processGetProduits(response: HttpResponseBase): Observable<GetProduitsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProduitsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProduitsResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDocumentsFichier(body: GetDocumentsFichierRequest | undefined): Observable<GetDocumentsFichierResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDocumentsFichier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFichier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFichier(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentsFichierResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentsFichierResponse>;
        }));
    }

    protected processGetDocumentsFichier(response: HttpResponseBase): Observable<GetDocumentsFichierResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsFichierResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentsFichierResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFichierPDF(body: GetFichierPDFRequest | undefined): Observable<GetFichierPDFResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getFichierPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFichierPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFichierPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFichierPDFResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFichierPDFResponse>;
        }));
    }

    protected processGetFichierPDF(response: HttpResponseBase): Observable<GetFichierPDFResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFichierPDFResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFichierPDFResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDocumentsProduit(body: GetDocumentsProduitRequest | undefined): Observable<GetDocumentsProduitResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDocumentsProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentsProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentsProduitResponse>;
        }));
    }

    protected processGetDocumentsProduit(response: HttpResponseBase): Observable<GetDocumentsProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentsProduitResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDocumentsFonds(body: GetDocumentsFondsRequest | undefined): Observable<GetDocumentsFondsResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDocumentsFonds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsFonds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsFonds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentsFondsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentsFondsResponse>;
        }));
    }

    protected processGetDocumentsFonds(response: HttpResponseBase): Observable<GetDocumentsFondsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentsFondsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentsFondsResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getOrigineDemande(body: GetOrigineDemandeRequest | undefined): Observable<GetOrigineDemandeResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getOrigineDemande";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrigineDemande(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrigineDemande(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrigineDemandeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrigineDemandeResponse>;
        }));
    }

    protected processGetOrigineDemande(response: HttpResponseBase): Observable<GetOrigineDemandeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrigineDemandeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrigineDemandeResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getRecommandation(body: GetRecommandationRequest | undefined): Observable<GetRecommandationResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getRecommandation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecommandation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecommandation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecommandationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecommandationResponse>;
        }));
    }

    protected processGetRecommandation(response: HttpResponseBase): Observable<GetRecommandationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecommandationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecommandationResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getReglesMetierProduit(body: GetReglesMetierProduitRequest | undefined): Observable<GetReglesMetierProduitResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getReglesMetierProduit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReglesMetierProduit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReglesMetierProduit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReglesMetierProduitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReglesMetierProduitResponse>;
        }));
    }

    protected processGetReglesMetierProduit(response: HttpResponseBase): Observable<GetReglesMetierProduitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReglesMetierProduitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReglesMetierProduitResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getDocumentsProduitSignatureSouscriptionEnLigne(body: DocumentsProduitSignatureSouscriptionEnLigneRequest | undefined): Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getDocumentsProduitSignatureSouscriptionEnLigne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsProduitSignatureSouscriptionEnLigne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsProduitSignatureSouscriptionEnLigne(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse>;
        }));
    }

    protected processGetDocumentsProduitSignatureSouscriptionEnLigne(response: HttpResponseBase): Observable<DocumentsProduitSignatureSouscriptionEnLigneResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentsProduitSignatureSouscriptionEnLigneResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentsProduitSignatureSouscriptionEnLigneResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getRUM(body: GetRUMRequest | undefined): Observable<GetRUMResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getRUM";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRUM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRUM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRUMResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRUMResponse>;
        }));
    }

    protected processGetRUM(response: HttpResponseBase): Observable<GetRUMResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRUMResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRUMResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getGrilleDesensibilisationCERU(body: GetGrilleDesensibilisationCERURequest | undefined): Observable<GetGrilleDesensibilisationCERUResponse> {
        let url_ = this.baseUrl + "/api/WsReferentielMetier/getGrilleDesensibilisationCERU";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrilleDesensibilisationCERU(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrilleDesensibilisationCERU(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGrilleDesensibilisationCERUResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGrilleDesensibilisationCERUResponse>;
        }));
    }

    protected processGetGrilleDesensibilisationCERU(response: HttpResponseBase): Observable<GetGrilleDesensibilisationCERUResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGrilleDesensibilisationCERUResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGrilleDesensibilisationCERUResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createMandat(body: CreateMandatRequest | undefined): Observable<CreateMandatResponse> {
        let url_ = this.baseUrl + "/api/WsSepalia/createMandat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMandat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMandat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMandatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMandatResponse>;
        }));
    }

    protected processCreateMandat(response: HttpResponseBase): Observable<CreateMandatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMandatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateMandatResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getBICFromIBAN(body: GetBICFromIBANRequest | undefined): Observable<GetBICFromIBANResponse> {
        let url_ = this.baseUrl + "/api/WsSepalia/getBICFromIBAN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBICFromIBAN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBICFromIBAN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBICFromIBANResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBICFromIBANResponse>;
        }));
    }

    protected processGetBICFromIBAN(response: HttpResponseBase): Observable<GetBICFromIBANResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBICFromIBANResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBICFromIBANResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    searchMandat(body: SearchMandatRequest | undefined): Observable<SearchMandatResponse> {
        let url_ = this.baseUrl + "/api/WsSepalia/searchMandat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMandat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMandat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchMandatResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchMandatResponse>;
        }));
    }

    protected processSearchMandat(response: HttpResponseBase): Observable<SearchMandatResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchMandatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchMandatResponse>(null as any);
    }
}

export class CSP implements ICSP {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    professions?: Professions[] | undefined;

    constructor(data?: ICSP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(Professions.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CSP {
        data = typeof data === 'object' ? data : {};
        let result = new CSP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICSP {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    professions?: Professions[] | undefined;
}

export class AdressePrincipale implements IAdressePrincipale {
    adresseFR?: boolean;
    codeCommune?: string | undefined;
    codePostal?: string | undefined;
    codeVoie?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    nomVille?: string | undefined;
    npai?: boolean;
    npaiCommentaire?: string | undefined;
    paysId?: number;
    paysLibelle?: string | undefined;
    type?: number;
    voie?: string | undefined;
    pays?: Pays;

    constructor(data?: IAdressePrincipale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adresseFR = _data["adresseFR"];
            this.codeCommune = _data["codeCommune"];
            this.codePostal = _data["codePostal"];
            this.codeVoie = _data["codeVoie"];
            this.complement = _data["complement"];
            this.complement2 = _data["complement2"];
            this.lieudit = _data["lieudit"];
            this.nomVille = _data["nomVille"];
            this.npai = _data["npai"];
            this.npaiCommentaire = _data["npaiCommentaire"];
            this.paysId = _data["paysId"];
            this.paysLibelle = _data["paysLibelle"];
            this.type = _data["type"];
            this.voie = _data["voie"];
            this.pays = _data["pays"] ? Pays.fromJS(_data["pays"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdressePrincipale {
        data = typeof data === 'object' ? data : {};
        let result = new AdressePrincipale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adresseFR"] = this.adresseFR;
        data["codeCommune"] = this.codeCommune;
        data["codePostal"] = this.codePostal;
        data["codeVoie"] = this.codeVoie;
        data["complement"] = this.complement;
        data["complement2"] = this.complement2;
        data["lieudit"] = this.lieudit;
        data["nomVille"] = this.nomVille;
        data["npai"] = this.npai;
        data["npaiCommentaire"] = this.npaiCommentaire;
        data["paysId"] = this.paysId;
        data["paysLibelle"] = this.paysLibelle;
        data["type"] = this.type;
        data["voie"] = this.voie;
        data["pays"] = this.pays ? this.pays.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdressePrincipale {
    adresseFR?: boolean;
    codeCommune?: string | undefined;
    codePostal?: string | undefined;
    codeVoie?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    nomVille?: string | undefined;
    npai?: boolean;
    npaiCommentaire?: string | undefined;
    paysId?: number;
    paysLibelle?: string | undefined;
    type?: number;
    voie?: string | undefined;
    pays?: Pays;
}

export class Beneficiaires implements IBeneficiaires {
    noSocietaireInterne?: string | undefined;
    mail?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    civilite?: string | undefined;
    dateParrainage?: Date | undefined;

    constructor(data?: IBeneficiaires) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.mail = _data["mail"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.civilite = _data["civilite"];
            this.dateParrainage = _data["dateParrainage"] ? new Date(_data["dateParrainage"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Beneficiaires {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiaires();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["mail"] = this.mail;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["civilite"] = this.civilite;
        data["dateParrainage"] = this.dateParrainage ? this.dateParrainage.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBeneficiaires {
    noSocietaireInterne?: string | undefined;
    mail?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    civilite?: string | undefined;
    dateParrainage?: Date | undefined;
}

export class Complement implements IComplement {
    autreContrat?: number;
    compositionPatrimoines?: CompositionPatrimoines;
    exerciceFiscal?: number | undefined;
    matricule?: string | undefined;
    mifInfo?: number;
    motifSouscription?: number;
    nbEnfants16AnsOuPlus?: number | undefined;
    nbEnfantsACharge?: number | undefined;
    nbEnfantsMoins16Ans?: number | undefined;
    notificationOperation?: number;
    numeroClientB?: number;
    regimeMatrimonial?: number;
    revenuFiscal?: number | undefined;
    revenuMensuelNetFoyer?: number;
    secteurActivite?: number;
    sectionMIF?: number;
    situationFamiliale?: number;
    situationFamilialeFiscale?: number;
    situationFinanciere?: number;
    situationPatrimoniale?: number;
    situationProfessionnelle?: number;
    profession?: number | undefined;
    CSP?: number;
    sollicitationCourrier?: boolean | undefined;
    sollicitationEmail?: boolean | undefined;
    sollicitationSMS?: boolean | undefined;
    sollicitationPartenaire?: boolean | undefined;
    source?: number;
    sourceAnnee?: number;
    statutCommercial?: number;
    statutInstitutionnel?: number;
    statutSncf?: string | undefined;
    strCompositionPatrimoine?: string | undefined;
    typeClient?: string | undefined;
    typeMatricule?: string | undefined;
    motifSouscriptionLibelle?: string | undefined;
    regimeMatrimonialLibelle?: string | undefined;
    situationFamilialeLibelle?: string | undefined;
    situationFamilialeFiscaleLibelle?: string | undefined;
    situationFinanciereLibelle?: string | undefined;
    situationPatrimonialeLibelle?: string | undefined;
    situationProfessionnelleLibelle?: string | undefined;
    professionLibelle?: string | undefined;
    CSPLibelle?: string | undefined;
    revenuMensuelNetFoyerLibelle?: string | undefined;
    secteurActiviteLibelle?: string | undefined;
    notificationOperationLibelle?: string | undefined;
    abonnePerformance?: boolean | undefined;
    abonneActualite?: boolean | undefined;
    canalPrefereNotificationOperation?: string | undefined;
    canalPrefereMifInfos?: string | undefined;
    relations?: Relation[] | undefined;

    constructor(data?: IComplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autreContrat = _data["autreContrat"];
            this.compositionPatrimoines = _data["compositionPatrimoines"] ? CompositionPatrimoines.fromJS(_data["compositionPatrimoines"]) : <any>undefined;
            this.exerciceFiscal = _data["exerciceFiscal"];
            this.matricule = _data["matricule"];
            this.mifInfo = _data["mifInfo"];
            this.motifSouscription = _data["motifSouscription"];
            this.nbEnfants16AnsOuPlus = _data["nbEnfants16AnsOuPlus"];
            this.nbEnfantsACharge = _data["nbEnfantsACharge"];
            this.nbEnfantsMoins16Ans = _data["nbEnfantsMoins16Ans"];
            this.notificationOperation = _data["notificationOperation"];
            this.numeroClientB = _data["numeroClientB"];
            this.regimeMatrimonial = _data["regimeMatrimonial"];
            this.revenuFiscal = _data["revenuFiscal"];
            this.revenuMensuelNetFoyer = _data["revenuMensuelNetFoyer"];
            this.secteurActivite = _data["secteurActivite"];
            this.sectionMIF = _data["sectionMIF"];
            this.situationFamiliale = _data["situationFamiliale"];
            this.situationFamilialeFiscale = _data["situationFamilialeFiscale"];
            this.situationFinanciere = _data["situationFinanciere"];
            this.situationPatrimoniale = _data["situationPatrimoniale"];
            this.situationProfessionnelle = _data["situationProfessionnelle"];
            this.profession = _data["profession"];
            this.CSP = _data["CSP"];
            this.sollicitationCourrier = _data["sollicitationCourrier"];
            this.sollicitationEmail = _data["sollicitationEmail"];
            this.sollicitationSMS = _data["sollicitationSMS"];
            this.sollicitationPartenaire = _data["sollicitationPartenaire"];
            this.source = _data["source"];
            this.sourceAnnee = _data["sourceAnnee"];
            this.statutCommercial = _data["statutCommercial"];
            this.statutInstitutionnel = _data["statutInstitutionnel"];
            this.statutSncf = _data["statutSncf"];
            this.strCompositionPatrimoine = _data["strCompositionPatrimoine"];
            this.typeClient = _data["typeClient"];
            this.typeMatricule = _data["typeMatricule"];
            this.motifSouscriptionLibelle = _data["motifSouscriptionLibelle"];
            this.regimeMatrimonialLibelle = _data["regimeMatrimonialLibelle"];
            this.situationFamilialeLibelle = _data["situationFamilialeLibelle"];
            this.situationFamilialeFiscaleLibelle = _data["situationFamilialeFiscaleLibelle"];
            this.situationFinanciereLibelle = _data["situationFinanciereLibelle"];
            this.situationPatrimonialeLibelle = _data["situationPatrimonialeLibelle"];
            this.situationProfessionnelleLibelle = _data["situationProfessionnelleLibelle"];
            this.professionLibelle = _data["professionLibelle"];
            this.CSPLibelle = _data["CSPLibelle"];
            this.revenuMensuelNetFoyerLibelle = _data["revenuMensuelNetFoyerLibelle"];
            this.secteurActiviteLibelle = _data["secteurActiviteLibelle"];
            this.notificationOperationLibelle = _data["notificationOperationLibelle"];
            this.abonnePerformance = _data["abonnePerformance"];
            this.abonneActualite = _data["abonneActualite"];
            this.canalPrefereNotificationOperation = _data["canalPrefereNotificationOperation"];
            this.canalPrefereMifInfos = _data["canalPrefereMifInfos"];
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(Relation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Complement {
        data = typeof data === 'object' ? data : {};
        let result = new Complement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autreContrat"] = this.autreContrat;
        data["compositionPatrimoines"] = this.compositionPatrimoines ? this.compositionPatrimoines.toJSON() : <any>undefined;
        data["exerciceFiscal"] = this.exerciceFiscal;
        data["matricule"] = this.matricule;
        data["mifInfo"] = this.mifInfo;
        data["motifSouscription"] = this.motifSouscription;
        data["nbEnfants16AnsOuPlus"] = this.nbEnfants16AnsOuPlus;
        data["nbEnfantsACharge"] = this.nbEnfantsACharge;
        data["nbEnfantsMoins16Ans"] = this.nbEnfantsMoins16Ans;
        data["notificationOperation"] = this.notificationOperation;
        data["numeroClientB"] = this.numeroClientB;
        data["regimeMatrimonial"] = this.regimeMatrimonial;
        data["revenuFiscal"] = this.revenuFiscal;
        data["revenuMensuelNetFoyer"] = this.revenuMensuelNetFoyer;
        data["secteurActivite"] = this.secteurActivite;
        data["sectionMIF"] = this.sectionMIF;
        data["situationFamiliale"] = this.situationFamiliale;
        data["situationFamilialeFiscale"] = this.situationFamilialeFiscale;
        data["situationFinanciere"] = this.situationFinanciere;
        data["situationPatrimoniale"] = this.situationPatrimoniale;
        data["situationProfessionnelle"] = this.situationProfessionnelle;
        data["profession"] = this.profession;
        data["CSP"] = this.CSP;
        data["sollicitationCourrier"] = this.sollicitationCourrier;
        data["sollicitationEmail"] = this.sollicitationEmail;
        data["sollicitationSMS"] = this.sollicitationSMS;
        data["sollicitationPartenaire"] = this.sollicitationPartenaire;
        data["source"] = this.source;
        data["sourceAnnee"] = this.sourceAnnee;
        data["statutCommercial"] = this.statutCommercial;
        data["statutInstitutionnel"] = this.statutInstitutionnel;
        data["statutSncf"] = this.statutSncf;
        data["strCompositionPatrimoine"] = this.strCompositionPatrimoine;
        data["typeClient"] = this.typeClient;
        data["typeMatricule"] = this.typeMatricule;
        data["motifSouscriptionLibelle"] = this.motifSouscriptionLibelle;
        data["regimeMatrimonialLibelle"] = this.regimeMatrimonialLibelle;
        data["situationFamilialeLibelle"] = this.situationFamilialeLibelle;
        data["situationFamilialeFiscaleLibelle"] = this.situationFamilialeFiscaleLibelle;
        data["situationFinanciereLibelle"] = this.situationFinanciereLibelle;
        data["situationPatrimonialeLibelle"] = this.situationPatrimonialeLibelle;
        data["situationProfessionnelleLibelle"] = this.situationProfessionnelleLibelle;
        data["professionLibelle"] = this.professionLibelle;
        data["CSPLibelle"] = this.CSPLibelle;
        data["revenuMensuelNetFoyerLibelle"] = this.revenuMensuelNetFoyerLibelle;
        data["secteurActiviteLibelle"] = this.secteurActiviteLibelle;
        data["notificationOperationLibelle"] = this.notificationOperationLibelle;
        data["abonnePerformance"] = this.abonnePerformance;
        data["abonneActualite"] = this.abonneActualite;
        data["canalPrefereNotificationOperation"] = this.canalPrefereNotificationOperation;
        data["canalPrefereMifInfos"] = this.canalPrefereMifInfos;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComplement {
    autreContrat?: number;
    compositionPatrimoines?: CompositionPatrimoines;
    exerciceFiscal?: number | undefined;
    matricule?: string | undefined;
    mifInfo?: number;
    motifSouscription?: number;
    nbEnfants16AnsOuPlus?: number | undefined;
    nbEnfantsACharge?: number | undefined;
    nbEnfantsMoins16Ans?: number | undefined;
    notificationOperation?: number;
    numeroClientB?: number;
    regimeMatrimonial?: number;
    revenuFiscal?: number | undefined;
    revenuMensuelNetFoyer?: number;
    secteurActivite?: number;
    sectionMIF?: number;
    situationFamiliale?: number;
    situationFamilialeFiscale?: number;
    situationFinanciere?: number;
    situationPatrimoniale?: number;
    situationProfessionnelle?: number;
    profession?: number | undefined;
    CSP?: number;
    sollicitationCourrier?: boolean | undefined;
    sollicitationEmail?: boolean | undefined;
    sollicitationSMS?: boolean | undefined;
    sollicitationPartenaire?: boolean | undefined;
    source?: number;
    sourceAnnee?: number;
    statutCommercial?: number;
    statutInstitutionnel?: number;
    statutSncf?: string | undefined;
    strCompositionPatrimoine?: string | undefined;
    typeClient?: string | undefined;
    typeMatricule?: string | undefined;
    motifSouscriptionLibelle?: string | undefined;
    regimeMatrimonialLibelle?: string | undefined;
    situationFamilialeLibelle?: string | undefined;
    situationFamilialeFiscaleLibelle?: string | undefined;
    situationFinanciereLibelle?: string | undefined;
    situationPatrimonialeLibelle?: string | undefined;
    situationProfessionnelleLibelle?: string | undefined;
    professionLibelle?: string | undefined;
    CSPLibelle?: string | undefined;
    revenuMensuelNetFoyerLibelle?: string | undefined;
    secteurActiviteLibelle?: string | undefined;
    notificationOperationLibelle?: string | undefined;
    abonnePerformance?: boolean | undefined;
    abonneActualite?: boolean | undefined;
    canalPrefereNotificationOperation?: string | undefined;
    canalPrefereMifInfos?: string | undefined;
    relations?: Relation[] | undefined;
}

export class CompositionPatrimoines implements ICompositionPatrimoines {
    id?: number | undefined;
    libelleCourt?: string | undefined;

    constructor(data?: ICompositionPatrimoines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
        }
    }

    static fromJS(data: any): CompositionPatrimoines {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionPatrimoines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        return data;
    }
}

export interface ICompositionPatrimoines {
    id?: number | undefined;
    libelleCourt?: string | undefined;
}

export class Erreur implements IErreur {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetAllPaysRequest implements IGetAllPaysRequest {

    constructor(data?: IGetAllPaysRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllPaysRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaysRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllPaysRequest {
}

export class GetAllPaysResponse implements IGetAllPaysResponse {
    return?: Pays[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetAllPaysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["return"])) {
                this.return = [] as any;
                for (let item of _data["return"])
                    this.return!.push(Pays.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPaysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.return)) {
            data["return"] = [];
            for (let item of this.return)
                data["return"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllPaysResponse {
    return?: Pays[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetAllReferenceRequest implements IGetAllReferenceRequest {

    constructor(data?: IGetAllReferenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllReferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllReferenceRequest {
}

export class GetAllReferenceResponse implements IGetAllReferenceResponse {
    informations?: Informations[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetAllReferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["informations"])) {
                this.informations = [] as any;
                for (let item of _data["informations"])
                    this.informations!.push(Informations.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllReferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.informations)) {
            data["informations"] = [];
            for (let item of this.informations)
                data["informations"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllReferenceResponse {
    informations?: Informations[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetClientByIdCrmRequest implements IGetClientByIdCrmRequest {
    numeroClientCRM?: string | undefined;

    constructor(data?: IGetClientByIdCrmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientCRM = _data["numeroClientCRM"];
        }
    }

    static fromJS(data: any): GetClientByIdCrmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByIdCrmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientCRM"] = this.numeroClientCRM;
        return data;
    }
}

export interface IGetClientByIdCrmRequest {
    numeroClientCRM?: string | undefined;
}

export class GetClientByIdCrmResponse implements IGetClientByIdCrmResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetClientByIdCrmResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.return = _data["return"] ? GetIdentite.fromJS(_data["return"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientByIdCrmResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByIdCrmResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["return"] = this.return ? this.return.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetClientByIdCrmResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;
}

export class GetClientByNumeroClientARequest implements IGetClientByNumeroClientARequest {
    numeroClientA?: string | undefined;

    constructor(data?: IGetClientByNumeroClientARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientA = _data["numeroClientA"];
        }
    }

    static fromJS(data: any): GetClientByNumeroClientARequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroClientARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientA"] = this.numeroClientA;
        return data;
    }
}

export interface IGetClientByNumeroClientARequest {
    numeroClientA?: string | undefined;
}

export class GetClientByNumeroClientAResponse implements IGetClientByNumeroClientAResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;
    warnings?: Warning[] | undefined;

    constructor(data?: IGetClientByNumeroClientAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.return = _data["return"] ? GetIdentite.fromJS(_data["return"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientByNumeroClientAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroClientAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["return"] = this.return ? this.return.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetClientByNumeroClientAResponse {
    return?: GetIdentite;
    erreurs?: Erreur[] | undefined;
    warnings?: Warning[] | undefined;
}

export class GetFilleulsRequest implements IGetFilleulsRequest {
    noSocietaireInterne?: string | undefined;

    constructor(data?: IGetFilleulsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
        }
    }

    static fromJS(data: any): GetFilleulsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilleulsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        return data;
    }
}

export interface IGetFilleulsRequest {
    noSocietaireInterne?: string | undefined;
}

export class GetFilleulsResponse implements IGetFilleulsResponse {
    beneficiaires?: Beneficiaires[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetFilleulsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["beneficiaires"])) {
                this.beneficiaires = [] as any;
                for (let item of _data["beneficiaires"])
                    this.beneficiaires!.push(Beneficiaires.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilleulsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilleulsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.beneficiaires)) {
            data["beneficiaires"] = [];
            for (let item of this.beneficiaires)
                data["beneficiaires"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilleulsResponse {
    beneficiaires?: Beneficiaires[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetIdentite implements IGetIdentite {
    id?: string | undefined;
    consultationDate?: Date;
    consultationUtilisateurId?: string | undefined;
    creationDate?: Date;
    creationUtilisateurId?: string | undefined;
    desactivationDate?: Date;
    desactivationUtilisateurId?: string | undefined;
    desactive?: boolean;
    majDate?: Date;
    majUtilisateurId?: string | undefined;
    anneeNaissance?: number;
    autresPrenoms?: string | undefined;
    codeCommuneNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    commentaire?: string | undefined;
    contribuableAmericain?: boolean;
    dateDeces?: Date;
    dateNaissance?: Date;
    departementNaissance?: string | undefined;
    email?: string | undefined;
    fonctionPPE?: number;
    fonctionPPELibelle?: string | undefined;
    motifPPE?: number;
    motifPPELibelle?: string | undefined;
    inseeVilleNaissance?: string | undefined;
    isEmailValide?: boolean;
    jourNaissance?: number;
    mesureProtectionJuridique?: number;
    mesureProtectionJuridiqueLibelle?: string | undefined;
    moisNaissance?: number;
    nationalite?: number;
    nationaliteLibelle?: string | undefined;
    nom?: string | undefined;
    nomJeuneFille?: string | undefined;
    numero?: string | undefined;
    numeroClientA?: string | undefined;
    numeroClientB?: string | undefined;
    NIR?: string | undefined;
    paysNaissance?: string | undefined;
    paysResidenceFiscaleId?: number;
    paysResidenceFiscaleLibelle?: string | undefined;
    personneMorale?: boolean;
    politiquementExposee?: boolean;
    prenom?: string | undefined;
    sexe?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    titre?: string | undefined;
    type?: string | undefined;
    villeNaissance?: string | undefined;
    associationClientId?: number;
    associationPrincipale?: boolean;
    lastConsultationDateByClient?: Date;
    typeClient?: string | undefined;
    adressePrincipale?: AdressePrincipale;
    complement?: Complement;

    constructor(data?: IGetIdentite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>undefined;
            this.consultationUtilisateurId = _data["consultationUtilisateurId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.creationUtilisateurId = _data["creationUtilisateurId"];
            this.desactivationDate = _data["desactivationDate"] ? new Date(_data["desactivationDate"].toString()) : <any>undefined;
            this.desactivationUtilisateurId = _data["desactivationUtilisateurId"];
            this.desactive = _data["desactive"];
            this.majDate = _data["majDate"] ? new Date(_data["majDate"].toString()) : <any>undefined;
            this.majUtilisateurId = _data["majUtilisateurId"];
            this.anneeNaissance = _data["anneeNaissance"];
            this.autresPrenoms = _data["autresPrenoms"];
            this.codeCommuneNaissance = _data["codeCommuneNaissance"];
            this.codePostalNaissance = _data["codePostalNaissance"];
            this.commentaire = _data["commentaire"];
            this.contribuableAmericain = _data["contribuableAmericain"];
            this.dateDeces = _data["dateDeces"] ? new Date(_data["dateDeces"].toString()) : <any>undefined;
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.departementNaissance = _data["departementNaissance"];
            this.email = _data["email"];
            this.fonctionPPE = _data["fonctionPPE"];
            this.fonctionPPELibelle = _data["fonctionPPELibelle"];
            this.motifPPE = _data["motifPPE"];
            this.motifPPELibelle = _data["motifPPELibelle"];
            this.inseeVilleNaissance = _data["inseeVilleNaissance"];
            this.isEmailValide = _data["isEmailValide"];
            this.jourNaissance = _data["jourNaissance"];
            this.mesureProtectionJuridique = _data["mesureProtectionJuridique"];
            this.mesureProtectionJuridiqueLibelle = _data["mesureProtectionJuridiqueLibelle"];
            this.moisNaissance = _data["moisNaissance"];
            this.nationalite = _data["nationalite"];
            this.nationaliteLibelle = _data["nationaliteLibelle"];
            this.nom = _data["nom"];
            this.nomJeuneFille = _data["nomJeuneFille"];
            this.numero = _data["numero"];
            this.numeroClientA = _data["numeroClientA"];
            this.numeroClientB = _data["numeroClientB"];
            this.NIR = _data["NIR"];
            this.paysNaissance = _data["paysNaissance"];
            this.paysResidenceFiscaleId = _data["paysResidenceFiscaleId"];
            this.paysResidenceFiscaleLibelle = _data["paysResidenceFiscaleLibelle"];
            this.personneMorale = _data["personneMorale"];
            this.politiquementExposee = _data["politiquementExposee"];
            this.prenom = _data["prenom"];
            this.sexe = _data["sexe"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneProfessionnel = _data["telephoneProfessionnel"];
            this.titre = _data["titre"];
            this.type = _data["type"];
            this.villeNaissance = _data["villeNaissance"];
            this.associationClientId = _data["associationClientId"];
            this.associationPrincipale = _data["associationPrincipale"];
            this.lastConsultationDateByClient = _data["lastConsultationDateByClient"] ? new Date(_data["lastConsultationDateByClient"].toString()) : <any>undefined;
            this.typeClient = _data["typeClient"];
            this.adressePrincipale = _data["adressePrincipale"] ? AdressePrincipale.fromJS(_data["adressePrincipale"]) : <any>undefined;
            this.complement = _data["complement"] ? Complement.fromJS(_data["complement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIdentite {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdentite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>undefined;
        data["consultationUtilisateurId"] = this.consultationUtilisateurId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["creationUtilisateurId"] = this.creationUtilisateurId;
        data["desactivationDate"] = this.desactivationDate ? this.desactivationDate.toISOString() : <any>undefined;
        data["desactivationUtilisateurId"] = this.desactivationUtilisateurId;
        data["desactive"] = this.desactive;
        data["majDate"] = this.majDate ? this.majDate.toISOString() : <any>undefined;
        data["majUtilisateurId"] = this.majUtilisateurId;
        data["anneeNaissance"] = this.anneeNaissance;
        data["autresPrenoms"] = this.autresPrenoms;
        data["codeCommuneNaissance"] = this.codeCommuneNaissance;
        data["codePostalNaissance"] = this.codePostalNaissance;
        data["commentaire"] = this.commentaire;
        data["contribuableAmericain"] = this.contribuableAmericain;
        data["dateDeces"] = this.dateDeces ? this.dateDeces.toISOString() : <any>undefined;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["departementNaissance"] = this.departementNaissance;
        data["email"] = this.email;
        data["fonctionPPE"] = this.fonctionPPE;
        data["fonctionPPELibelle"] = this.fonctionPPELibelle;
        data["motifPPE"] = this.motifPPE;
        data["motifPPELibelle"] = this.motifPPELibelle;
        data["inseeVilleNaissance"] = this.inseeVilleNaissance;
        data["isEmailValide"] = this.isEmailValide;
        data["jourNaissance"] = this.jourNaissance;
        data["mesureProtectionJuridique"] = this.mesureProtectionJuridique;
        data["mesureProtectionJuridiqueLibelle"] = this.mesureProtectionJuridiqueLibelle;
        data["moisNaissance"] = this.moisNaissance;
        data["nationalite"] = this.nationalite;
        data["nationaliteLibelle"] = this.nationaliteLibelle;
        data["nom"] = this.nom;
        data["nomJeuneFille"] = this.nomJeuneFille;
        data["numero"] = this.numero;
        data["numeroClientA"] = this.numeroClientA;
        data["numeroClientB"] = this.numeroClientB;
        data["NIR"] = this.NIR;
        data["paysNaissance"] = this.paysNaissance;
        data["paysResidenceFiscaleId"] = this.paysResidenceFiscaleId;
        data["paysResidenceFiscaleLibelle"] = this.paysResidenceFiscaleLibelle;
        data["personneMorale"] = this.personneMorale;
        data["politiquementExposee"] = this.politiquementExposee;
        data["prenom"] = this.prenom;
        data["sexe"] = this.sexe;
        data["telephoneFixe"] = this.telephoneFixe;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneProfessionnel"] = this.telephoneProfessionnel;
        data["titre"] = this.titre;
        data["type"] = this.type;
        data["villeNaissance"] = this.villeNaissance;
        data["associationClientId"] = this.associationClientId;
        data["associationPrincipale"] = this.associationPrincipale;
        data["lastConsultationDateByClient"] = this.lastConsultationDateByClient ? this.lastConsultationDateByClient.toISOString() : <any>undefined;
        data["typeClient"] = this.typeClient;
        data["adressePrincipale"] = this.adressePrincipale ? this.adressePrincipale.toJSON() : <any>undefined;
        data["complement"] = this.complement ? this.complement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIdentite {
    id?: string | undefined;
    consultationDate?: Date;
    consultationUtilisateurId?: string | undefined;
    creationDate?: Date;
    creationUtilisateurId?: string | undefined;
    desactivationDate?: Date;
    desactivationUtilisateurId?: string | undefined;
    desactive?: boolean;
    majDate?: Date;
    majUtilisateurId?: string | undefined;
    anneeNaissance?: number;
    autresPrenoms?: string | undefined;
    codeCommuneNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    commentaire?: string | undefined;
    contribuableAmericain?: boolean;
    dateDeces?: Date;
    dateNaissance?: Date;
    departementNaissance?: string | undefined;
    email?: string | undefined;
    fonctionPPE?: number;
    fonctionPPELibelle?: string | undefined;
    motifPPE?: number;
    motifPPELibelle?: string | undefined;
    inseeVilleNaissance?: string | undefined;
    isEmailValide?: boolean;
    jourNaissance?: number;
    mesureProtectionJuridique?: number;
    mesureProtectionJuridiqueLibelle?: string | undefined;
    moisNaissance?: number;
    nationalite?: number;
    nationaliteLibelle?: string | undefined;
    nom?: string | undefined;
    nomJeuneFille?: string | undefined;
    numero?: string | undefined;
    numeroClientA?: string | undefined;
    numeroClientB?: string | undefined;
    NIR?: string | undefined;
    paysNaissance?: string | undefined;
    paysResidenceFiscaleId?: number;
    paysResidenceFiscaleLibelle?: string | undefined;
    personneMorale?: boolean;
    politiquementExposee?: boolean;
    prenom?: string | undefined;
    sexe?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    titre?: string | undefined;
    type?: string | undefined;
    villeNaissance?: string | undefined;
    associationClientId?: number;
    associationPrincipale?: boolean;
    lastConsultationDateByClient?: Date;
    typeClient?: string | undefined;
    adressePrincipale?: AdressePrincipale;
    complement?: Complement;
}

export class GetMotifsCSPRequest implements IGetMotifsCSPRequest {

    constructor(data?: IGetMotifsCSPRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetMotifsCSPRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsCSPRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetMotifsCSPRequest {
}

export class GetMotifsCSPResponse implements IGetMotifsCSPResponse {
    CSP?: CSP[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetMotifsCSPResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["CSP"])) {
                this.CSP = [] as any;
                for (let item of _data["CSP"])
                    this.CSP!.push(CSP.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMotifsCSPResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsCSPResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.CSP)) {
            data["CSP"] = [];
            for (let item of this.CSP)
                data["CSP"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMotifsCSPResponse {
    CSP?: CSP[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class GetMotifsPPERequest implements IGetMotifsPPERequest {

    constructor(data?: IGetMotifsPPERequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetMotifsPPERequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsPPERequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetMotifsPPERequest {
}

export class GetMotifsPPEResponse implements IGetMotifsPPEResponse {
    motifs?: Motifs[] | undefined;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IGetMotifsPPEResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["motifs"])) {
                this.motifs = [] as any;
                for (let item of _data["motifs"])
                    this.motifs!.push(Motifs.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMotifsPPEResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMotifsPPEResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.motifs)) {
            data["motifs"] = [];
            for (let item of this.motifs)
                data["motifs"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMotifsPPEResponse {
    motifs?: Motifs[] | undefined;
    erreurs?: Erreur[] | undefined;
}

export class Informations implements IInformations {
    id?: number;
    actif?: boolean;
    code?: string | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: IInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.code = _data["code"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Informations {
        data = typeof data === 'object' ? data : {};
        let result = new Informations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["code"] = this.code;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IInformations {
    id?: number;
    actif?: boolean;
    code?: string | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class Motifs implements IMotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    sousmotifs?: Sousmotifs[] | undefined;

    constructor(data?: IMotifs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
            if (Array.isArray(_data["sousmotifs"])) {
                this.sousmotifs = [] as any;
                for (let item of _data["sousmotifs"])
                    this.sousmotifs!.push(Sousmotifs.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Motifs {
        data = typeof data === 'object' ? data : {};
        let result = new Motifs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        if (Array.isArray(this.sousmotifs)) {
            data["sousmotifs"] = [];
            for (let item of this.sousmotifs)
                data["sousmotifs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
    sousmotifs?: Sousmotifs[] | undefined;
}

export class Pays implements IPays {
    id?: number;
    langFR?: string | undefined;
    alpha2?: string | undefined;
    alpha3?: string | undefined;

    constructor(data?: IPays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.langFR = _data["langFR"];
            this.alpha2 = _data["alpha2"];
            this.alpha3 = _data["alpha3"];
        }
    }

    static fromJS(data: any): Pays {
        data = typeof data === 'object' ? data : {};
        let result = new Pays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["langFR"] = this.langFR;
        data["alpha2"] = this.alpha2;
        data["alpha3"] = this.alpha3;
        return data;
    }
}

export interface IPays {
    id?: number;
    langFR?: string | undefined;
    alpha2?: string | undefined;
    alpha3?: string | undefined;
}

export class Professions implements IProfessions {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: IProfessions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Professions {
        data = typeof data === 'object' ? data : {};
        let result = new Professions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IProfessions {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class ProspectToClientRequest implements IProspectToClientRequest {
    idPersonne?: string | undefined;

    constructor(data?: IProspectToClientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPersonne = _data["idPersonne"];
        }
    }

    static fromJS(data: any): ProspectToClientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectToClientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPersonne"] = this.idPersonne;
        return data;
    }
}

export interface IProspectToClientRequest {
    idPersonne?: string | undefined;
}

export class ProspetToClientResponse implements IProspetToClientResponse {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: number;
    erreurs?: Erreur[] | undefined;

    constructor(data?: IProspetToClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientExterne = _data["numeroClientExterne"];
            this.numeroClientInterne = _data["numeroClientInterne"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProspetToClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProspetToClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientExterne"] = this.numeroClientExterne;
        data["numeroClientInterne"] = this.numeroClientInterne;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProspetToClientResponse {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: number;
    erreurs?: Erreur[] | undefined;
}

export class Relation implements IRelation {
    numeroSocietaireInterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    idTypeRelation?: number;
    libelleTypeRelation?: string | undefined;

    constructor(data?: IRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.idTypeRelation = _data["idTypeRelation"];
            this.libelleTypeRelation = _data["libelleTypeRelation"];
        }
    }

    static fromJS(data: any): Relation {
        data = typeof data === 'object' ? data : {};
        let result = new Relation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["idTypeRelation"] = this.idTypeRelation;
        data["libelleTypeRelation"] = this.libelleTypeRelation;
        return data;
    }
}

export interface IRelation {
    numeroSocietaireInterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    idTypeRelation?: number;
    libelleTypeRelation?: string | undefined;
}

export class Sousmotifs implements ISousmotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISousmotifs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actif = _data["actif"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.technicalId = _data["technicalId"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Sousmotifs {
        data = typeof data === 'object' ? data : {};
        let result = new Sousmotifs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actif"] = this.actif;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["technicalId"] = this.technicalId;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ISousmotifs {
    id?: number;
    actif?: boolean;
    libelle?: string | undefined;
    ordre?: number;
    technicalId?: string | undefined;
    type?: string | undefined;
    value?: string | undefined;
}

export class Warning implements IWarning {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning {
        data = typeof data === 'object' ? data : {};
        let result = new Warning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class CompositionPatrimoines2 implements ICompositionPatrimoines2 {
    id?: number;

    constructor(data?: ICompositionPatrimoines2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompositionPatrimoines2 {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionPatrimoines2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICompositionPatrimoines2 {
    id?: number;
}

export class CompositionPatrimoines22 implements ICompositionPatrimoines22 {
    id?: number;

    constructor(data?: ICompositionPatrimoines22) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompositionPatrimoines22 {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionPatrimoines22();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICompositionPatrimoines22 {
    id?: number;
}

export class CreationIdentiteRequest implements ICreationIdentiteRequest {
    identite?: Identite;

    constructor(data?: ICreationIdentiteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identite = _data["identite"] ? Identite.fromJS(_data["identite"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreationIdentiteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreationIdentiteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identite"] = this.identite ? this.identite.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreationIdentiteRequest {
    identite?: Identite;
}

export class CreationIdentiteResponse implements ICreationIdentiteResponse {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: string | undefined;
    idPersonne?: string | undefined;
    erreurs?: Erreur2[] | undefined;

    constructor(data?: ICreationIdentiteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroClientExterne = _data["numeroClientExterne"];
            this.numeroClientInterne = _data["numeroClientInterne"];
            this.idPersonne = _data["idPersonne"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreationIdentiteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreationIdentiteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroClientExterne"] = this.numeroClientExterne;
        data["numeroClientInterne"] = this.numeroClientInterne;
        data["idPersonne"] = this.idPersonne;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreationIdentiteResponse {
    numeroClientExterne?: string | undefined;
    numeroClientInterne?: string | undefined;
    idPersonne?: string | undefined;
    erreurs?: Erreur2[] | undefined;
}

export class Erreur2 implements IErreur2 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur2 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur2 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetIBANInformations implements IGetIBANInformations {
    idGED?: number | undefined;
    IBAN?: string | undefined;
    codeTypeDocumentGED?: string | undefined;

    constructor(data?: IGetIBANInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idGED = _data["idGED"];
            this.IBAN = _data["IBAN"];
            this.codeTypeDocumentGED = _data["codeTypeDocumentGED"];
        }
    }

    static fromJS(data: any): GetIBANInformations {
        data = typeof data === 'object' ? data : {};
        let result = new GetIBANInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idGED"] = this.idGED;
        data["IBAN"] = this.IBAN;
        data["codeTypeDocumentGED"] = this.codeTypeDocumentGED;
        return data;
    }
}

export interface IGetIBANInformations {
    idGED?: number | undefined;
    IBAN?: string | undefined;
    codeTypeDocumentGED?: string | undefined;
}

export class GetIBANRequest implements IGetIBANRequest {
    noSocietaireInterne?: number | undefined;
    idDemarche?: number | undefined;
    codeTypeDocumentGED?: string | undefined;

    constructor(data?: IGetIBANRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.idDemarche = _data["idDemarche"];
            this.codeTypeDocumentGED = _data["codeTypeDocumentGED"];
        }
    }

    static fromJS(data: any): GetIBANRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetIBANRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["idDemarche"] = this.idDemarche;
        data["codeTypeDocumentGED"] = this.codeTypeDocumentGED;
        return data;
    }
}

export interface IGetIBANRequest {
    noSocietaireInterne?: number | undefined;
    idDemarche?: number | undefined;
    codeTypeDocumentGED?: string | undefined;
}

export class GetIBANResponse implements IGetIBANResponse {
    typeDocumentGED?: GetIBANInformations[] | undefined;
    erreurs?: Erreur2[] | undefined;
    warnings?: Warning2[] | undefined;

    constructor(data?: IGetIBANResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["typeDocumentGED"])) {
                this.typeDocumentGED = [] as any;
                for (let item of _data["typeDocumentGED"])
                    this.typeDocumentGED!.push(GetIBANInformations.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIBANResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetIBANResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.typeDocumentGED)) {
            data["typeDocumentGED"] = [];
            for (let item of this.typeDocumentGED)
                data["typeDocumentGED"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIBANResponse {
    typeDocumentGED?: GetIBANInformations[] | undefined;
    erreurs?: Erreur2[] | undefined;
    warnings?: Warning2[] | undefined;
}

export class GetScoringRequest implements IGetScoringRequest {
    noIdentiteInterne?: number;

    constructor(data?: IGetScoringRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noIdentiteInterne = _data["noIdentiteInterne"];
        }
    }

    static fromJS(data: any): GetScoringRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoringRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noIdentiteInterne"] = this.noIdentiteInterne;
        return data;
    }
}

export interface IGetScoringRequest {
    noIdentiteInterne?: number;
}

export class GetScoringResponse implements IGetScoringResponse {
    note?: number | undefined;
    erreurs?: Erreur2[] | undefined;

    constructor(data?: IGetScoringResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetScoringResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetScoringResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetScoringResponse {
    note?: number | undefined;
    erreurs?: Erreur2[] | undefined;
}

export class Identite implements IIdentite {
    autresPrenoms?: string | undefined;
    nomJeuneFille?: string | undefined;
    paysNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    villeNaissance?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    nomVille?: string | undefined;
    codeCommune?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    situationFamiliale?: number;
    nbEnfantsMoins16Ans?: number;
    nbEnfants16AnsOuPlus?: number;
    nbEnfantsACharge?: number;
    typeMatricule?: string | undefined;
    matricule?: string | undefined;
    statutSncf?: string | undefined;
    situationProfessionnelle?: number;
    situationFinanciere?: number;
    revenuFiscal?: string | undefined;
    situationPatrimoniale?: number;
    autreContrat?: boolean;
    motifSouscription?: number;
    secteurActivite?: number;
    sollicitationEmail?: boolean;
    sollicitationCourrier?: boolean;
    sollicitationSMS?: boolean;
    sollicitationPartenaire?: boolean;
    abonnePerformance?: boolean;
    abonneActualite?: boolean;
    stopPublicite?: boolean;
    politiquementExposee?: boolean;
    paysResidenceFiscaleCode?: string | undefined;
    regimeMatrimonial?: number;
    compositionPatrimoineAutres?: string | undefined;
    compositionPatrimoines?: CompositionPatrimoines2[] | undefined;
    revenuMensuelNetFoyer?: number;
    contribuableAmericain?: boolean;
    fonctionPPE?: number;
    motifPPE?: number;
    type?: string | undefined;
    titre?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    nationalite?: number;
    dateNaissance?: Date;
    codePostal?: string | undefined;
    voie?: string | undefined;
    pays?: string | undefined;
    profession?: number;
    CSP?: number;
    BP?: boolean;
    extranetActif?: boolean;
    origineMarketing?: string | undefined;
    qualite?: number;
    profilPartenaire?: boolean;
    SIRET?: string | undefined;
    NIR?: string | undefined;
    mesureProtectionJuridique?: number;

    constructor(data?: IIdentite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autresPrenoms = _data["autresPrenoms"];
            this.nomJeuneFille = _data["nomJeuneFille"];
            this.paysNaissance = _data["paysNaissance"];
            this.departementNaissance = _data["departementNaissance"];
            this.codePostalNaissance = _data["codePostalNaissance"];
            this.villeNaissance = _data["villeNaissance"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneProfessionnel = _data["telephoneProfessionnel"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.nomVille = _data["nomVille"];
            this.codeCommune = _data["codeCommune"];
            this.complement = _data["complement"];
            this.complement2 = _data["complement2"];
            this.lieudit = _data["lieudit"];
            this.situationFamiliale = _data["situationFamiliale"];
            this.nbEnfantsMoins16Ans = _data["nbEnfantsMoins16Ans"];
            this.nbEnfants16AnsOuPlus = _data["nbEnfants16AnsOuPlus"];
            this.nbEnfantsACharge = _data["nbEnfantsACharge"];
            this.typeMatricule = _data["typeMatricule"];
            this.matricule = _data["matricule"];
            this.statutSncf = _data["statutSncf"];
            this.situationProfessionnelle = _data["situationProfessionnelle"];
            this.situationFinanciere = _data["situationFinanciere"];
            this.revenuFiscal = _data["revenuFiscal"];
            this.situationPatrimoniale = _data["situationPatrimoniale"];
            this.autreContrat = _data["autreContrat"];
            this.motifSouscription = _data["motifSouscription"];
            this.secteurActivite = _data["secteurActivite"];
            this.sollicitationEmail = _data["sollicitationEmail"];
            this.sollicitationCourrier = _data["sollicitationCourrier"];
            this.sollicitationSMS = _data["sollicitationSMS"];
            this.sollicitationPartenaire = _data["sollicitationPartenaire"];
            this.abonnePerformance = _data["abonnePerformance"];
            this.abonneActualite = _data["abonneActualite"];
            this.stopPublicite = _data["stopPublicite"];
            this.politiquementExposee = _data["politiquementExposee"];
            this.paysResidenceFiscaleCode = _data["paysResidenceFiscaleCode"];
            this.regimeMatrimonial = _data["regimeMatrimonial"];
            this.compositionPatrimoineAutres = _data["compositionPatrimoineAutres"];
            if (Array.isArray(_data["compositionPatrimoines"])) {
                this.compositionPatrimoines = [] as any;
                for (let item of _data["compositionPatrimoines"])
                    this.compositionPatrimoines!.push(CompositionPatrimoines2.fromJS(item));
            }
            this.revenuMensuelNetFoyer = _data["revenuMensuelNetFoyer"];
            this.contribuableAmericain = _data["contribuableAmericain"];
            this.fonctionPPE = _data["fonctionPPE"];
            this.motifPPE = _data["motifPPE"];
            this.type = _data["type"];
            this.titre = _data["titre"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.nationalite = _data["nationalite"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.codePostal = _data["codePostal"];
            this.voie = _data["voie"];
            this.pays = _data["pays"];
            this.profession = _data["profession"];
            this.CSP = _data["CSP"];
            this.BP = _data["BP"];
            this.extranetActif = _data["extranetActif"];
            this.origineMarketing = _data["origineMarketing"];
            this.qualite = _data["qualite"];
            this.profilPartenaire = _data["profilPartenaire"];
            this.SIRET = _data["SIRET"];
            this.NIR = _data["NIR"];
            this.mesureProtectionJuridique = _data["mesureProtectionJuridique"];
        }
    }

    static fromJS(data: any): Identite {
        data = typeof data === 'object' ? data : {};
        let result = new Identite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autresPrenoms"] = this.autresPrenoms;
        data["nomJeuneFille"] = this.nomJeuneFille;
        data["paysNaissance"] = this.paysNaissance;
        data["departementNaissance"] = this.departementNaissance;
        data["codePostalNaissance"] = this.codePostalNaissance;
        data["villeNaissance"] = this.villeNaissance;
        data["telephoneFixe"] = this.telephoneFixe;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneProfessionnel"] = this.telephoneProfessionnel;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["nomVille"] = this.nomVille;
        data["codeCommune"] = this.codeCommune;
        data["complement"] = this.complement;
        data["complement2"] = this.complement2;
        data["lieudit"] = this.lieudit;
        data["situationFamiliale"] = this.situationFamiliale;
        data["nbEnfantsMoins16Ans"] = this.nbEnfantsMoins16Ans;
        data["nbEnfants16AnsOuPlus"] = this.nbEnfants16AnsOuPlus;
        data["nbEnfantsACharge"] = this.nbEnfantsACharge;
        data["typeMatricule"] = this.typeMatricule;
        data["matricule"] = this.matricule;
        data["statutSncf"] = this.statutSncf;
        data["situationProfessionnelle"] = this.situationProfessionnelle;
        data["situationFinanciere"] = this.situationFinanciere;
        data["revenuFiscal"] = this.revenuFiscal;
        data["situationPatrimoniale"] = this.situationPatrimoniale;
        data["autreContrat"] = this.autreContrat;
        data["motifSouscription"] = this.motifSouscription;
        data["secteurActivite"] = this.secteurActivite;
        data["sollicitationEmail"] = this.sollicitationEmail;
        data["sollicitationCourrier"] = this.sollicitationCourrier;
        data["sollicitationSMS"] = this.sollicitationSMS;
        data["sollicitationPartenaire"] = this.sollicitationPartenaire;
        data["abonnePerformance"] = this.abonnePerformance;
        data["abonneActualite"] = this.abonneActualite;
        data["stopPublicite"] = this.stopPublicite;
        data["politiquementExposee"] = this.politiquementExposee;
        data["paysResidenceFiscaleCode"] = this.paysResidenceFiscaleCode;
        data["regimeMatrimonial"] = this.regimeMatrimonial;
        data["compositionPatrimoineAutres"] = this.compositionPatrimoineAutres;
        if (Array.isArray(this.compositionPatrimoines)) {
            data["compositionPatrimoines"] = [];
            for (let item of this.compositionPatrimoines)
                data["compositionPatrimoines"].push(item.toJSON());
        }
        data["revenuMensuelNetFoyer"] = this.revenuMensuelNetFoyer;
        data["contribuableAmericain"] = this.contribuableAmericain;
        data["fonctionPPE"] = this.fonctionPPE;
        data["motifPPE"] = this.motifPPE;
        data["type"] = this.type;
        data["titre"] = this.titre;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["nationalite"] = this.nationalite;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["codePostal"] = this.codePostal;
        data["voie"] = this.voie;
        data["pays"] = this.pays;
        data["profession"] = this.profession;
        data["CSP"] = this.CSP;
        data["BP"] = this.BP;
        data["extranetActif"] = this.extranetActif;
        data["origineMarketing"] = this.origineMarketing;
        data["qualite"] = this.qualite;
        data["profilPartenaire"] = this.profilPartenaire;
        data["SIRET"] = this.SIRET;
        data["NIR"] = this.NIR;
        data["mesureProtectionJuridique"] = this.mesureProtectionJuridique;
        return data;
    }
}

export interface IIdentite {
    autresPrenoms?: string | undefined;
    nomJeuneFille?: string | undefined;
    paysNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    villeNaissance?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    nomVille?: string | undefined;
    codeCommune?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    situationFamiliale?: number;
    nbEnfantsMoins16Ans?: number;
    nbEnfants16AnsOuPlus?: number;
    nbEnfantsACharge?: number;
    typeMatricule?: string | undefined;
    matricule?: string | undefined;
    statutSncf?: string | undefined;
    situationProfessionnelle?: number;
    situationFinanciere?: number;
    revenuFiscal?: string | undefined;
    situationPatrimoniale?: number;
    autreContrat?: boolean;
    motifSouscription?: number;
    secteurActivite?: number;
    sollicitationEmail?: boolean;
    sollicitationCourrier?: boolean;
    sollicitationSMS?: boolean;
    sollicitationPartenaire?: boolean;
    abonnePerformance?: boolean;
    abonneActualite?: boolean;
    stopPublicite?: boolean;
    politiquementExposee?: boolean;
    paysResidenceFiscaleCode?: string | undefined;
    regimeMatrimonial?: number;
    compositionPatrimoineAutres?: string | undefined;
    compositionPatrimoines?: CompositionPatrimoines2[] | undefined;
    revenuMensuelNetFoyer?: number;
    contribuableAmericain?: boolean;
    fonctionPPE?: number;
    motifPPE?: number;
    type?: string | undefined;
    titre?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    nationalite?: number;
    dateNaissance?: Date;
    codePostal?: string | undefined;
    voie?: string | undefined;
    pays?: string | undefined;
    profession?: number;
    CSP?: number;
    BP?: boolean;
    extranetActif?: boolean;
    origineMarketing?: string | undefined;
    qualite?: number;
    profilPartenaire?: boolean;
    SIRET?: string | undefined;
    NIR?: string | undefined;
    mesureProtectionJuridique?: number;
}

export class IdentiteForUpdate implements IIdentiteForUpdate {
    autresPrenoms?: string | undefined;
    nomJeuneFille?: string | undefined;
    paysNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    villeNaissance?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    nomVille?: string | undefined;
    codeCommune?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    situationFamiliale?: number;
    nbEnfantsMoins16Ans?: number;
    nbEnfants16AnsOuPlus?: number;
    nbEnfantsACharge?: number;
    typeMatricule?: string | undefined;
    matricule?: string | undefined;
    statutSncf?: string | undefined;
    situationProfessionnelle?: number;
    situationFinanciere?: number;
    revenuFiscal?: string | undefined;
    situationPatrimoniale?: number;
    autreContrat?: boolean;
    motifSouscription?: number;
    secteurActivite?: number;
    sollicitationEmail?: boolean;
    sollicitationCourrier?: boolean;
    sollicitationSMS?: boolean;
    sollicitationPartenaire?: boolean;
    abonnePerformance?: boolean;
    abonneActualite?: boolean;
    stopPublicite?: boolean;
    politiquementExposee?: boolean;
    paysResidenceFiscaleCode?: string | undefined;
    regimeMatrimonial?: number;
    canalPrefereNotificationOperation?: number | undefined;
    canalPrefereMifInfo?: number | undefined;
    compositionPatrimoineAutres?: string | undefined;
    compositionPatrimoines?: CompositionPatrimoines22[] | undefined;
    revenuMensuelNetFoyer?: number;
    contribuableAmericain?: boolean;
    fonctionPPE?: number;
    motifPPE?: number;
    type?: string | undefined;
    titre?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    nationalite?: number;
    dateNaissance?: Date;
    codePostal?: string | undefined;
    voie?: string | undefined;
    pays?: string | undefined;
    profession?: number;
    CSP?: number;
    numeroCRM?: string | undefined;
    BP?: boolean;
    extranetActif?: boolean;
    dateDerniereConnexionExtranet?: Date;
    origineMarketing?: string | undefined;
    qualite?: number;
    profilPartenaire?: string | undefined;
    SIRET?: string | undefined;
    NIR?: string | undefined;
    mesureProtectionJuridique?: number;

    constructor(data?: IIdentiteForUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autresPrenoms = _data["autresPrenoms"];
            this.nomJeuneFille = _data["nomJeuneFille"];
            this.paysNaissance = _data["paysNaissance"];
            this.departementNaissance = _data["departementNaissance"];
            this.codePostalNaissance = _data["codePostalNaissance"];
            this.villeNaissance = _data["villeNaissance"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneProfessionnel = _data["telephoneProfessionnel"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.nomVille = _data["nomVille"];
            this.codeCommune = _data["codeCommune"];
            this.complement = _data["complement"];
            this.complement2 = _data["complement2"];
            this.lieudit = _data["lieudit"];
            this.situationFamiliale = _data["situationFamiliale"];
            this.nbEnfantsMoins16Ans = _data["nbEnfantsMoins16Ans"];
            this.nbEnfants16AnsOuPlus = _data["nbEnfants16AnsOuPlus"];
            this.nbEnfantsACharge = _data["nbEnfantsACharge"];
            this.typeMatricule = _data["typeMatricule"];
            this.matricule = _data["matricule"];
            this.statutSncf = _data["statutSncf"];
            this.situationProfessionnelle = _data["situationProfessionnelle"];
            this.situationFinanciere = _data["situationFinanciere"];
            this.revenuFiscal = _data["revenuFiscal"];
            this.situationPatrimoniale = _data["situationPatrimoniale"];
            this.autreContrat = _data["autreContrat"];
            this.motifSouscription = _data["motifSouscription"];
            this.secteurActivite = _data["secteurActivite"];
            this.sollicitationEmail = _data["sollicitationEmail"];
            this.sollicitationCourrier = _data["sollicitationCourrier"];
            this.sollicitationSMS = _data["sollicitationSMS"];
            this.sollicitationPartenaire = _data["sollicitationPartenaire"];
            this.abonnePerformance = _data["abonnePerformance"];
            this.abonneActualite = _data["abonneActualite"];
            this.stopPublicite = _data["stopPublicite"];
            this.politiquementExposee = _data["politiquementExposee"];
            this.paysResidenceFiscaleCode = _data["paysResidenceFiscaleCode"];
            this.regimeMatrimonial = _data["regimeMatrimonial"];
            this.canalPrefereNotificationOperation = _data["canalPrefereNotificationOperation"];
            this.canalPrefereMifInfo = _data["canalPrefereMifInfo"];
            this.compositionPatrimoineAutres = _data["compositionPatrimoineAutres"];
            if (Array.isArray(_data["compositionPatrimoines"])) {
                this.compositionPatrimoines = [] as any;
                for (let item of _data["compositionPatrimoines"])
                    this.compositionPatrimoines!.push(CompositionPatrimoines22.fromJS(item));
            }
            this.revenuMensuelNetFoyer = _data["revenuMensuelNetFoyer"];
            this.contribuableAmericain = _data["contribuableAmericain"];
            this.fonctionPPE = _data["fonctionPPE"];
            this.motifPPE = _data["motifPPE"];
            this.type = _data["type"];
            this.titre = _data["titre"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.nationalite = _data["nationalite"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.codePostal = _data["codePostal"];
            this.voie = _data["voie"];
            this.pays = _data["pays"];
            this.profession = _data["profession"];
            this.CSP = _data["CSP"];
            this.numeroCRM = _data["numeroCRM"];
            this.BP = _data["BP"];
            this.extranetActif = _data["extranetActif"];
            this.dateDerniereConnexionExtranet = _data["dateDerniereConnexionExtranet"] ? new Date(_data["dateDerniereConnexionExtranet"].toString()) : <any>undefined;
            this.origineMarketing = _data["origineMarketing"];
            this.qualite = _data["qualite"];
            this.profilPartenaire = _data["profilPartenaire"];
            this.SIRET = _data["SIRET"];
            this.NIR = _data["NIR"];
            this.mesureProtectionJuridique = _data["mesureProtectionJuridique"];
        }
    }

    static fromJS(data: any): IdentiteForUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new IdentiteForUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autresPrenoms"] = this.autresPrenoms;
        data["nomJeuneFille"] = this.nomJeuneFille;
        data["paysNaissance"] = this.paysNaissance;
        data["departementNaissance"] = this.departementNaissance;
        data["codePostalNaissance"] = this.codePostalNaissance;
        data["villeNaissance"] = this.villeNaissance;
        data["telephoneFixe"] = this.telephoneFixe;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneProfessionnel"] = this.telephoneProfessionnel;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["nomVille"] = this.nomVille;
        data["codeCommune"] = this.codeCommune;
        data["complement"] = this.complement;
        data["complement2"] = this.complement2;
        data["lieudit"] = this.lieudit;
        data["situationFamiliale"] = this.situationFamiliale;
        data["nbEnfantsMoins16Ans"] = this.nbEnfantsMoins16Ans;
        data["nbEnfants16AnsOuPlus"] = this.nbEnfants16AnsOuPlus;
        data["nbEnfantsACharge"] = this.nbEnfantsACharge;
        data["typeMatricule"] = this.typeMatricule;
        data["matricule"] = this.matricule;
        data["statutSncf"] = this.statutSncf;
        data["situationProfessionnelle"] = this.situationProfessionnelle;
        data["situationFinanciere"] = this.situationFinanciere;
        data["revenuFiscal"] = this.revenuFiscal;
        data["situationPatrimoniale"] = this.situationPatrimoniale;
        data["autreContrat"] = this.autreContrat;
        data["motifSouscription"] = this.motifSouscription;
        data["secteurActivite"] = this.secteurActivite;
        data["sollicitationEmail"] = this.sollicitationEmail;
        data["sollicitationCourrier"] = this.sollicitationCourrier;
        data["sollicitationSMS"] = this.sollicitationSMS;
        data["sollicitationPartenaire"] = this.sollicitationPartenaire;
        data["abonnePerformance"] = this.abonnePerformance;
        data["abonneActualite"] = this.abonneActualite;
        data["stopPublicite"] = this.stopPublicite;
        data["politiquementExposee"] = this.politiquementExposee;
        data["paysResidenceFiscaleCode"] = this.paysResidenceFiscaleCode;
        data["regimeMatrimonial"] = this.regimeMatrimonial;
        data["canalPrefereNotificationOperation"] = this.canalPrefereNotificationOperation;
        data["canalPrefereMifInfo"] = this.canalPrefereMifInfo;
        data["compositionPatrimoineAutres"] = this.compositionPatrimoineAutres;
        if (Array.isArray(this.compositionPatrimoines)) {
            data["compositionPatrimoines"] = [];
            for (let item of this.compositionPatrimoines)
                data["compositionPatrimoines"].push(item.toJSON());
        }
        data["revenuMensuelNetFoyer"] = this.revenuMensuelNetFoyer;
        data["contribuableAmericain"] = this.contribuableAmericain;
        data["fonctionPPE"] = this.fonctionPPE;
        data["motifPPE"] = this.motifPPE;
        data["type"] = this.type;
        data["titre"] = this.titre;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["nationalite"] = this.nationalite;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["codePostal"] = this.codePostal;
        data["voie"] = this.voie;
        data["pays"] = this.pays;
        data["profession"] = this.profession;
        data["CSP"] = this.CSP;
        data["numeroCRM"] = this.numeroCRM;
        data["BP"] = this.BP;
        data["extranetActif"] = this.extranetActif;
        data["dateDerniereConnexionExtranet"] = this.dateDerniereConnexionExtranet ? this.dateDerniereConnexionExtranet.toISOString() : <any>undefined;
        data["origineMarketing"] = this.origineMarketing;
        data["qualite"] = this.qualite;
        data["profilPartenaire"] = this.profilPartenaire;
        data["SIRET"] = this.SIRET;
        data["NIR"] = this.NIR;
        data["mesureProtectionJuridique"] = this.mesureProtectionJuridique;
        return data;
    }
}

export interface IIdentiteForUpdate {
    autresPrenoms?: string | undefined;
    nomJeuneFille?: string | undefined;
    paysNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    villeNaissance?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    nomVille?: string | undefined;
    codeCommune?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    situationFamiliale?: number;
    nbEnfantsMoins16Ans?: number;
    nbEnfants16AnsOuPlus?: number;
    nbEnfantsACharge?: number;
    typeMatricule?: string | undefined;
    matricule?: string | undefined;
    statutSncf?: string | undefined;
    situationProfessionnelle?: number;
    situationFinanciere?: number;
    revenuFiscal?: string | undefined;
    situationPatrimoniale?: number;
    autreContrat?: boolean;
    motifSouscription?: number;
    secteurActivite?: number;
    sollicitationEmail?: boolean;
    sollicitationCourrier?: boolean;
    sollicitationSMS?: boolean;
    sollicitationPartenaire?: boolean;
    abonnePerformance?: boolean;
    abonneActualite?: boolean;
    stopPublicite?: boolean;
    politiquementExposee?: boolean;
    paysResidenceFiscaleCode?: string | undefined;
    regimeMatrimonial?: number;
    canalPrefereNotificationOperation?: number | undefined;
    canalPrefereMifInfo?: number | undefined;
    compositionPatrimoineAutres?: string | undefined;
    compositionPatrimoines?: CompositionPatrimoines22[] | undefined;
    revenuMensuelNetFoyer?: number;
    contribuableAmericain?: boolean;
    fonctionPPE?: number;
    motifPPE?: number;
    type?: string | undefined;
    titre?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    nationalite?: number;
    dateNaissance?: Date;
    codePostal?: string | undefined;
    voie?: string | undefined;
    pays?: string | undefined;
    profession?: number;
    CSP?: number;
    numeroCRM?: string | undefined;
    BP?: boolean;
    extranetActif?: boolean;
    dateDerniereConnexionExtranet?: Date;
    origineMarketing?: string | undefined;
    qualite?: number;
    profilPartenaire?: string | undefined;
    SIRET?: string | undefined;
    NIR?: string | undefined;
    mesureProtectionJuridique?: number;
}

export class ModificationIdentiteRequest implements IModificationIdentiteRequest {
    identiteForUpdate?: IdentiteForUpdate;

    constructor(data?: IModificationIdentiteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identiteForUpdate = _data["identiteForUpdate"] ? IdentiteForUpdate.fromJS(_data["identiteForUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ModificationIdentiteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ModificationIdentiteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identiteForUpdate"] = this.identiteForUpdate ? this.identiteForUpdate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IModificationIdentiteRequest {
    identiteForUpdate?: IdentiteForUpdate;
}

export class ModificationIdentiteResponse implements IModificationIdentiteResponse {
    erreurs?: Erreur2[] | undefined;

    constructor(data?: IModificationIdentiteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModificationIdentiteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModificationIdentiteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModificationIdentiteResponse {
    erreurs?: Erreur2[] | undefined;
}

export class Warning2 implements IWarning2 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning2 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning2 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class CreationAbandonSouscriptionRequest implements ICreationAbandonSouscriptionRequest {
    numeroCRM?: string | undefined;
    origineSouscription?: number;
    idTypeProduit?: number;
    idProduit?: number;
    etape?: string | undefined;
    origineMarketing?: string | undefined;
    urlRepriseParcours?: string | undefined;
    dateAbandon?: Date;

    constructor(data?: ICreationAbandonSouscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroCRM = _data["numeroCRM"];
            this.origineSouscription = _data["origineSouscription"];
            this.idTypeProduit = _data["idTypeProduit"];
            this.idProduit = _data["idProduit"];
            this.etape = _data["etape"];
            this.origineMarketing = _data["origineMarketing"];
            this.urlRepriseParcours = _data["urlRepriseParcours"];
            this.dateAbandon = _data["dateAbandon"] ? new Date(_data["dateAbandon"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreationAbandonSouscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreationAbandonSouscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroCRM"] = this.numeroCRM;
        data["origineSouscription"] = this.origineSouscription;
        data["idTypeProduit"] = this.idTypeProduit;
        data["idProduit"] = this.idProduit;
        data["etape"] = this.etape;
        data["origineMarketing"] = this.origineMarketing;
        data["urlRepriseParcours"] = this.urlRepriseParcours;
        data["dateAbandon"] = this.dateAbandon ? this.dateAbandon.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreationAbandonSouscriptionRequest {
    numeroCRM?: string | undefined;
    origineSouscription?: number;
    idTypeProduit?: number;
    idProduit?: number;
    etape?: string | undefined;
    origineMarketing?: string | undefined;
    urlRepriseParcours?: string | undefined;
    dateAbandon?: Date;
}

export class CreationAbandonSouscriptionResponse implements ICreationAbandonSouscriptionResponse {
    erreurs?: Erreur3[] | undefined;

    constructor(data?: ICreationAbandonSouscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreationAbandonSouscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreationAbandonSouscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreationAbandonSouscriptionResponse {
    erreurs?: Erreur3[] | undefined;
}

export class CreationDemandeDocumentationRequest implements ICreationDemandeDocumentationRequest {
    numeroCRM?: string | undefined;
    typeFormulaire?: string | undefined;
    idTypeProduit?: number;
    idProduit?: number;
    origineMarketing?: string | undefined;
    dateDemande?: Date;

    constructor(data?: ICreationDemandeDocumentationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroCRM = _data["numeroCRM"];
            this.typeFormulaire = _data["typeFormulaire"];
            this.idTypeProduit = _data["idTypeProduit"];
            this.idProduit = _data["idProduit"];
            this.origineMarketing = _data["origineMarketing"];
            this.dateDemande = _data["dateDemande"] ? new Date(_data["dateDemande"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreationDemandeDocumentationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreationDemandeDocumentationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroCRM"] = this.numeroCRM;
        data["typeFormulaire"] = this.typeFormulaire;
        data["idTypeProduit"] = this.idTypeProduit;
        data["idProduit"] = this.idProduit;
        data["origineMarketing"] = this.origineMarketing;
        data["dateDemande"] = this.dateDemande ? this.dateDemande.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreationDemandeDocumentationRequest {
    numeroCRM?: string | undefined;
    typeFormulaire?: string | undefined;
    idTypeProduit?: number;
    idProduit?: number;
    origineMarketing?: string | undefined;
    dateDemande?: Date;
}

export class CreationDemandeDocumentationResponse implements ICreationDemandeDocumentationResponse {
    erreurs?: Erreur3[] | undefined;

    constructor(data?: ICreationDemandeDocumentationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreationDemandeDocumentationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreationDemandeDocumentationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreationDemandeDocumentationResponse {
    erreurs?: Erreur3[] | undefined;
}

export class Erreur3 implements IErreur3 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur3 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur3 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class CreateResultatQuestionnaireRequest implements ICreateResultatQuestionnaireRequest {
    numeroCRM?: string | undefined;
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;
    reponsesDonnees?: ReponseDonnee[] | undefined;

    constructor(data?: ICreateResultatQuestionnaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroCRM = _data["numeroCRM"];
            this.dateQuestionnaire = _data["dateQuestionnaire"] ? new Date(_data["dateQuestionnaire"].toString()) : <any>undefined;
            this.lieuQuestionnaire = _data["lieuQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.score = _data["score"];
            this.profil = _data["profil"];
            this.descriptionProfil = _data["descriptionProfil"];
            this.codeContratCible = _data["codeContratCible"];
            this.libelleContratCible = _data["libelleContratCible"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.codeContratRecommande = _data["codeContratRecommande"];
            this.libelleContratRecommande = _data["libelleContratRecommande"];
            this.recommandation = _data["recommandation"];
            this.identifiantChoix = _data["identifiantChoix"];
            this.choixPersonne = _data["choixPersonne"];
            if (Array.isArray(_data["reponsesDonnees"])) {
                this.reponsesDonnees = [] as any;
                for (let item of _data["reponsesDonnees"])
                    this.reponsesDonnees!.push(ReponseDonnee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateResultatQuestionnaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResultatQuestionnaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroCRM"] = this.numeroCRM;
        data["dateQuestionnaire"] = this.dateQuestionnaire ? this.dateQuestionnaire.toISOString() : <any>undefined;
        data["lieuQuestionnaire"] = this.lieuQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["score"] = this.score;
        data["profil"] = this.profil;
        data["descriptionProfil"] = this.descriptionProfil;
        data["codeContratCible"] = this.codeContratCible;
        data["libelleContratCible"] = this.libelleContratCible;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["echeancePrecise"] = this.echeancePrecise;
        data["codeContratRecommande"] = this.codeContratRecommande;
        data["libelleContratRecommande"] = this.libelleContratRecommande;
        data["recommandation"] = this.recommandation;
        data["identifiantChoix"] = this.identifiantChoix;
        data["choixPersonne"] = this.choixPersonne;
        if (Array.isArray(this.reponsesDonnees)) {
            data["reponsesDonnees"] = [];
            for (let item of this.reponsesDonnees)
                data["reponsesDonnees"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateResultatQuestionnaireRequest {
    numeroCRM?: string | undefined;
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;
    reponsesDonnees?: ReponseDonnee[] | undefined;
}

export class CreateResultatQuestionnaireResponse implements ICreateResultatQuestionnaireResponse {
    messageRetour?: string | undefined;
    erreurs?: Erreur4[] | undefined;
    warnings?: Warning3[] | undefined;

    constructor(data?: ICreateResultatQuestionnaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageRetour = _data["messageRetour"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateResultatQuestionnaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResultatQuestionnaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageRetour"] = this.messageRetour;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateResultatQuestionnaireResponse {
    messageRetour?: string | undefined;
    erreurs?: Erreur4[] | undefined;
    warnings?: Warning3[] | undefined;
}

export class Erreur4 implements IErreur4 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur4 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur4 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetInfosProfilEpargnantRequest implements IGetInfosProfilEpargnantRequest {
    numeroExterne?: string | undefined;

    constructor(data?: IGetInfosProfilEpargnantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroExterne = _data["numeroExterne"];
        }
    }

    static fromJS(data: any): GetInfosProfilEpargnantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfosProfilEpargnantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroExterne"] = this.numeroExterne;
        return data;
    }
}

export interface IGetInfosProfilEpargnantRequest {
    numeroExterne?: string | undefined;
}

export class GetInfosProfilEpargnantResponse implements IGetInfosProfilEpargnantResponse {
    infosProfilEpargnant?: InfosProfilEpargnant;
    erreurs?: Erreur4[] | undefined;
    warnings?: Warning3[] | undefined;

    constructor(data?: IGetInfosProfilEpargnantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infosProfilEpargnant = _data["infosProfilEpargnant"] ? InfosProfilEpargnant.fromJS(_data["infosProfilEpargnant"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInfosProfilEpargnantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInfosProfilEpargnantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infosProfilEpargnant"] = this.infosProfilEpargnant ? this.infosProfilEpargnant.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInfosProfilEpargnantResponse {
    infosProfilEpargnant?: InfosProfilEpargnant;
    erreurs?: Erreur4[] | undefined;
    warnings?: Warning3[] | undefined;
}

export class GetQuestionnaireRequest implements IGetQuestionnaireRequest {
    identifiantDemarche?: number | undefined;

    constructor(data?: IGetQuestionnaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiantDemarche = _data["identifiantDemarche"];
        }
    }

    static fromJS(data: any): GetQuestionnaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionnaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiantDemarche"] = this.identifiantDemarche;
        return data;
    }
}

export interface IGetQuestionnaireRequest {
    identifiantDemarche?: number | undefined;
}

export class GetQuestionnaireResponse implements IGetQuestionnaireResponse {
    questionnaire?: Questionnaire;
    erreurs?: Erreur4[] | undefined;

    constructor(data?: IGetQuestionnaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionnaire = _data["questionnaire"] ? Questionnaire.fromJS(_data["questionnaire"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuestionnaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionnaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetQuestionnaireResponse {
    questionnaire?: Questionnaire;
    erreurs?: Erreur4[] | undefined;
}

export class InfosProfilEpargnant implements IInfosProfilEpargnant {
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;

    constructor(data?: IInfosProfilEpargnant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateQuestionnaire = _data["dateQuestionnaire"] ? new Date(_data["dateQuestionnaire"].toString()) : <any>undefined;
            this.lieuQuestionnaire = _data["lieuQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.score = _data["score"];
            this.profil = _data["profil"];
            this.descriptionProfil = _data["descriptionProfil"];
            this.codeContratCible = _data["codeContratCible"];
            this.libelleContratCible = _data["libelleContratCible"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.codeContratRecommande = _data["codeContratRecommande"];
            this.libelleContratRecommande = _data["libelleContratRecommande"];
            this.recommandation = _data["recommandation"];
            this.identifiantChoix = _data["identifiantChoix"];
            this.choixPersonne = _data["choixPersonne"];
        }
    }

    static fromJS(data: any): InfosProfilEpargnant {
        data = typeof data === 'object' ? data : {};
        let result = new InfosProfilEpargnant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateQuestionnaire"] = this.dateQuestionnaire ? this.dateQuestionnaire.toISOString() : <any>undefined;
        data["lieuQuestionnaire"] = this.lieuQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["score"] = this.score;
        data["profil"] = this.profil;
        data["descriptionProfil"] = this.descriptionProfil;
        data["codeContratCible"] = this.codeContratCible;
        data["libelleContratCible"] = this.libelleContratCible;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["echeancePrecise"] = this.echeancePrecise;
        data["codeContratRecommande"] = this.codeContratRecommande;
        data["libelleContratRecommande"] = this.libelleContratRecommande;
        data["recommandation"] = this.recommandation;
        data["identifiantChoix"] = this.identifiantChoix;
        data["choixPersonne"] = this.choixPersonne;
        return data;
    }
}

export interface IInfosProfilEpargnant {
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    libelleContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean;
    echeancePrecise?: boolean;
    codeContratRecommande?: string | undefined;
    libelleContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    identifiantChoix?: number | undefined;
    choixPersonne?: string | undefined;
}

export class Question implements IQuestion {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    reponsesMultiples?: boolean | undefined;
    ordre?: number | undefined;
    reponses?: Reponse[] | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.libelle = _data["libelle"];
            this.aide = _data["aide"];
            this.reponsesMultiples = _data["reponsesMultiples"];
            this.ordre = _data["ordre"];
            if (Array.isArray(_data["reponses"])) {
                this.reponses = [] as any;
                for (let item of _data["reponses"])
                    this.reponses!.push(Reponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["libelle"] = this.libelle;
        data["aide"] = this.aide;
        data["reponsesMultiples"] = this.reponsesMultiples;
        data["ordre"] = this.ordre;
        if (Array.isArray(this.reponses)) {
            data["reponses"] = [];
            for (let item of this.reponses)
                data["reponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestion {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    reponsesMultiples?: boolean | undefined;
    ordre?: number | undefined;
    reponses?: Reponse[] | undefined;
}

export class Questionnaire implements IQuestionnaire {
    etat?: string | undefined;
    version?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLongDescription?: string | undefined;
    dateCreation?: Date | undefined;
    dateModification?: Date | undefined;
    identifiantQuestionnaire?: number | undefined;
    identifiantDemarche?: number | undefined;
    dateDebutIndicative?: Date | undefined;
    dateFinIndicative?: Date | undefined;
    themes?: Theme[] | undefined;

    constructor(data?: IQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.etat = _data["etat"];
            this.version = _data["version"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLongDescription = _data["libelleLongDescription"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : <any>undefined;
            this.dateModification = _data["dateModification"] ? new Date(_data["dateModification"].toString()) : <any>undefined;
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.dateDebutIndicative = _data["dateDebutIndicative"] ? new Date(_data["dateDebutIndicative"].toString()) : <any>undefined;
            this.dateFinIndicative = _data["dateFinIndicative"] ? new Date(_data["dateFinIndicative"].toString()) : <any>undefined;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(Theme.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Questionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Questionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["etat"] = this.etat;
        data["version"] = this.version;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLongDescription"] = this.libelleLongDescription;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : <any>undefined;
        data["dateModification"] = this.dateModification ? this.dateModification.toISOString() : <any>undefined;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["dateDebutIndicative"] = this.dateDebutIndicative ? this.dateDebutIndicative.toISOString() : <any>undefined;
        data["dateFinIndicative"] = this.dateFinIndicative ? this.dateFinIndicative.toISOString() : <any>undefined;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionnaire {
    etat?: string | undefined;
    version?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLongDescription?: string | undefined;
    dateCreation?: Date | undefined;
    dateModification?: Date | undefined;
    identifiantQuestionnaire?: number | undefined;
    identifiantDemarche?: number | undefined;
    dateDebutIndicative?: Date | undefined;
    dateFinIndicative?: Date | undefined;
    themes?: Theme[] | undefined;
}

export class Reponse implements IReponse {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    points?: number | undefined;
    ordre?: number | undefined;

    constructor(data?: IReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.libelle = _data["libelle"];
            this.aide = _data["aide"];
            this.points = _data["points"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): Reponse {
        data = typeof data === 'object' ? data : {};
        let result = new Reponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["libelle"] = this.libelle;
        data["aide"] = this.aide;
        data["points"] = this.points;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IReponse {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    points?: number | undefined;
    ordre?: number | undefined;
}

export class ReponseDonnee implements IReponseDonnee {
    identifiantQuestion?: number | undefined;
    identifiantReponse?: number | undefined;

    constructor(data?: IReponseDonnee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiantQuestion = _data["identifiantQuestion"];
            this.identifiantReponse = _data["identifiantReponse"];
        }
    }

    static fromJS(data: any): ReponseDonnee {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseDonnee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiantQuestion"] = this.identifiantQuestion;
        data["identifiantReponse"] = this.identifiantReponse;
        return data;
    }
}

export interface IReponseDonnee {
    identifiantQuestion?: number | undefined;
    identifiantReponse?: number | undefined;
}

export class Theme implements ITheme {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    ordre?: number | undefined;
    questions?: Question[] | undefined;

    constructor(data?: ITheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.libelle = _data["libelle"];
            this.aide = _data["aide"];
            this.ordre = _data["ordre"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Theme {
        data = typeof data === 'object' ? data : {};
        let result = new Theme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["libelle"] = this.libelle;
        data["aide"] = this.aide;
        data["ordre"] = this.ordre;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITheme {
    identifiant?: number | undefined;
    libelle?: string | undefined;
    aide?: string | undefined;
    ordre?: number | undefined;
    questions?: Question[] | undefined;
}

export class Warning3 implements IWarning3 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning3 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning3 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class CoordonneesCompteBancairePrelevement implements ICoordonneesCompteBancairePrelevement {
    IBAN?: string | undefined;
    BIC?: string | undefined;
    nomBanque?: string | undefined;
    numeroContrat?: number[] | undefined;
    dateCreation?: Date | undefined;
    RUM?: string | undefined;

    constructor(data?: ICoordonneesCompteBancairePrelevement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.IBAN = _data["IBAN"];
            this.BIC = _data["BIC"];
            this.nomBanque = _data["nomBanque"];
            if (Array.isArray(_data["numeroContrat"])) {
                this.numeroContrat = [] as any;
                for (let item of _data["numeroContrat"])
                    this.numeroContrat!.push(item);
            }
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : <any>undefined;
            this.RUM = _data["RUM"];
        }
    }

    static fromJS(data: any): CoordonneesCompteBancairePrelevement {
        data = typeof data === 'object' ? data : {};
        let result = new CoordonneesCompteBancairePrelevement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IBAN"] = this.IBAN;
        data["BIC"] = this.BIC;
        data["nomBanque"] = this.nomBanque;
        if (Array.isArray(this.numeroContrat)) {
            data["numeroContrat"] = [];
            for (let item of this.numeroContrat)
                data["numeroContrat"].push(item);
        }
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : <any>undefined;
        data["RUM"] = this.RUM;
        return data;
    }
}

export interface ICoordonneesCompteBancairePrelevement {
    IBAN?: string | undefined;
    BIC?: string | undefined;
    nomBanque?: string | undefined;
    numeroContrat?: number[] | undefined;
    dateCreation?: Date | undefined;
    RUM?: string | undefined;
}

export class CoordonneesCompteBancaireReglement implements ICoordonneesCompteBancaireReglement {
    IBAN?: string | undefined;
    BIC?: string | undefined;
    nomBanque?: string | undefined;
    dateCreation?: Date | undefined;
    typeCompte?: string | undefined;

    constructor(data?: ICoordonneesCompteBancaireReglement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.IBAN = _data["IBAN"];
            this.BIC = _data["BIC"];
            this.nomBanque = _data["nomBanque"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : <any>undefined;
            this.typeCompte = _data["typeCompte"];
        }
    }

    static fromJS(data: any): CoordonneesCompteBancaireReglement {
        data = typeof data === 'object' ? data : {};
        let result = new CoordonneesCompteBancaireReglement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IBAN"] = this.IBAN;
        data["BIC"] = this.BIC;
        data["nomBanque"] = this.nomBanque;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : <any>undefined;
        data["typeCompte"] = this.typeCompte;
        return data;
    }
}

export interface ICoordonneesCompteBancaireReglement {
    IBAN?: string | undefined;
    BIC?: string | undefined;
    nomBanque?: string | undefined;
    dateCreation?: Date | undefined;
    typeCompte?: string | undefined;
}

export class Erreur5 implements IErreur5 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur5 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur5 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetCoordonneesComptesBancairesPrelevementRequest implements IGetCoordonneesComptesBancairesPrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesPrelevementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesPrelevementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesPrelevementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesPrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;
}

export class GetCoordonneesComptesBancairesPrelevementResponse implements IGetCoordonneesComptesBancairesPrelevementResponse {
    coordonneesCompteBancairePrelevement?: CoordonneesCompteBancairePrelevement[] | undefined;
    erreurs?: Erreur5[] | undefined;
    warnings?: Warning4[] | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesPrelevementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordonneesCompteBancairePrelevement"])) {
                this.coordonneesCompteBancairePrelevement = [] as any;
                for (let item of _data["coordonneesCompteBancairePrelevement"])
                    this.coordonneesCompteBancairePrelevement!.push(CoordonneesCompteBancairePrelevement.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur5.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesPrelevementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesPrelevementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordonneesCompteBancairePrelevement)) {
            data["coordonneesCompteBancairePrelevement"] = [];
            for (let item of this.coordonneesCompteBancairePrelevement)
                data["coordonneesCompteBancairePrelevement"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesPrelevementResponse {
    coordonneesCompteBancairePrelevement?: CoordonneesCompteBancairePrelevement[] | undefined;
    erreurs?: Erreur5[] | undefined;
    warnings?: Warning4[] | undefined;
}

export class GetCoordonneesComptesBancairesReglementRequest implements IGetCoordonneesComptesBancairesReglementRequest {
    numeroInterne?: number | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesReglementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesReglementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesReglementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesReglementRequest {
    numeroInterne?: number | undefined;
}

export class GetCoordonneesComptesBancairesReglementResponse implements IGetCoordonneesComptesBancairesReglementResponse {
    coordonneesCompteBancaireReglement?: CoordonneesCompteBancaireReglement[] | undefined;
    erreurs?: Erreur5[] | undefined;
    warnings?: Warning4[] | undefined;

    constructor(data?: IGetCoordonneesComptesBancairesReglementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordonneesCompteBancaireReglement"])) {
                this.coordonneesCompteBancaireReglement = [] as any;
                for (let item of _data["coordonneesCompteBancaireReglement"])
                    this.coordonneesCompteBancaireReglement!.push(CoordonneesCompteBancaireReglement.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur5.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCoordonneesComptesBancairesReglementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoordonneesComptesBancairesReglementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordonneesCompteBancaireReglement)) {
            data["coordonneesCompteBancaireReglement"] = [];
            for (let item of this.coordonneesCompteBancaireReglement)
                data["coordonneesCompteBancaireReglement"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCoordonneesComptesBancairesReglementResponse {
    coordonneesCompteBancaireReglement?: CoordonneesCompteBancaireReglement[] | undefined;
    erreurs?: Erreur5[] | undefined;
    warnings?: Warning4[] | undefined;
}

export class UpdateForNewSourcePrelevementRequest implements IUpdateForNewSourcePrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;

    constructor(data?: IUpdateForNewSourcePrelevementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): UpdateForNewSourcePrelevementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForNewSourcePrelevementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IUpdateForNewSourcePrelevementRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;
}

export class UpdateForNewSourcePrelevementResponse implements IUpdateForNewSourcePrelevementResponse {
    erreurs?: Erreur5[] | undefined;

    constructor(data?: IUpdateForNewSourcePrelevementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateForNewSourcePrelevementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForNewSourcePrelevementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateForNewSourcePrelevementResponse {
    erreurs?: Erreur5[] | undefined;
}

export class Warning4 implements IWarning4 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning4 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning4 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class AutoCompletionEmail implements IAutoCompletionEmail {
    Instance?: number | undefined;
    suggest?: string[] | undefined;
    syntaxe?: string | undefined;

    constructor(data?: IAutoCompletionEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Instance = _data["Instance"];
            if (Array.isArray(_data["suggest"])) {
                this.suggest = [] as any;
                for (let item of _data["suggest"])
                    this.suggest!.push(item);
            }
            this.syntaxe = _data["syntaxe"];
        }
    }

    static fromJS(data: any): AutoCompletionEmail {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Instance"] = this.Instance;
        if (Array.isArray(this.suggest)) {
            data["suggest"] = [];
            for (let item of this.suggest)
                data["suggest"].push(item);
        }
        data["syntaxe"] = this.syntaxe;
        return data;
    }
}

export interface IAutoCompletionEmail {
    Instance?: number | undefined;
    suggest?: string[] | undefined;
    syntaxe?: string | undefined;
}

export class AutoCompletionEmailRequest implements IAutoCompletionEmailRequest {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IAutoCompletionEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.email = _data["email"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): AutoCompletionEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["email"] = this.email;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IAutoCompletionEmailRequest {
    nom?: string | undefined;
    prenom?: string | undefined;
    email?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class AutoCompletionEmailResponse implements IAutoCompletionEmailResponse {
    autoCompletion?: AutoCompletionEmail;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IAutoCompletionEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoCompletion = _data["autoCompletion"] ? AutoCompletionEmail.fromJS(_data["autoCompletion"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoCompletionEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutoCompletionEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoCompletion"] = this.autoCompletion ? this.autoCompletion.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAutoCompletionEmailResponse {
    autoCompletion?: AutoCompletionEmail;
    erreurs?: Erreur6[] | undefined;
}

export class ControleFormulaireRequest implements IControleFormulaireRequest {
    saisie?: string | undefined;
    taille?: number | undefined;
    proposition?: boolean | undefined;
    modification?: boolean | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IControleFormulaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saisie = _data["saisie"];
            this.taille = _data["taille"];
            this.proposition = _data["proposition"];
            this.modification = _data["modification"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): ControleFormulaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ControleFormulaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saisie"] = this.saisie;
        data["taille"] = this.taille;
        data["proposition"] = this.proposition;
        data["modification"] = this.modification;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IControleFormulaireRequest {
    saisie?: string | undefined;
    taille?: number | undefined;
    proposition?: boolean | undefined;
    modification?: boolean | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class ControleFormulaireResponse implements IControleFormulaireResponse {
    controleFormulaire?: ResponseDQE4[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IControleFormulaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["controleFormulaire"])) {
                this.controleFormulaire = [] as any;
                for (let item of _data["controleFormulaire"])
                    this.controleFormulaire!.push(ResponseDQE4.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ControleFormulaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ControleFormulaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.controleFormulaire)) {
            data["controleFormulaire"] = [];
            for (let item of this.controleFormulaire)
                data["controleFormulaire"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IControleFormulaireResponse {
    controleFormulaire?: ResponseDQE4[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class Erreur6 implements IErreur6 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur6 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur6 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class RechercheAdresseRequest implements IRechercheAdresseRequest {
    adresse?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheAdresseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adresse = _data["adresse"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheAdresseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAdresseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adresse"] = this.adresse;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheAdresseRequest {
    adresse?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheAdresseResponse implements IRechercheAdresseResponse {
    rechercheAdresse?: ResponseDQE6[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheAdresseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheAdresse"])) {
                this.rechercheAdresse = [] as any;
                for (let item of _data["rechercheAdresse"])
                    this.rechercheAdresse!.push(ResponseDQE6.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheAdresseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAdresseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheAdresse)) {
            data["rechercheAdresse"] = [];
            for (let item of this.rechercheAdresse)
                data["rechercheAdresse"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheAdresseResponse {
    rechercheAdresse?: ResponseDQE6[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class RechercheComplementAdresseRequest implements IRechercheComplementAdresseRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheComplementAdresseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVoie = _data["idVoie"];
            this.numeroVoie = _data["numeroVoie"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheComplementAdresseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVoie"] = this.idVoie;
        data["numeroVoie"] = this.numeroVoie;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheComplementAdresseRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheComplementAdresseResponse implements IRechercheComplementAdresseResponse {
    rechercheComplementAdresse?: ResponseDQE2[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheComplementAdresseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheComplementAdresse"])) {
                this.rechercheComplementAdresse = [] as any;
                for (let item of _data["rechercheComplementAdresse"])
                    this.rechercheComplementAdresse!.push(ResponseDQE2.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheComplementAdresseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheComplementAdresse)) {
            data["rechercheComplementAdresse"] = [];
            for (let item of this.rechercheComplementAdresse)
                data["rechercheComplementAdresse"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheComplementAdresseResponse {
    rechercheComplementAdresse?: ResponseDQE2[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class RechercheComplementAdresseSaisie implements IRechercheComplementAdresseSaisie {
    informations?: ResponseDQE3;

    constructor(data?: IRechercheComplementAdresseSaisie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.informations = _data["informations"] ? ResponseDQE3.fromJS(_data["informations"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RechercheComplementAdresseSaisie {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseSaisie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["informations"] = this.informations ? this.informations.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRechercheComplementAdresseSaisie {
    informations?: ResponseDQE3;
}

export class RechercheComplementAdresseSaisieRequest implements IRechercheComplementAdresseSaisieRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheComplementAdresseSaisieRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVoie = _data["idVoie"];
            this.numeroVoie = _data["numeroVoie"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheComplementAdresseSaisieRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseSaisieRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVoie"] = this.idVoie;
        data["numeroVoie"] = this.numeroVoie;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheComplementAdresseSaisieRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheComplementAdresseSaisieResponse implements IRechercheComplementAdresseSaisieResponse {
    rechercheComplementAdresseSaisie?: RechercheComplementAdresseSaisie;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheComplementAdresseSaisieResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rechercheComplementAdresseSaisie = _data["rechercheComplementAdresseSaisie"] ? RechercheComplementAdresseSaisie.fromJS(_data["rechercheComplementAdresseSaisie"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheComplementAdresseSaisieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheComplementAdresseSaisieResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rechercheComplementAdresseSaisie"] = this.rechercheComplementAdresseSaisie ? this.rechercheComplementAdresseSaisie.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheComplementAdresseSaisieResponse {
    rechercheComplementAdresseSaisie?: RechercheComplementAdresseSaisie;
    erreurs?: Erreur6[] | undefined;
}

export class RechercheGeolocalisationRequest implements IRechercheGeolocalisationRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheGeolocalisationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVoie = _data["idVoie"];
            this.numeroVoie = _data["numeroVoie"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheGeolocalisationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheGeolocalisationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVoie"] = this.idVoie;
        data["numeroVoie"] = this.numeroVoie;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheGeolocalisationRequest {
    idVoie?: number | undefined;
    numeroVoie?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheGeolocalisationResponse implements IRechercheGeolocalisationResponse {
    rechercheGeolocalisation?: ResponseDQE7[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheGeolocalisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheGeolocalisation"])) {
                this.rechercheGeolocalisation = [] as any;
                for (let item of _data["rechercheGeolocalisation"])
                    this.rechercheGeolocalisation!.push(ResponseDQE7.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheGeolocalisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheGeolocalisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheGeolocalisation)) {
            data["rechercheGeolocalisation"] = [];
            for (let item of this.rechercheGeolocalisation)
                data["rechercheGeolocalisation"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheGeolocalisationResponse {
    rechercheGeolocalisation?: ResponseDQE7[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class RechercheRueRequest implements IRechercheRueRequest {
    idVille?: number | undefined;
    adresse?: string | undefined;
    taille?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheRueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idVille = _data["idVille"];
            this.adresse = _data["adresse"];
            this.taille = _data["taille"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheRueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idVille"] = this.idVille;
        data["adresse"] = this.adresse;
        data["taille"] = this.taille;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheRueRequest {
    idVille?: number | undefined;
    adresse?: string | undefined;
    taille?: number | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheRueResponse implements IRechercheRueResponse {
    rechercheRue?: ResponseDQE5[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheRueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheRue"])) {
                this.rechercheRue = [] as any;
                for (let item of _data["rechercheRue"])
                    this.rechercheRue!.push(ResponseDQE5.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheRueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheRue)) {
            data["rechercheRue"] = [];
            for (let item of this.rechercheRue)
                data["rechercheRue"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheRueResponse {
    rechercheRue?: ResponseDQE5[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class RechercheVilleRequest implements IRechercheVilleRequest {
    nomVille?: string | undefined;
    codePostal?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;

    constructor(data?: IRechercheVilleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomVille = _data["nomVille"];
            this.codePostal = _data["codePostal"];
            this.codePaysISO = _data["codePaysISO"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): RechercheVilleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheVilleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nomVille"] = this.nomVille;
        data["codePostal"] = this.codePostal;
        data["codePaysISO"] = this.codePaysISO;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IRechercheVilleRequest {
    nomVille?: string | undefined;
    codePostal?: string | undefined;
    codePaysISO?: string | undefined;
    idCanal?: number | undefined;
}

export class RechercheVilleResponse implements IRechercheVilleResponse {
    rechercheVille?: ResponseDQE[] | undefined;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IRechercheVilleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rechercheVille"])) {
                this.rechercheVille = [] as any;
                for (let item of _data["rechercheVille"])
                    this.rechercheVille!.push(ResponseDQE.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheVilleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheVilleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rechercheVille)) {
            data["rechercheVille"] = [];
            for (let item of this.rechercheVille)
                data["rechercheVille"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheVilleResponse {
    rechercheVille?: ResponseDQE[] | undefined;
    erreurs?: Erreur6[] | undefined;
}

export class ResponseDQE implements IResponseDQE {
    Province?: string | undefined;
    IDLocalite?: string | undefined;
    NbNumero?: string | undefined;
    Pays?: string | undefined;
    IDVoie?: string | undefined;
    Cedex?: string | undefined;
    Numero?: string | undefined;
    TypeVoie?: string | undefined;
    Instance?: string | undefined;
    ListeNumero?: string | undefined;
    CodePostal?: string | undefined;
    SousLocalite?: string | undefined;
    LieuDit?: string | undefined;
    Latitude?: string | undefined;
    Localite?: string | undefined;
    Longitude?: string | undefined;
    Complement?: string | undefined;
    Entreprise?: string | undefined;

    constructor(data?: IResponseDQE) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Province = _data["Province"];
            this.IDLocalite = _data["IDLocalite"];
            this.NbNumero = _data["NbNumero"];
            this.Pays = _data["Pays"];
            this.IDVoie = _data["IDVoie"];
            this.Cedex = _data["Cedex"];
            this.Numero = _data["Numero"];
            this.TypeVoie = _data["TypeVoie"];
            this.Instance = _data["Instance"];
            this.ListeNumero = _data["ListeNumero"];
            this.CodePostal = _data["CodePostal"];
            this.SousLocalite = _data["SousLocalite"];
            this.LieuDit = _data["LieuDit"];
            this.Latitude = _data["Latitude"];
            this.Localite = _data["Localite"];
            this.Longitude = _data["Longitude"];
            this.Complement = _data["Complement"];
            this.Entreprise = _data["Entreprise"];
        }
    }

    static fromJS(data: any): ResponseDQE {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Province"] = this.Province;
        data["IDLocalite"] = this.IDLocalite;
        data["NbNumero"] = this.NbNumero;
        data["Pays"] = this.Pays;
        data["IDVoie"] = this.IDVoie;
        data["Cedex"] = this.Cedex;
        data["Numero"] = this.Numero;
        data["TypeVoie"] = this.TypeVoie;
        data["Instance"] = this.Instance;
        data["ListeNumero"] = this.ListeNumero;
        data["CodePostal"] = this.CodePostal;
        data["SousLocalite"] = this.SousLocalite;
        data["LieuDit"] = this.LieuDit;
        data["Latitude"] = this.Latitude;
        data["Localite"] = this.Localite;
        data["Longitude"] = this.Longitude;
        data["Complement"] = this.Complement;
        data["Entreprise"] = this.Entreprise;
        return data;
    }
}

export interface IResponseDQE {
    Province?: string | undefined;
    IDLocalite?: string | undefined;
    NbNumero?: string | undefined;
    Pays?: string | undefined;
    IDVoie?: string | undefined;
    Cedex?: string | undefined;
    Numero?: string | undefined;
    TypeVoie?: string | undefined;
    Instance?: string | undefined;
    ListeNumero?: string | undefined;
    CodePostal?: string | undefined;
    SousLocalite?: string | undefined;
    LieuDit?: string | undefined;
    Latitude?: string | undefined;
    Localite?: string | undefined;
    Longitude?: string | undefined;
    Complement?: string | undefined;
    Entreprise?: string | undefined;
}

export class ResponseDQE2 implements IResponseDQE2 {
    Batiment?: string | undefined;

    constructor(data?: IResponseDQE2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Batiment = _data["Batiment"];
        }
    }

    static fromJS(data: any): ResponseDQE2 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Batiment"] = this.Batiment;
        return data;
    }
}

export interface IResponseDQE2 {
    Batiment?: string | undefined;
}

export class ResponseDQE3 implements IResponseDQE3 {
    Longitude?: string | undefined;
    Latitude?: string | undefined;
    Batiment?: string[] | undefined;

    constructor(data?: IResponseDQE3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Longitude = _data["Longitude"];
            this.Latitude = _data["Latitude"];
            if (Array.isArray(_data["Batiment"])) {
                this.Batiment = [] as any;
                for (let item of _data["Batiment"])
                    this.Batiment!.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseDQE3 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Longitude"] = this.Longitude;
        data["Latitude"] = this.Latitude;
        if (Array.isArray(this.Batiment)) {
            data["Batiment"] = [];
            for (let item of this.Batiment)
                data["Batiment"].push(item);
        }
        return data;
    }
}

export interface IResponseDQE3 {
    Longitude?: string | undefined;
    Latitude?: string | undefined;
    Batiment?: string[] | undefined;
}

export class ResponseDQE4 implements IResponseDQE4 {
    Roudis?: string | undefined;
    DQECompte?: string | undefined;
    Instance?: string | undefined;
    CodePostal?: string | undefined;
    Status_IrisIlot?: string | undefined;
    Latitude?: string | undefined;
    Localite?: string | undefined;
    Province?: string | undefined;
    NbNumero?: string | undefined;
    Complement?: string | undefined;
    Voie?: string | undefined;
    Adresse?: string | undefined;
    Cedex?: string | undefined;
    Numero?: string | undefined;
    ListeNumero?: string | undefined;
    IDHexaposte?: string | undefined;
    IDCle?: string | undefined;
    LieuDit?: string | undefined;
    ilot?: string | undefined;
    TypeVoie?: string | undefined;
    DQECodeDetail?: string | undefined;
    DQELibErreur?: string | undefined;
    Longitude?: string | undefined;
    CompNum?: string | undefined;
    iris?: string | undefined;
    IDLocalite?: string | undefined;
    DQECodeErreur?: string | undefined;
    Pays?: string | undefined;
    IDVoie?: string | undefined;
    NumSeul?: string | undefined;
    Ligne2?: string | undefined;
    DQEPourcentErreur?: string | undefined;
    Status_Modification?: string | undefined;
    Code_Modification?: string | undefined;

    constructor(data?: IResponseDQE4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Roudis = _data["Roudis"];
            this.DQECompte = _data["DQECompte"];
            this.Instance = _data["Instance"];
            this.CodePostal = _data["CodePostal"];
            this.Status_IrisIlot = _data["Status_IrisIlot"];
            this.Latitude = _data["Latitude"];
            this.Localite = _data["Localite"];
            this.Province = _data["Province"];
            this.NbNumero = _data["NbNumero"];
            this.Complement = _data["Complement"];
            this.Voie = _data["Voie"];
            this.Adresse = _data["Adresse"];
            this.Cedex = _data["Cedex"];
            this.Numero = _data["Numero"];
            this.ListeNumero = _data["ListeNumero"];
            this.IDHexaposte = _data["IDHexaposte"];
            this.IDCle = _data["IDCle"];
            this.LieuDit = _data["LieuDit"];
            this.ilot = _data["ilot"];
            this.TypeVoie = _data["TypeVoie"];
            this.DQECodeDetail = _data["DQECodeDetail"];
            this.DQELibErreur = _data["DQELibErreur"];
            this.Longitude = _data["Longitude"];
            this.CompNum = _data["CompNum"];
            this.iris = _data["iris"];
            this.IDLocalite = _data["IDLocalite"];
            this.DQECodeErreur = _data["DQECodeErreur"];
            this.Pays = _data["Pays"];
            this.IDVoie = _data["IDVoie"];
            this.NumSeul = _data["NumSeul"];
            this.Ligne2 = _data["Ligne2"];
            this.DQEPourcentErreur = _data["DQEPourcentErreur"];
            this.Status_Modification = _data["Status_Modification"];
            this.Code_Modification = _data["Code_Modification"];
        }
    }

    static fromJS(data: any): ResponseDQE4 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Roudis"] = this.Roudis;
        data["DQECompte"] = this.DQECompte;
        data["Instance"] = this.Instance;
        data["CodePostal"] = this.CodePostal;
        data["Status_IrisIlot"] = this.Status_IrisIlot;
        data["Latitude"] = this.Latitude;
        data["Localite"] = this.Localite;
        data["Province"] = this.Province;
        data["NbNumero"] = this.NbNumero;
        data["Complement"] = this.Complement;
        data["Voie"] = this.Voie;
        data["Adresse"] = this.Adresse;
        data["Cedex"] = this.Cedex;
        data["Numero"] = this.Numero;
        data["ListeNumero"] = this.ListeNumero;
        data["IDHexaposte"] = this.IDHexaposte;
        data["IDCle"] = this.IDCle;
        data["LieuDit"] = this.LieuDit;
        data["ilot"] = this.ilot;
        data["TypeVoie"] = this.TypeVoie;
        data["DQECodeDetail"] = this.DQECodeDetail;
        data["DQELibErreur"] = this.DQELibErreur;
        data["Longitude"] = this.Longitude;
        data["CompNum"] = this.CompNum;
        data["iris"] = this.iris;
        data["IDLocalite"] = this.IDLocalite;
        data["DQECodeErreur"] = this.DQECodeErreur;
        data["Pays"] = this.Pays;
        data["IDVoie"] = this.IDVoie;
        data["NumSeul"] = this.NumSeul;
        data["Ligne2"] = this.Ligne2;
        data["DQEPourcentErreur"] = this.DQEPourcentErreur;
        data["Status_Modification"] = this.Status_Modification;
        data["Code_Modification"] = this.Code_Modification;
        return data;
    }
}

export interface IResponseDQE4 {
    Roudis?: string | undefined;
    DQECompte?: string | undefined;
    Instance?: string | undefined;
    CodePostal?: string | undefined;
    Status_IrisIlot?: string | undefined;
    Latitude?: string | undefined;
    Localite?: string | undefined;
    Province?: string | undefined;
    NbNumero?: string | undefined;
    Complement?: string | undefined;
    Voie?: string | undefined;
    Adresse?: string | undefined;
    Cedex?: string | undefined;
    Numero?: string | undefined;
    ListeNumero?: string | undefined;
    IDHexaposte?: string | undefined;
    IDCle?: string | undefined;
    LieuDit?: string | undefined;
    ilot?: string | undefined;
    TypeVoie?: string | undefined;
    DQECodeDetail?: string | undefined;
    DQELibErreur?: string | undefined;
    Longitude?: string | undefined;
    CompNum?: string | undefined;
    iris?: string | undefined;
    IDLocalite?: string | undefined;
    DQECodeErreur?: string | undefined;
    Pays?: string | undefined;
    IDVoie?: string | undefined;
    NumSeul?: string | undefined;
    Ligne2?: string | undefined;
    DQEPourcentErreur?: string | undefined;
    Status_Modification?: string | undefined;
    Code_Modification?: string | undefined;
}

export class ResponseDQE5 implements IResponseDQE5 {
    IDLocalite?: string | undefined;
    Saisie?: string | undefined;
    Pays?: string | undefined;
    IDVoie?: string | undefined;
    Voie?: string | undefined;
    Roudis?: string | undefined;
    ListeNumero?: string | undefined;
    Numero?: string | undefined;
    TypeVoie?: string | undefined;
    Instance?: string | undefined;
    Cedex?: string | undefined;
    Num?: string | undefined;
    CodePostal?: string | undefined;
    NbNumero?: string | undefined;
    LieuDit?: string | undefined;
    Localite?: string | undefined;
    CodeVoie?: string | undefined;
    Complement?: string | undefined;
    Entreprise?: string | undefined;

    constructor(data?: IResponseDQE5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.IDLocalite = _data["IDLocalite"];
            this.Saisie = _data["Saisie"];
            this.Pays = _data["Pays"];
            this.IDVoie = _data["IDVoie"];
            this.Voie = _data["Voie"];
            this.Roudis = _data["Roudis"];
            this.ListeNumero = _data["ListeNumero"];
            this.Numero = _data["Numero"];
            this.TypeVoie = _data["TypeVoie"];
            this.Instance = _data["Instance"];
            this.Cedex = _data["Cedex"];
            this.Num = _data["Num"];
            this.CodePostal = _data["CodePostal"];
            this.NbNumero = _data["NbNumero"];
            this.LieuDit = _data["LieuDit"];
            this.Localite = _data["Localite"];
            this.CodeVoie = _data["CodeVoie"];
            this.Complement = _data["Complement"];
            this.Entreprise = _data["Entreprise"];
        }
    }

    static fromJS(data: any): ResponseDQE5 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IDLocalite"] = this.IDLocalite;
        data["Saisie"] = this.Saisie;
        data["Pays"] = this.Pays;
        data["IDVoie"] = this.IDVoie;
        data["Voie"] = this.Voie;
        data["Roudis"] = this.Roudis;
        data["ListeNumero"] = this.ListeNumero;
        data["Numero"] = this.Numero;
        data["TypeVoie"] = this.TypeVoie;
        data["Instance"] = this.Instance;
        data["Cedex"] = this.Cedex;
        data["Num"] = this.Num;
        data["CodePostal"] = this.CodePostal;
        data["NbNumero"] = this.NbNumero;
        data["LieuDit"] = this.LieuDit;
        data["Localite"] = this.Localite;
        data["CodeVoie"] = this.CodeVoie;
        data["Complement"] = this.Complement;
        data["Entreprise"] = this.Entreprise;
        return data;
    }
}

export interface IResponseDQE5 {
    IDLocalite?: string | undefined;
    Saisie?: string | undefined;
    Pays?: string | undefined;
    IDVoie?: string | undefined;
    Voie?: string | undefined;
    Roudis?: string | undefined;
    ListeNumero?: string | undefined;
    Numero?: string | undefined;
    TypeVoie?: string | undefined;
    Instance?: string | undefined;
    Cedex?: string | undefined;
    Num?: string | undefined;
    CodePostal?: string | undefined;
    NbNumero?: string | undefined;
    LieuDit?: string | undefined;
    Localite?: string | undefined;
    CodeVoie?: string | undefined;
    Complement?: string | undefined;
    Entreprise?: string | undefined;
}

export class ResponseDQE6 implements IResponseDQE6 {
    Instance?: string | undefined;
    Province?: string | undefined;
    IDLocalite?: string | undefined;
    CodePostal?: string | undefined;
    Localite?: string | undefined;
    Pays?: string | undefined;
    LieuDit?: string | undefined;
    Latitude?: string | undefined;
    Longitude?: string | undefined;
    IDVoie?: string | undefined;
    CodeVoie?: string | undefined;
    label?: string | undefined;
    Region3?: string | undefined;
    Region2?: string | undefined;
    Region1?: string | undefined;
    Region4?: string | undefined;
    Numero?: string | undefined;
    Num?: string | undefined;
    NbNumero?: string | undefined;
    Nbnumero?: string | undefined;
    valid_num?: string | undefined;
    NumSeul?: string | undefined;
    ListeNumero?: string | undefined;
    TypeVoie?: string | undefined;
    Voie?: string | undefined;
    Suburb?: string | undefined;
    SousLocalite?: string | undefined;
    Complement?: string | undefined;
    Saisie?: string | undefined;
    Entreprise?: string | undefined;

    constructor(data?: IResponseDQE6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Instance = _data["Instance"];
            this.Province = _data["Province"];
            this.IDLocalite = _data["IDLocalite"];
            this.CodePostal = _data["CodePostal"];
            this.Localite = _data["Localite"];
            this.Pays = _data["Pays"];
            this.LieuDit = _data["LieuDit"];
            this.Latitude = _data["Latitude"];
            this.Longitude = _data["Longitude"];
            this.IDVoie = _data["IDVoie"];
            this.CodeVoie = _data["CodeVoie"];
            this.label = _data["label"];
            this.Region3 = _data["Region3"];
            this.Region2 = _data["Region2"];
            this.Region1 = _data["Region1"];
            this.Region4 = _data["Region4"];
            this.Numero = _data["Numero"];
            this.Num = _data["Num"];
            this.NbNumero = _data["NbNumero"];
            this.Nbnumero = _data["Nbnumero"];
            this.valid_num = _data["valid_num"];
            this.NumSeul = _data["NumSeul"];
            this.ListeNumero = _data["ListeNumero"];
            this.TypeVoie = _data["TypeVoie"];
            this.Voie = _data["Voie"];
            this.Suburb = _data["Suburb"];
            this.SousLocalite = _data["SousLocalite"];
            this.Complement = _data["Complement"];
            this.Saisie = _data["Saisie"];
            this.Entreprise = _data["Entreprise"];
        }
    }

    static fromJS(data: any): ResponseDQE6 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Instance"] = this.Instance;
        data["Province"] = this.Province;
        data["IDLocalite"] = this.IDLocalite;
        data["CodePostal"] = this.CodePostal;
        data["Localite"] = this.Localite;
        data["Pays"] = this.Pays;
        data["LieuDit"] = this.LieuDit;
        data["Latitude"] = this.Latitude;
        data["Longitude"] = this.Longitude;
        data["IDVoie"] = this.IDVoie;
        data["CodeVoie"] = this.CodeVoie;
        data["label"] = this.label;
        data["Region3"] = this.Region3;
        data["Region2"] = this.Region2;
        data["Region1"] = this.Region1;
        data["Region4"] = this.Region4;
        data["Numero"] = this.Numero;
        data["Num"] = this.Num;
        data["NbNumero"] = this.NbNumero;
        data["Nbnumero"] = this.Nbnumero;
        data["valid_num"] = this.valid_num;
        data["NumSeul"] = this.NumSeul;
        data["ListeNumero"] = this.ListeNumero;
        data["TypeVoie"] = this.TypeVoie;
        data["Voie"] = this.Voie;
        data["Suburb"] = this.Suburb;
        data["SousLocalite"] = this.SousLocalite;
        data["Complement"] = this.Complement;
        data["Saisie"] = this.Saisie;
        data["Entreprise"] = this.Entreprise;
        return data;
    }
}

export interface IResponseDQE6 {
    Instance?: string | undefined;
    Province?: string | undefined;
    IDLocalite?: string | undefined;
    CodePostal?: string | undefined;
    Localite?: string | undefined;
    Pays?: string | undefined;
    LieuDit?: string | undefined;
    Latitude?: string | undefined;
    Longitude?: string | undefined;
    IDVoie?: string | undefined;
    CodeVoie?: string | undefined;
    label?: string | undefined;
    Region3?: string | undefined;
    Region2?: string | undefined;
    Region1?: string | undefined;
    Region4?: string | undefined;
    Numero?: string | undefined;
    Num?: string | undefined;
    NbNumero?: string | undefined;
    Nbnumero?: string | undefined;
    valid_num?: string | undefined;
    NumSeul?: string | undefined;
    ListeNumero?: string | undefined;
    TypeVoie?: string | undefined;
    Voie?: string | undefined;
    Suburb?: string | undefined;
    SousLocalite?: string | undefined;
    Complement?: string | undefined;
    Saisie?: string | undefined;
    Entreprise?: string | undefined;
}

export class ResponseDQE7 implements IResponseDQE7 {
    Latitude?: string | undefined;
    Longitude?: string | undefined;
    LibelleQualiteGeo?: string | undefined;
    CodeQualiteGeo?: string | undefined;

    constructor(data?: IResponseDQE7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Latitude = _data["Latitude"];
            this.Longitude = _data["Longitude"];
            this.LibelleQualiteGeo = _data["LibelleQualiteGeo"];
            this.CodeQualiteGeo = _data["CodeQualiteGeo"];
        }
    }

    static fromJS(data: any): ResponseDQE7 {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDQE7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Latitude"] = this.Latitude;
        data["Longitude"] = this.Longitude;
        data["LibelleQualiteGeo"] = this.LibelleQualiteGeo;
        data["CodeQualiteGeo"] = this.CodeQualiteGeo;
        return data;
    }
}

export interface IResponseDQE7 {
    Latitude?: string | undefined;
    Longitude?: string | undefined;
    LibelleQualiteGeo?: string | undefined;
    CodeQualiteGeo?: string | undefined;
}

export class ValidationEmail implements IValidationEmail {
    Redressement?: number | undefined;
    eMailOrigine?: string | undefined;
    IdError?: number | undefined;
    eMail?: string | undefined;

    constructor(data?: IValidationEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Redressement = _data["Redressement"];
            this.eMailOrigine = _data["eMailOrigine"];
            this.IdError = _data["IdError"];
            this.eMail = _data["eMail"];
        }
    }

    static fromJS(data: any): ValidationEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Redressement"] = this.Redressement;
        data["eMailOrigine"] = this.eMailOrigine;
        data["IdError"] = this.IdError;
        data["eMail"] = this.eMail;
        return data;
    }
}

export interface IValidationEmail {
    Redressement?: number | undefined;
    eMailOrigine?: string | undefined;
    IdError?: number | undefined;
    eMail?: string | undefined;
}

export class ValidationEmailRequest implements IValidationEmailRequest {
    email?: string | undefined;
    isRectify?: boolean | undefined;
    isExtendedSyntax?: boolean | undefined;
    isCheckUser?: boolean | undefined;
    idCanal?: number | undefined;

    constructor(data?: IValidationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.isRectify = _data["isRectify"];
            this.isExtendedSyntax = _data["isExtendedSyntax"];
            this.isCheckUser = _data["isCheckUser"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): ValidationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["isRectify"] = this.isRectify;
        data["isExtendedSyntax"] = this.isExtendedSyntax;
        data["isCheckUser"] = this.isCheckUser;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IValidationEmailRequest {
    email?: string | undefined;
    isRectify?: boolean | undefined;
    isExtendedSyntax?: boolean | undefined;
    isCheckUser?: boolean | undefined;
    idCanal?: number | undefined;
}

export class ValidationEmailResponse implements IValidationEmailResponse {
    validation?: ValidationEmail;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IValidationEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validation = _data["validation"] ? ValidationEmail.fromJS(_data["validation"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationEmailResponse {
    validation?: ValidationEmail;
    erreurs?: Erreur6[] | undefined;
}

export class ValidationNumTel implements IValidationNumTel {
    TelOrigine?: string | undefined;
    Geolocation?: string | undefined;
    Tel?: string | undefined;
    Ported?: string | undefined;
    Operator?: string | undefined;
    IdError?: number | undefined;
    OldOperator?: string | undefined;
    Type?: string | undefined;

    constructor(data?: IValidationNumTel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.TelOrigine = _data["TelOrigine"];
            this.Geolocation = _data["Geolocation"];
            this.Tel = _data["Tel"];
            this.Ported = _data["Ported"];
            this.Operator = _data["Operator"];
            this.IdError = _data["IdError"];
            this.OldOperator = _data["OldOperator"];
            this.Type = _data["Type"];
        }
    }

    static fromJS(data: any): ValidationNumTel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationNumTel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TelOrigine"] = this.TelOrigine;
        data["Geolocation"] = this.Geolocation;
        data["Tel"] = this.Tel;
        data["Ported"] = this.Ported;
        data["Operator"] = this.Operator;
        data["IdError"] = this.IdError;
        data["OldOperator"] = this.OldOperator;
        data["Type"] = this.Type;
        return data;
    }
}

export interface IValidationNumTel {
    TelOrigine?: string | undefined;
    Geolocation?: string | undefined;
    Tel?: string | undefined;
    Ported?: string | undefined;
    Operator?: string | undefined;
    IdError?: number | undefined;
    OldOperator?: string | undefined;
    Type?: string | undefined;
}

export class ValidationNumTelRequest implements IValidationNumTelRequest {
    numTel?: string | undefined;
    codePaysISO?: string | undefined;
    format?: number | undefined;
    idCanal?: number | undefined;

    constructor(data?: IValidationNumTelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numTel = _data["numTel"];
            this.codePaysISO = _data["codePaysISO"];
            this.format = _data["format"];
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): ValidationNumTelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationNumTelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numTel"] = this.numTel;
        data["codePaysISO"] = this.codePaysISO;
        data["format"] = this.format;
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface IValidationNumTelRequest {
    numTel?: string | undefined;
    codePaysISO?: string | undefined;
    format?: number | undefined;
    idCanal?: number | undefined;
}

export class ValidationNumTelResponse implements IValidationNumTelResponse {
    validation?: ValidationNumTel;
    erreurs?: Erreur6[] | undefined;

    constructor(data?: IValidationNumTelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validation = _data["validation"] ? ValidationNumTel.fromJS(_data["validation"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationNumTelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationNumTelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidationNumTelResponse {
    validation?: ValidationNumTel;
    erreurs?: Erreur6[] | undefined;
}

export class AjoutCoordonneeBancaire implements IAjoutCoordonneeBancaire {
    numeroContrat?: number | undefined;
    IBAN?: string | undefined;
    mandat?: Mandat;

    constructor(data?: IAjoutCoordonneeBancaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.IBAN = _data["IBAN"];
            this.mandat = _data["mandat"] ? Mandat.fromJS(_data["mandat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AjoutCoordonneeBancaire {
        data = typeof data === 'object' ? data : {};
        let result = new AjoutCoordonneeBancaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["IBAN"] = this.IBAN;
        data["mandat"] = this.mandat ? this.mandat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAjoutCoordonneeBancaire {
    numeroContrat?: number | undefined;
    IBAN?: string | undefined;
    mandat?: Mandat;
}

export class Arbitrage implements IArbitrage {
    numeroContrat?: number | undefined;
    dateValeur?: Date;
    supportsDesinvestis?: Support[] | undefined;
    supportsReinvestis?: Support[] | undefined;

    constructor(data?: IArbitrage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.dateValeur = _data["dateValeur"] ? new Date(_data["dateValeur"].toString()) : <any>undefined;
            if (Array.isArray(_data["supportsDesinvestis"])) {
                this.supportsDesinvestis = [] as any;
                for (let item of _data["supportsDesinvestis"])
                    this.supportsDesinvestis!.push(Support.fromJS(item));
            }
            if (Array.isArray(_data["supportsReinvestis"])) {
                this.supportsReinvestis = [] as any;
                for (let item of _data["supportsReinvestis"])
                    this.supportsReinvestis!.push(Support.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Arbitrage {
        data = typeof data === 'object' ? data : {};
        let result = new Arbitrage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["dateValeur"] = this.dateValeur ? this.dateValeur.toISOString() : <any>undefined;
        if (Array.isArray(this.supportsDesinvestis)) {
            data["supportsDesinvestis"] = [];
            for (let item of this.supportsDesinvestis)
                data["supportsDesinvestis"].push(item.toJSON());
        }
        if (Array.isArray(this.supportsReinvestis)) {
            data["supportsReinvestis"] = [];
            for (let item of this.supportsReinvestis)
                data["supportsReinvestis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArbitrage {
    numeroContrat?: number | undefined;
    dateValeur?: Date;
    supportsDesinvestis?: Support[] | undefined;
    supportsReinvestis?: Support[] | undefined;
}

export class CompositionPatrimoine implements ICompositionPatrimoine {
    id?: number | undefined;

    constructor(data?: ICompositionPatrimoine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CompositionPatrimoine {
        data = typeof data === 'object' ? data : {};
        let result = new CompositionPatrimoine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICompositionPatrimoine {
    id?: number | undefined;
}

export class CreationAdhesionDocument implements ICreationAdhesionDocument {
    NUM_DOSSIER?: string | undefined;
    NUM_SIGNATURE?: string | undefined;
    identite?: Identite2;
    questionnaire?: Questionnaire2;
    polices?: Police[] | undefined;
    transfertPacte?: TransfertPacte;
    mandatSEPA?: MandatSepa;

    constructor(data?: ICreationAdhesionDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.NUM_DOSSIER = _data["NUM_DOSSIER"];
            this.NUM_SIGNATURE = _data["NUM_SIGNATURE"];
            this.identite = _data["identite"] ? Identite2.fromJS(_data["identite"]) : <any>undefined;
            this.questionnaire = _data["questionnaire"] ? Questionnaire2.fromJS(_data["questionnaire"]) : <any>undefined;
            if (Array.isArray(_data["polices"])) {
                this.polices = [] as any;
                for (let item of _data["polices"])
                    this.polices!.push(Police.fromJS(item));
            }
            this.transfertPacte = _data["transfertPacte"] ? TransfertPacte.fromJS(_data["transfertPacte"]) : <any>undefined;
            this.mandatSEPA = _data["mandatSEPA"] ? MandatSepa.fromJS(_data["mandatSEPA"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreationAdhesionDocument {
        data = typeof data === 'object' ? data : {};
        let result = new CreationAdhesionDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NUM_DOSSIER"] = this.NUM_DOSSIER;
        data["NUM_SIGNATURE"] = this.NUM_SIGNATURE;
        data["identite"] = this.identite ? this.identite.toJSON() : <any>undefined;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : <any>undefined;
        if (Array.isArray(this.polices)) {
            data["polices"] = [];
            for (let item of this.polices)
                data["polices"].push(item.toJSON());
        }
        data["transfertPacte"] = this.transfertPacte ? this.transfertPacte.toJSON() : <any>undefined;
        data["mandatSEPA"] = this.mandatSEPA ? this.mandatSEPA.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreationAdhesionDocument {
    NUM_DOSSIER?: string | undefined;
    NUM_SIGNATURE?: string | undefined;
    identite?: Identite2;
    questionnaire?: Questionnaire2;
    polices?: Police[] | undefined;
    transfertPacte?: TransfertPacte;
    mandatSEPA?: MandatSepa;
}

export class DemandePrelevementImmediat implements IDemandePrelevementImmediat {
    numeroPolice?: number;
    montantPrelevement?: number;
    origineFonds?: string | undefined;
    IBAN?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
    supports?: Support[] | undefined;
    mandat?: Mandat;

    constructor(data?: IDemandePrelevementImmediat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroPolice = _data["numeroPolice"];
            this.montantPrelevement = _data["montantPrelevement"];
            this.origineFonds = _data["origineFonds"];
            this.IBAN = _data["IBAN"];
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.codeApporteur = _data["codeApporteur"];
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
            this.mandat = _data["mandat"] ? Mandat.fromJS(_data["mandat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DemandePrelevementImmediat {
        data = typeof data === 'object' ? data : {};
        let result = new DemandePrelevementImmediat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroPolice"] = this.numeroPolice;
        data["montantPrelevement"] = this.montantPrelevement;
        data["origineFonds"] = this.origineFonds;
        data["IBAN"] = this.IBAN;
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["codeApporteur"] = this.codeApporteur;
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        data["mandat"] = this.mandat ? this.mandat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDemandePrelevementImmediat {
    numeroPolice?: number;
    montantPrelevement?: number;
    origineFonds?: string | undefined;
    IBAN?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
    supports?: Support[] | undefined;
    mandat?: Mandat;
}

export class DemandeRachatPartiel implements IDemandeRachatPartiel {
    numeroContrat?: number;
    typeSinistre?: string | undefined;
    dateJour?: number;
    prelevementLib?: string | undefined;
    montant?: number;
    IBAN?: string | undefined;
    banque?: string | undefined;
    typeCompte?: string | undefined;
    idMotif?: number | undefined;
    motif?: string | undefined;
    supports?: Support[] | undefined;

    constructor(data?: IDemandeRachatPartiel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.typeSinistre = _data["typeSinistre"];
            this.dateJour = _data["dateJour"];
            this.prelevementLib = _data["prelevementLib"];
            this.montant = _data["montant"];
            this.IBAN = _data["IBAN"];
            this.banque = _data["banque"];
            this.typeCompte = _data["typeCompte"];
            this.idMotif = _data["idMotif"];
            this.motif = _data["motif"];
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DemandeRachatPartiel {
        data = typeof data === 'object' ? data : {};
        let result = new DemandeRachatPartiel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["typeSinistre"] = this.typeSinistre;
        data["dateJour"] = this.dateJour;
        data["prelevementLib"] = this.prelevementLib;
        data["montant"] = this.montant;
        data["IBAN"] = this.IBAN;
        data["banque"] = this.banque;
        data["typeCompte"] = this.typeCompte;
        data["idMotif"] = this.idMotif;
        data["motif"] = this.motif;
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDemandeRachatPartiel {
    numeroContrat?: number;
    typeSinistre?: string | undefined;
    dateJour?: number;
    prelevementLib?: string | undefined;
    montant?: number;
    IBAN?: string | undefined;
    banque?: string | undefined;
    typeCompte?: string | undefined;
    idMotif?: number | undefined;
    motif?: string | undefined;
    supports?: Support[] | undefined;
}

export class DocumentPOF implements IDocumentPOF {
    idProvenanceFonds?: number;
    dateTransaction?: Date;
    montantTransaction?: number;
    pieceJointe?: PieceJointe[] | undefined;

    constructor(data?: IDocumentPOF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idProvenanceFonds = _data["idProvenanceFonds"];
            this.dateTransaction = _data["dateTransaction"] ? new Date(_data["dateTransaction"].toString()) : <any>undefined;
            this.montantTransaction = _data["montantTransaction"];
            if (Array.isArray(_data["pieceJointe"])) {
                this.pieceJointe = [] as any;
                for (let item of _data["pieceJointe"])
                    this.pieceJointe!.push(PieceJointe.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentPOF {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPOF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idProvenanceFonds"] = this.idProvenanceFonds;
        data["dateTransaction"] = this.dateTransaction ? this.dateTransaction.toISOString() : <any>undefined;
        data["montantTransaction"] = this.montantTransaction;
        if (Array.isArray(this.pieceJointe)) {
            data["pieceJointe"] = [];
            for (let item of this.pieceJointe)
                data["pieceJointe"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentPOF {
    idProvenanceFonds?: number;
    dateTransaction?: Date;
    montantTransaction?: number;
    pieceJointe?: PieceJointe[] | undefined;
}

export class Erreur7 implements IErreur7 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur7 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur7 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class Identite2 implements IIdentite2 {
    autresPrenoms?: string | undefined;
    nomNaissance?: string | undefined;
    nomJeuneFille?: string | undefined;
    paysNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    villeNaissance?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    nomVille?: string | undefined;
    codeCommune?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    situationFamiliale?: number;
    nbEnfantsMoins16Ans?: number;
    nbEnfants16AnsOuPlus?: number;
    nbEnfantsACharge?: number;
    typeMatricule?: string | undefined;
    matricule?: string | undefined;
    statutSncf?: string | undefined;
    situationProfessionnelle?: number;
    situationFinanciere?: number;
    revenuFiscal?: string | undefined;
    situationPatrimoniale?: number;
    autreContrat?: number;
    motifSouscription?: number;
    secteurActivite?: number;
    sollicitationEmail?: boolean;
    sollicitationCourrier?: boolean;
    sollicitationSMS?: boolean;
    sollicitationPartenaire?: boolean;
    abonnePerformance?: boolean;
    abonneActualite?: boolean;
    stopPublicite?: boolean;
    politiquementExposee?: boolean;
    paysResidenceFiscaleCode?: string | undefined;
    compositionPatrimoine?: CompositionPatrimoine[] | undefined;
    compositionPatrimoines?: CompositionPatrimoine[] | undefined;
    compositionPatrimoineAutres?: string | undefined;
    regimeMatrimonial?: number;
    revenuMensuelNetFoyer?: number;
    contribuableAmericain?: boolean;
    fonctionPPE?: number;
    motifPPE?: number;
    type?: string | undefined;
    titre?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    nationalite?: number;
    dateNaissance?: Date;
    codePostal?: string | undefined;
    voie?: string | undefined;
    pays?: string | undefined;
    profession?: number;
    CSP?: number;
    numeroClientInterne?: number;
    numeroClientExterne?: string | undefined;
    numeroCRM?: string | undefined;
    BP?: boolean;
    extranetActif?: boolean;
    dateDerniereConnexionExtranet?: string | undefined;
    origineMarketing?: string | undefined;
    qualite?: number;
    profilPartenaire?: string | undefined;
    SIRET?: string | undefined;

    constructor(data?: IIdentite2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autresPrenoms = _data["autresPrenoms"];
            this.nomNaissance = _data["nomNaissance"];
            this.nomJeuneFille = _data["nomJeuneFille"];
            this.paysNaissance = _data["paysNaissance"];
            this.departementNaissance = _data["departementNaissance"];
            this.codePostalNaissance = _data["codePostalNaissance"];
            this.villeNaissance = _data["villeNaissance"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneProfessionnel = _data["telephoneProfessionnel"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.nomVille = _data["nomVille"];
            this.codeCommune = _data["codeCommune"];
            this.complement = _data["complement"];
            this.complement2 = _data["complement2"];
            this.lieudit = _data["lieudit"];
            this.situationFamiliale = _data["situationFamiliale"];
            this.nbEnfantsMoins16Ans = _data["nbEnfantsMoins16Ans"];
            this.nbEnfants16AnsOuPlus = _data["nbEnfants16AnsOuPlus"];
            this.nbEnfantsACharge = _data["nbEnfantsACharge"];
            this.typeMatricule = _data["typeMatricule"];
            this.matricule = _data["matricule"];
            this.statutSncf = _data["statutSncf"];
            this.situationProfessionnelle = _data["situationProfessionnelle"];
            this.situationFinanciere = _data["situationFinanciere"];
            this.revenuFiscal = _data["revenuFiscal"];
            this.situationPatrimoniale = _data["situationPatrimoniale"];
            this.autreContrat = _data["autreContrat"];
            this.motifSouscription = _data["motifSouscription"];
            this.secteurActivite = _data["secteurActivite"];
            this.sollicitationEmail = _data["sollicitationEmail"];
            this.sollicitationCourrier = _data["sollicitationCourrier"];
            this.sollicitationSMS = _data["sollicitationSMS"];
            this.sollicitationPartenaire = _data["sollicitationPartenaire"];
            this.abonnePerformance = _data["abonnePerformance"];
            this.abonneActualite = _data["abonneActualite"];
            this.stopPublicite = _data["stopPublicite"];
            this.politiquementExposee = _data["politiquementExposee"];
            this.paysResidenceFiscaleCode = _data["paysResidenceFiscaleCode"];
            if (Array.isArray(_data["compositionPatrimoine"])) {
                this.compositionPatrimoine = [] as any;
                for (let item of _data["compositionPatrimoine"])
                    this.compositionPatrimoine!.push(CompositionPatrimoine.fromJS(item));
            }
            if (Array.isArray(_data["compositionPatrimoines"])) {
                this.compositionPatrimoines = [] as any;
                for (let item of _data["compositionPatrimoines"])
                    this.compositionPatrimoines!.push(CompositionPatrimoine.fromJS(item));
            }
            this.compositionPatrimoineAutres = _data["compositionPatrimoineAutres"];
            this.regimeMatrimonial = _data["regimeMatrimonial"];
            this.revenuMensuelNetFoyer = _data["revenuMensuelNetFoyer"];
            this.contribuableAmericain = _data["contribuableAmericain"];
            this.fonctionPPE = _data["fonctionPPE"];
            this.motifPPE = _data["motifPPE"];
            this.type = _data["type"];
            this.titre = _data["titre"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.nationalite = _data["nationalite"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.codePostal = _data["codePostal"];
            this.voie = _data["voie"];
            this.pays = _data["pays"];
            this.profession = _data["profession"];
            this.CSP = _data["CSP"];
            this.numeroClientInterne = _data["numeroClientInterne"];
            this.numeroClientExterne = _data["numeroClientExterne"];
            this.numeroCRM = _data["numeroCRM"];
            this.BP = _data["BP"];
            this.extranetActif = _data["extranetActif"];
            this.dateDerniereConnexionExtranet = _data["dateDerniereConnexionExtranet"];
            this.origineMarketing = _data["origineMarketing"];
            this.qualite = _data["qualite"];
            this.profilPartenaire = _data["profilPartenaire"];
            this.SIRET = _data["SIRET"];
        }
    }

    static fromJS(data: any): Identite2 {
        data = typeof data === 'object' ? data : {};
        let result = new Identite2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autresPrenoms"] = this.autresPrenoms;
        data["nomNaissance"] = this.nomNaissance;
        data["nomJeuneFille"] = this.nomJeuneFille;
        data["paysNaissance"] = this.paysNaissance;
        data["departementNaissance"] = this.departementNaissance;
        data["codePostalNaissance"] = this.codePostalNaissance;
        data["villeNaissance"] = this.villeNaissance;
        data["telephoneFixe"] = this.telephoneFixe;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneProfessionnel"] = this.telephoneProfessionnel;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["nomVille"] = this.nomVille;
        data["codeCommune"] = this.codeCommune;
        data["complement"] = this.complement;
        data["complement2"] = this.complement2;
        data["lieudit"] = this.lieudit;
        data["situationFamiliale"] = this.situationFamiliale;
        data["nbEnfantsMoins16Ans"] = this.nbEnfantsMoins16Ans;
        data["nbEnfants16AnsOuPlus"] = this.nbEnfants16AnsOuPlus;
        data["nbEnfantsACharge"] = this.nbEnfantsACharge;
        data["typeMatricule"] = this.typeMatricule;
        data["matricule"] = this.matricule;
        data["statutSncf"] = this.statutSncf;
        data["situationProfessionnelle"] = this.situationProfessionnelle;
        data["situationFinanciere"] = this.situationFinanciere;
        data["revenuFiscal"] = this.revenuFiscal;
        data["situationPatrimoniale"] = this.situationPatrimoniale;
        data["autreContrat"] = this.autreContrat;
        data["motifSouscription"] = this.motifSouscription;
        data["secteurActivite"] = this.secteurActivite;
        data["sollicitationEmail"] = this.sollicitationEmail;
        data["sollicitationCourrier"] = this.sollicitationCourrier;
        data["sollicitationSMS"] = this.sollicitationSMS;
        data["sollicitationPartenaire"] = this.sollicitationPartenaire;
        data["abonnePerformance"] = this.abonnePerformance;
        data["abonneActualite"] = this.abonneActualite;
        data["stopPublicite"] = this.stopPublicite;
        data["politiquementExposee"] = this.politiquementExposee;
        data["paysResidenceFiscaleCode"] = this.paysResidenceFiscaleCode;
        if (Array.isArray(this.compositionPatrimoine)) {
            data["compositionPatrimoine"] = [];
            for (let item of this.compositionPatrimoine)
                data["compositionPatrimoine"].push(item.toJSON());
        }
        if (Array.isArray(this.compositionPatrimoines)) {
            data["compositionPatrimoines"] = [];
            for (let item of this.compositionPatrimoines)
                data["compositionPatrimoines"].push(item.toJSON());
        }
        data["compositionPatrimoineAutres"] = this.compositionPatrimoineAutres;
        data["regimeMatrimonial"] = this.regimeMatrimonial;
        data["revenuMensuelNetFoyer"] = this.revenuMensuelNetFoyer;
        data["contribuableAmericain"] = this.contribuableAmericain;
        data["fonctionPPE"] = this.fonctionPPE;
        data["motifPPE"] = this.motifPPE;
        data["type"] = this.type;
        data["titre"] = this.titre;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["nationalite"] = this.nationalite;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["codePostal"] = this.codePostal;
        data["voie"] = this.voie;
        data["pays"] = this.pays;
        data["profession"] = this.profession;
        data["CSP"] = this.CSP;
        data["numeroClientInterne"] = this.numeroClientInterne;
        data["numeroClientExterne"] = this.numeroClientExterne;
        data["numeroCRM"] = this.numeroCRM;
        data["BP"] = this.BP;
        data["extranetActif"] = this.extranetActif;
        data["dateDerniereConnexionExtranet"] = this.dateDerniereConnexionExtranet;
        data["origineMarketing"] = this.origineMarketing;
        data["qualite"] = this.qualite;
        data["profilPartenaire"] = this.profilPartenaire;
        data["SIRET"] = this.SIRET;
        return data;
    }
}

export interface IIdentite2 {
    autresPrenoms?: string | undefined;
    nomNaissance?: string | undefined;
    nomJeuneFille?: string | undefined;
    paysNaissance?: string | undefined;
    departementNaissance?: string | undefined;
    codePostalNaissance?: string | undefined;
    villeNaissance?: string | undefined;
    telephoneFixe?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneProfessionnel?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    nomVille?: string | undefined;
    codeCommune?: string | undefined;
    complement?: string | undefined;
    complement2?: string | undefined;
    lieudit?: string | undefined;
    situationFamiliale?: number;
    nbEnfantsMoins16Ans?: number;
    nbEnfants16AnsOuPlus?: number;
    nbEnfantsACharge?: number;
    typeMatricule?: string | undefined;
    matricule?: string | undefined;
    statutSncf?: string | undefined;
    situationProfessionnelle?: number;
    situationFinanciere?: number;
    revenuFiscal?: string | undefined;
    situationPatrimoniale?: number;
    autreContrat?: number;
    motifSouscription?: number;
    secteurActivite?: number;
    sollicitationEmail?: boolean;
    sollicitationCourrier?: boolean;
    sollicitationSMS?: boolean;
    sollicitationPartenaire?: boolean;
    abonnePerformance?: boolean;
    abonneActualite?: boolean;
    stopPublicite?: boolean;
    politiquementExposee?: boolean;
    paysResidenceFiscaleCode?: string | undefined;
    compositionPatrimoine?: CompositionPatrimoine[] | undefined;
    compositionPatrimoines?: CompositionPatrimoine[] | undefined;
    compositionPatrimoineAutres?: string | undefined;
    regimeMatrimonial?: number;
    revenuMensuelNetFoyer?: number;
    contribuableAmericain?: boolean;
    fonctionPPE?: number;
    motifPPE?: number;
    type?: string | undefined;
    titre?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    nationalite?: number;
    dateNaissance?: Date;
    codePostal?: string | undefined;
    voie?: string | undefined;
    pays?: string | undefined;
    profession?: number;
    CSP?: number;
    numeroClientInterne?: number;
    numeroClientExterne?: string | undefined;
    numeroCRM?: string | undefined;
    BP?: boolean;
    extranetActif?: boolean;
    dateDerniereConnexionExtranet?: string | undefined;
    origineMarketing?: string | undefined;
    qualite?: number;
    profilPartenaire?: string | undefined;
    SIRET?: string | undefined;
}

export class Mandat implements IMandat {
    RUM?: string | undefined;
    dateSignature?: Date;

    constructor(data?: IMandat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.RUM = _data["RUM"];
            this.dateSignature = _data["dateSignature"] ? new Date(_data["dateSignature"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Mandat {
        data = typeof data === 'object' ? data : {};
        let result = new Mandat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RUM"] = this.RUM;
        data["dateSignature"] = this.dateSignature ? this.dateSignature.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMandat {
    RUM?: string | undefined;
    dateSignature?: Date;
}

export class MandatSepa implements IMandatSepa {
    idCrediteur?: string | undefined;
    nomCrediteur?: string | undefined;
    RUM?: string | undefined;
    dateSignature?: Date;
    lieuSignature?: string | undefined;
    numeroSocietaireInterne?: number;
    numeroSocietaireExterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    IBAN?: string | undefined;
    codeBIC?: string | undefined;
    adresse?: string | undefined;
    adresseComp?: string | undefined;
    adresseComp2?: string | undefined;
    lieuDit?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IMandatSepa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idCrediteur = _data["idCrediteur"];
            this.nomCrediteur = _data["nomCrediteur"];
            this.RUM = _data["RUM"];
            this.dateSignature = _data["dateSignature"] ? new Date(_data["dateSignature"].toString()) : <any>undefined;
            this.lieuSignature = _data["lieuSignature"];
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
            this.numeroSocietaireExterne = _data["numeroSocietaireExterne"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.IBAN = _data["IBAN"];
            this.codeBIC = _data["codeBIC"];
            this.adresse = _data["adresse"];
            this.adresseComp = _data["adresseComp"];
            this.adresseComp2 = _data["adresseComp2"];
            this.lieuDit = _data["lieuDit"];
            this.codePostal = _data["codePostal"];
            this.ville = _data["ville"];
            this.pays = _data["pays"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): MandatSepa {
        data = typeof data === 'object' ? data : {};
        let result = new MandatSepa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCrediteur"] = this.idCrediteur;
        data["nomCrediteur"] = this.nomCrediteur;
        data["RUM"] = this.RUM;
        data["dateSignature"] = this.dateSignature ? this.dateSignature.toISOString() : <any>undefined;
        data["lieuSignature"] = this.lieuSignature;
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        data["numeroSocietaireExterne"] = this.numeroSocietaireExterne;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["IBAN"] = this.IBAN;
        data["codeBIC"] = this.codeBIC;
        data["adresse"] = this.adresse;
        data["adresseComp"] = this.adresseComp;
        data["adresseComp2"] = this.adresseComp2;
        data["lieuDit"] = this.lieuDit;
        data["codePostal"] = this.codePostal;
        data["ville"] = this.ville;
        data["pays"] = this.pays;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        return data;
    }
}

export interface IMandatSepa {
    idCrediteur?: string | undefined;
    nomCrediteur?: string | undefined;
    RUM?: string | undefined;
    dateSignature?: Date;
    lieuSignature?: string | undefined;
    numeroSocietaireInterne?: number;
    numeroSocietaireExterne?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    IBAN?: string | undefined;
    codeBIC?: string | undefined;
    adresse?: string | undefined;
    adresseComp?: string | undefined;
    adresseComp2?: string | undefined;
    lieuDit?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
}

export class MiseEnPlaceVersemementProgramme implements IMiseEnPlaceVersemementProgramme {
    numeroContrat?: number;
    mntVersementProgramme?: number;
    IBAN?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
    supports?: Support[] | undefined;
    mandat?: Mandat;

    constructor(data?: IMiseEnPlaceVersemementProgramme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.mntVersementProgramme = _data["mntVersementProgramme"];
            this.IBAN = _data["IBAN"];
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.codeApporteur = _data["codeApporteur"];
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
            this.mandat = _data["mandat"] ? Mandat.fromJS(_data["mandat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MiseEnPlaceVersemementProgramme {
        data = typeof data === 'object' ? data : {};
        let result = new MiseEnPlaceVersemementProgramme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["mntVersementProgramme"] = this.mntVersementProgramme;
        data["IBAN"] = this.IBAN;
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["codeApporteur"] = this.codeApporteur;
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        data["mandat"] = this.mandat ? this.mandat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMiseEnPlaceVersemementProgramme {
    numeroContrat?: number;
    mntVersementProgramme?: number;
    IBAN?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
    supports?: Support[] | undefined;
    mandat?: Mandat;
}

export class ModificationHorizonCERU implements IModificationHorizonCERU {
    numeroContrat?: number;
    horizonActuel?: number;
    horizonNouveau?: number;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;

    constructor(data?: IModificationHorizonCERU) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.horizonActuel = _data["horizonActuel"];
            this.horizonNouveau = _data["horizonNouveau"];
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.codeApporteur = _data["codeApporteur"];
        }
    }

    static fromJS(data: any): ModificationHorizonCERU {
        data = typeof data === 'object' ? data : {};
        let result = new ModificationHorizonCERU();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["horizonActuel"] = this.horizonActuel;
        data["horizonNouveau"] = this.horizonNouveau;
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["codeApporteur"] = this.codeApporteur;
        return data;
    }
}

export interface IModificationHorizonCERU {
    numeroContrat?: number;
    horizonActuel?: number;
    horizonNouveau?: number;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
}

export class ModificationVersementProgramme implements IModificationVersementProgramme {
    numeroContrat?: number;
    mntVersementProgrammeActuel?: number;
    mntVersementProgrammeNouveau?: number;
    IBAN?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
    supports?: Support[] | undefined;
    mandat?: Mandat;

    constructor(data?: IModificationVersementProgramme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.mntVersementProgrammeActuel = _data["mntVersementProgrammeActuel"];
            this.mntVersementProgrammeNouveau = _data["mntVersementProgrammeNouveau"];
            this.IBAN = _data["IBAN"];
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.codeApporteur = _data["codeApporteur"];
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
            this.mandat = _data["mandat"] ? Mandat.fromJS(_data["mandat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ModificationVersementProgramme {
        data = typeof data === 'object' ? data : {};
        let result = new ModificationVersementProgramme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["mntVersementProgrammeActuel"] = this.mntVersementProgrammeActuel;
        data["mntVersementProgrammeNouveau"] = this.mntVersementProgrammeNouveau;
        data["IBAN"] = this.IBAN;
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["codeApporteur"] = this.codeApporteur;
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        data["mandat"] = this.mandat ? this.mandat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IModificationVersementProgramme {
    numeroContrat?: number;
    mntVersementProgrammeActuel?: number;
    mntVersementProgrammeNouveau?: number;
    IBAN?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
    supports?: Support[] | undefined;
    mandat?: Mandat;
}

export class PieceJointe implements IPieceJointe {
    idTypeDocumentGED?: number;
    dateEmission?: Date;
    dateFinValidite?: Date;
    fichierAttache?: string | undefined;

    constructor(data?: IPieceJointe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocumentGED = _data["idTypeDocumentGED"];
            this.dateEmission = _data["dateEmission"] ? new Date(_data["dateEmission"].toString()) : <any>undefined;
            this.dateFinValidite = _data["dateFinValidite"] ? new Date(_data["dateFinValidite"].toString()) : <any>undefined;
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): PieceJointe {
        data = typeof data === 'object' ? data : {};
        let result = new PieceJointe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocumentGED"] = this.idTypeDocumentGED;
        data["dateEmission"] = this.dateEmission ? this.dateEmission.toISOString() : <any>undefined;
        data["dateFinValidite"] = this.dateFinValidite ? this.dateFinValidite.toISOString() : <any>undefined;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IPieceJointe {
    idTypeDocumentGED?: number;
    dateEmission?: Date;
    dateFinValidite?: Date;
    fichierAttache?: string | undefined;
}

export class Police implements IPolice {
    codeProduit?: string | undefined;
    noAssure?: number;
    noContractant?: number | undefined;
    noPayeur?: number | undefined;
    periodicite?: string | undefined;
    fractionnement?: string | undefined;
    modePaiement?: string | undefined;
    unitePrelevement?: string | undefined;
    montantVersement?: number | undefined;
    rib?: string | undefined;
    domiciliation?: string | undefined;
    bic?: string | undefined;
    rum?: string | undefined;
    dateSignature?: Date;
    dateEffet?: Date | undefined;
    dureeContrat?: number | undefined;
    dureePaiement?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    parrainage?: string | undefined;
    noParrain?: number | undefined;
    noPoliceParrain?: number | undefined;
    codeApporteur?: number | undefined;
    noEncaissement?: number | undefined;
    premierePrime?: string | undefined;
    prelevementImmediat?: string | undefined;
    montantPrelevementImmediat?: number | undefined;
    datePrelevementImmediat?: Date | undefined;
    tauxRevalo?: number | undefined;
    capitalSouscrit?: number | undefined;
    idModeGestion?: number | undefined;
    idMandatGestion?: number | undefined;
    dureeTerme?: number | undefined;
    codeRedacteur?: string | undefined;
    dateCreation?: Date;
    policeBeneficiaires?: PoliceBeneficiaire[] | undefined;
    supports?: Support[] | undefined;
    policeGarantiesOptionnelles?: PoliceGarantieOpt[] | undefined;

    constructor(data?: IPolice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.noAssure = _data["noAssure"];
            this.noContractant = _data["noContractant"];
            this.noPayeur = _data["noPayeur"];
            this.periodicite = _data["periodicite"];
            this.fractionnement = _data["fractionnement"];
            this.modePaiement = _data["modePaiement"];
            this.unitePrelevement = _data["unitePrelevement"];
            this.montantVersement = _data["montantVersement"];
            this.rib = _data["rib"];
            this.domiciliation = _data["domiciliation"];
            this.bic = _data["bic"];
            this.rum = _data["rum"];
            this.dateSignature = _data["dateSignature"] ? new Date(_data["dateSignature"].toString()) : <any>undefined;
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : <any>undefined;
            this.dureeContrat = _data["dureeContrat"];
            this.dureePaiement = _data["dureePaiement"];
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.parrainage = _data["parrainage"];
            this.noParrain = _data["noParrain"];
            this.noPoliceParrain = _data["noPoliceParrain"];
            this.codeApporteur = _data["codeApporteur"];
            this.noEncaissement = _data["noEncaissement"];
            this.premierePrime = _data["premierePrime"];
            this.prelevementImmediat = _data["prelevementImmediat"];
            this.montantPrelevementImmediat = _data["montantPrelevementImmediat"];
            this.datePrelevementImmediat = _data["datePrelevementImmediat"] ? new Date(_data["datePrelevementImmediat"].toString()) : <any>undefined;
            this.tauxRevalo = _data["tauxRevalo"];
            this.capitalSouscrit = _data["capitalSouscrit"];
            this.idModeGestion = _data["idModeGestion"];
            this.idMandatGestion = _data["idMandatGestion"];
            this.dureeTerme = _data["dureeTerme"];
            this.codeRedacteur = _data["codeRedacteur"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : <any>undefined;
            if (Array.isArray(_data["policeBeneficiaires"])) {
                this.policeBeneficiaires = [] as any;
                for (let item of _data["policeBeneficiaires"])
                    this.policeBeneficiaires!.push(PoliceBeneficiaire.fromJS(item));
            }
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support.fromJS(item));
            }
            if (Array.isArray(_data["policeGarantiesOptionnelles"])) {
                this.policeGarantiesOptionnelles = [] as any;
                for (let item of _data["policeGarantiesOptionnelles"])
                    this.policeGarantiesOptionnelles!.push(PoliceGarantieOpt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Police {
        data = typeof data === 'object' ? data : {};
        let result = new Police();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["noAssure"] = this.noAssure;
        data["noContractant"] = this.noContractant;
        data["noPayeur"] = this.noPayeur;
        data["periodicite"] = this.periodicite;
        data["fractionnement"] = this.fractionnement;
        data["modePaiement"] = this.modePaiement;
        data["unitePrelevement"] = this.unitePrelevement;
        data["montantVersement"] = this.montantVersement;
        data["rib"] = this.rib;
        data["domiciliation"] = this.domiciliation;
        data["bic"] = this.bic;
        data["rum"] = this.rum;
        data["dateSignature"] = this.dateSignature ? this.dateSignature.toISOString() : <any>undefined;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : <any>undefined;
        data["dureeContrat"] = this.dureeContrat;
        data["dureePaiement"] = this.dureePaiement;
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["parrainage"] = this.parrainage;
        data["noParrain"] = this.noParrain;
        data["noPoliceParrain"] = this.noPoliceParrain;
        data["codeApporteur"] = this.codeApporteur;
        data["noEncaissement"] = this.noEncaissement;
        data["premierePrime"] = this.premierePrime;
        data["prelevementImmediat"] = this.prelevementImmediat;
        data["montantPrelevementImmediat"] = this.montantPrelevementImmediat;
        data["datePrelevementImmediat"] = this.datePrelevementImmediat ? this.datePrelevementImmediat.toISOString() : <any>undefined;
        data["tauxRevalo"] = this.tauxRevalo;
        data["capitalSouscrit"] = this.capitalSouscrit;
        data["idModeGestion"] = this.idModeGestion;
        data["idMandatGestion"] = this.idMandatGestion;
        data["dureeTerme"] = this.dureeTerme;
        data["codeRedacteur"] = this.codeRedacteur;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : <any>undefined;
        if (Array.isArray(this.policeBeneficiaires)) {
            data["policeBeneficiaires"] = [];
            for (let item of this.policeBeneficiaires)
                data["policeBeneficiaires"].push(item.toJSON());
        }
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        if (Array.isArray(this.policeGarantiesOptionnelles)) {
            data["policeGarantiesOptionnelles"] = [];
            for (let item of this.policeGarantiesOptionnelles)
                data["policeGarantiesOptionnelles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolice {
    codeProduit?: string | undefined;
    noAssure?: number;
    noContractant?: number | undefined;
    noPayeur?: number | undefined;
    periodicite?: string | undefined;
    fractionnement?: string | undefined;
    modePaiement?: string | undefined;
    unitePrelevement?: string | undefined;
    montantVersement?: number | undefined;
    rib?: string | undefined;
    domiciliation?: string | undefined;
    bic?: string | undefined;
    rum?: string | undefined;
    dateSignature?: Date;
    dateEffet?: Date | undefined;
    dureeContrat?: number | undefined;
    dureePaiement?: string | undefined;
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    parrainage?: string | undefined;
    noParrain?: number | undefined;
    noPoliceParrain?: number | undefined;
    codeApporteur?: number | undefined;
    noEncaissement?: number | undefined;
    premierePrime?: string | undefined;
    prelevementImmediat?: string | undefined;
    montantPrelevementImmediat?: number | undefined;
    datePrelevementImmediat?: Date | undefined;
    tauxRevalo?: number | undefined;
    capitalSouscrit?: number | undefined;
    idModeGestion?: number | undefined;
    idMandatGestion?: number | undefined;
    dureeTerme?: number | undefined;
    codeRedacteur?: string | undefined;
    dateCreation?: Date;
    policeBeneficiaires?: PoliceBeneficiaire[] | undefined;
    supports?: Support[] | undefined;
    policeGarantiesOptionnelles?: PoliceGarantieOpt[] | undefined;
}

export class PoliceBeneficiaire implements IPoliceBeneficiaire {
    codeBeneficiaire?: string | undefined;
    noBeneficiaire?: number | undefined;
    clauseBeneficiaire?: string | undefined;
    repartBeneficiaire?: number;
    typeRisqueBeneficiaire?: string | undefined;

    constructor(data?: IPoliceBeneficiaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeBeneficiaire = _data["codeBeneficiaire"];
            this.noBeneficiaire = _data["noBeneficiaire"];
            this.clauseBeneficiaire = _data["clauseBeneficiaire"];
            this.repartBeneficiaire = _data["repartBeneficiaire"];
            this.typeRisqueBeneficiaire = _data["typeRisqueBeneficiaire"];
        }
    }

    static fromJS(data: any): PoliceBeneficiaire {
        data = typeof data === 'object' ? data : {};
        let result = new PoliceBeneficiaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeBeneficiaire"] = this.codeBeneficiaire;
        data["noBeneficiaire"] = this.noBeneficiaire;
        data["clauseBeneficiaire"] = this.clauseBeneficiaire;
        data["repartBeneficiaire"] = this.repartBeneficiaire;
        data["typeRisqueBeneficiaire"] = this.typeRisqueBeneficiaire;
        return data;
    }
}

export interface IPoliceBeneficiaire {
    codeBeneficiaire?: string | undefined;
    noBeneficiaire?: number | undefined;
    clauseBeneficiaire?: string | undefined;
    repartBeneficiaire?: number;
    typeRisqueBeneficiaire?: string | undefined;
}

export class PoliceGarantieOpt implements IPoliceGarantieOpt {
    garantiesOpt?: string | undefined;
    tauxRepartitionVL?: number | undefined;

    constructor(data?: IPoliceGarantieOpt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.garantiesOpt = _data["garantiesOpt"];
            this.tauxRepartitionVL = _data["tauxRepartitionVL"];
        }
    }

    static fromJS(data: any): PoliceGarantieOpt {
        data = typeof data === 'object' ? data : {};
        let result = new PoliceGarantieOpt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["garantiesOpt"] = this.garantiesOpt;
        data["tauxRepartitionVL"] = this.tauxRepartitionVL;
        return data;
    }
}

export interface IPoliceGarantieOpt {
    garantiesOpt?: string | undefined;
    tauxRepartitionVL?: number | undefined;
}

export class Questionnaire2 implements IQuestionnaire2 {
    numeroCRM?: string | undefined;
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean | undefined;
    echeancePrecise?: boolean | undefined;
    codeContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    choixPersonne?: string | undefined;
    suiviRecommandation?: boolean | undefined;
    reponsesDonnees?: ReponseDonnee2[] | undefined;

    constructor(data?: IQuestionnaire2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroCRM = _data["numeroCRM"];
            this.dateQuestionnaire = _data["dateQuestionnaire"] ? new Date(_data["dateQuestionnaire"].toString()) : <any>undefined;
            this.lieuQuestionnaire = _data["lieuQuestionnaire"];
            this.identifiantDemarche = _data["identifiantDemarche"];
            this.identifiantQuestionnaire = _data["identifiantQuestionnaire"];
            this.score = _data["score"];
            this.profil = _data["profil"];
            this.descriptionProfil = _data["descriptionProfil"];
            this.codeContratCible = _data["codeContratCible"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.codeContratRecommande = _data["codeContratRecommande"];
            this.recommandation = _data["recommandation"];
            this.choixPersonne = _data["choixPersonne"];
            this.suiviRecommandation = _data["suiviRecommandation"];
            if (Array.isArray(_data["reponsesDonnees"])) {
                this.reponsesDonnees = [] as any;
                for (let item of _data["reponsesDonnees"])
                    this.reponsesDonnees!.push(ReponseDonnee2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Questionnaire2 {
        data = typeof data === 'object' ? data : {};
        let result = new Questionnaire2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroCRM"] = this.numeroCRM;
        data["dateQuestionnaire"] = this.dateQuestionnaire ? this.dateQuestionnaire.toISOString() : <any>undefined;
        data["lieuQuestionnaire"] = this.lieuQuestionnaire;
        data["identifiantDemarche"] = this.identifiantDemarche;
        data["identifiantQuestionnaire"] = this.identifiantQuestionnaire;
        data["score"] = this.score;
        data["profil"] = this.profil;
        data["descriptionProfil"] = this.descriptionProfil;
        data["codeContratCible"] = this.codeContratCible;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["echeancePrecise"] = this.echeancePrecise;
        data["codeContratRecommande"] = this.codeContratRecommande;
        data["recommandation"] = this.recommandation;
        data["choixPersonne"] = this.choixPersonne;
        data["suiviRecommandation"] = this.suiviRecommandation;
        if (Array.isArray(this.reponsesDonnees)) {
            data["reponsesDonnees"] = [];
            for (let item of this.reponsesDonnees)
                data["reponsesDonnees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionnaire2 {
    numeroCRM?: string | undefined;
    dateQuestionnaire?: Date | undefined;
    lieuQuestionnaire?: string | undefined;
    identifiantDemarche?: number | undefined;
    identifiantQuestionnaire?: number | undefined;
    score?: number | undefined;
    profil?: string | undefined;
    descriptionProfil?: string | undefined;
    codeContratCible?: string | undefined;
    souscriptionProfitEnfant?: boolean | undefined;
    echeancePrecise?: boolean | undefined;
    codeContratRecommande?: string | undefined;
    recommandation?: string | undefined;
    choixPersonne?: string | undefined;
    suiviRecommandation?: boolean | undefined;
    reponsesDonnees?: ReponseDonnee2[] | undefined;
}

export class ReponseDonnee2 implements IReponseDonnee2 {
    identifiantQuestion?: number | undefined;
    identifiantReponse?: number | undefined;

    constructor(data?: IReponseDonnee2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiantQuestion = _data["identifiantQuestion"];
            this.identifiantReponse = _data["identifiantReponse"];
        }
    }

    static fromJS(data: any): ReponseDonnee2 {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseDonnee2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiantQuestion"] = this.identifiantQuestion;
        data["identifiantReponse"] = this.identifiantReponse;
        return data;
    }
}

export interface IReponseDonnee2 {
    identifiantQuestion?: number | undefined;
    identifiantReponse?: number | undefined;
}

export class SendDemandeAdhesionRequest implements ISendDemandeAdhesionRequest {
    adhesion?: CreationAdhesionDocument;
    piecesJointes?: PieceJointe[] | undefined;
    idCanal?: number | undefined;

    constructor(data?: ISendDemandeAdhesionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adhesion = _data["adhesion"] ? CreationAdhesionDocument.fromJS(_data["adhesion"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            this.idCanal = _data["idCanal"];
        }
    }

    static fromJS(data: any): SendDemandeAdhesionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeAdhesionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adhesion"] = this.adhesion ? this.adhesion.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        data["idCanal"] = this.idCanal;
        return data;
    }
}

export interface ISendDemandeAdhesionRequest {
    adhesion?: CreationAdhesionDocument;
    piecesJointes?: PieceJointe[] | undefined;
    idCanal?: number | undefined;
}

export class SendDemandeAdhesionResponse implements ISendDemandeAdhesionResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeAdhesionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeAdhesionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeAdhesionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeAdhesionResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandeAjoutCoordonneeBancaireRequest implements ISendDemandeAjoutCoordonneeBancaireRequest {
    ajoutCoordonneeBancaire?: AjoutCoordonneeBancaire;
    piecesJointes?: PieceJointe[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandeAjoutCoordonneeBancaireRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ajoutCoordonneeBancaire = _data["ajoutCoordonneeBancaire"] ? AjoutCoordonneeBancaire.fromJS(_data["ajoutCoordonneeBancaire"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandeAjoutCoordonneeBancaireRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeAjoutCoordonneeBancaireRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ajoutCoordonneeBancaire"] = this.ajoutCoordonneeBancaire ? this.ajoutCoordonneeBancaire.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandeAjoutCoordonneeBancaireRequest {
    ajoutCoordonneeBancaire?: AjoutCoordonneeBancaire;
    piecesJointes?: PieceJointe[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;
}

export class SendDemandeAjoutCoordonneeBancaireResponse implements ISendDemandeAjoutCoordonneeBancaireResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeAjoutCoordonneeBancaireResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeAjoutCoordonneeBancaireResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeAjoutCoordonneeBancaireResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeAjoutCoordonneeBancaireResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandeArbitrageRequest implements ISendDemandeArbitrageRequest {
    arbitrage?: Arbitrage;
    piecesJointes?: PieceJointe[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandeArbitrageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arbitrage = _data["arbitrage"] ? Arbitrage.fromJS(_data["arbitrage"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandeArbitrageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeArbitrageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arbitrage"] = this.arbitrage ? this.arbitrage.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandeArbitrageRequest {
    arbitrage?: Arbitrage;
    piecesJointes?: PieceJointe[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;
}

export class SendDemandeArbitrageResponse implements ISendDemandeArbitrageResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeArbitrageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeArbitrageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeArbitrageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeArbitrageResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandeMiseEnPlaceVersementProgrammeRequest implements ISendDemandeMiseEnPlaceVersementProgrammeRequest {
    miseEnPlaceVersementProgramme?: MiseEnPlaceVersemementProgramme;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandeMiseEnPlaceVersementProgrammeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.miseEnPlaceVersementProgramme = _data["miseEnPlaceVersementProgramme"] ? MiseEnPlaceVersemementProgramme.fromJS(_data["miseEnPlaceVersementProgramme"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            if (Array.isArray(_data["documentsPOF"])) {
                this.documentsPOF = [] as any;
                for (let item of _data["documentsPOF"])
                    this.documentsPOF!.push(DocumentPOF.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandeMiseEnPlaceVersementProgrammeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeMiseEnPlaceVersementProgrammeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["miseEnPlaceVersementProgramme"] = this.miseEnPlaceVersementProgramme ? this.miseEnPlaceVersementProgramme.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        if (Array.isArray(this.documentsPOF)) {
            data["documentsPOF"] = [];
            for (let item of this.documentsPOF)
                data["documentsPOF"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandeMiseEnPlaceVersementProgrammeRequest {
    miseEnPlaceVersementProgramme?: MiseEnPlaceVersemementProgramme;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;
}

export class SendDemandeMiseEnPlaceVersementProgrammeResponse implements ISendDemandeMiseEnPlaceVersementProgrammeResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeMiseEnPlaceVersementProgrammeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeMiseEnPlaceVersementProgrammeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeMiseEnPlaceVersementProgrammeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeMiseEnPlaceVersementProgrammeResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandeModificationHorizonCERURequest implements ISendDemandeModificationHorizonCERURequest {
    modificationHorizonCERU?: ModificationHorizonCERU;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandeModificationHorizonCERURequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modificationHorizonCERU = _data["modificationHorizonCERU"] ? ModificationHorizonCERU.fromJS(_data["modificationHorizonCERU"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            if (Array.isArray(_data["documentsPOF"])) {
                this.documentsPOF = [] as any;
                for (let item of _data["documentsPOF"])
                    this.documentsPOF!.push(DocumentPOF.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandeModificationHorizonCERURequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeModificationHorizonCERURequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modificationHorizonCERU"] = this.modificationHorizonCERU ? this.modificationHorizonCERU.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        if (Array.isArray(this.documentsPOF)) {
            data["documentsPOF"] = [];
            for (let item of this.documentsPOF)
                data["documentsPOF"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandeModificationHorizonCERURequest {
    modificationHorizonCERU?: ModificationHorizonCERU;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;
}

export class SendDemandeModificationHorizonCERUResponse implements ISendDemandeModificationHorizonCERUResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeModificationHorizonCERUResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeModificationHorizonCERUResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeModificationHorizonCERUResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeModificationHorizonCERUResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandeModificationVersementProgrammeRequest implements ISendDemandeModificationVersementProgrammeRequest {
    modificationVersementProgramme?: ModificationVersementProgramme;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandeModificationVersementProgrammeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modificationVersementProgramme = _data["modificationVersementProgramme"] ? ModificationVersementProgramme.fromJS(_data["modificationVersementProgramme"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            if (Array.isArray(_data["documentsPOF"])) {
                this.documentsPOF = [] as any;
                for (let item of _data["documentsPOF"])
                    this.documentsPOF!.push(DocumentPOF.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandeModificationVersementProgrammeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeModificationVersementProgrammeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modificationVersementProgramme"] = this.modificationVersementProgramme ? this.modificationVersementProgramme.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        if (Array.isArray(this.documentsPOF)) {
            data["documentsPOF"] = [];
            for (let item of this.documentsPOF)
                data["documentsPOF"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandeModificationVersementProgrammeRequest {
    modificationVersementProgramme?: ModificationVersementProgramme;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;
}

export class SendDemandeModificationVersementProgrammeResponse implements ISendDemandeModificationVersementProgrammeResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeModificationVersementProgrammeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeModificationVersementProgrammeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeModificationVersementProgrammeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeModificationVersementProgrammeResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandePrelevementImmediatRequest implements ISendDemandePrelevementImmediatRequest {
    prelevementImmediat?: DemandePrelevementImmediat;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandePrelevementImmediatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prelevementImmediat = _data["prelevementImmediat"] ? DemandePrelevementImmediat.fromJS(_data["prelevementImmediat"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            if (Array.isArray(_data["documentsPOF"])) {
                this.documentsPOF = [] as any;
                for (let item of _data["documentsPOF"])
                    this.documentsPOF!.push(DocumentPOF.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandePrelevementImmediatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandePrelevementImmediatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prelevementImmediat"] = this.prelevementImmediat ? this.prelevementImmediat.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        if (Array.isArray(this.documentsPOF)) {
            data["documentsPOF"] = [];
            for (let item of this.documentsPOF)
                data["documentsPOF"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandePrelevementImmediatRequest {
    prelevementImmediat?: DemandePrelevementImmediat;
    piecesJointes?: PieceJointe[] | undefined;
    documentsPOF?: DocumentPOF[] | undefined;
    societaire?: Societaire;
    idCanal?: number | undefined;
    typeContrat?: string | undefined;
    dossierComplet?: boolean | undefined;
    modeTest?: boolean | undefined;
}

export class SendDemandePrelevementImmediatResponse implements ISendDemandePrelevementImmediatResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandePrelevementImmediatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandePrelevementImmediatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandePrelevementImmediatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandePrelevementImmediatResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class SendDemandeRachatPartielRequest implements ISendDemandeRachatPartielRequest {
    rachatPartiel?: DemandeRachatPartiel;
    piecesJointes?: PieceJointe[] | undefined;
    societaire?: Societaire;
    idCanal?: number;
    typeContrat?: string | undefined;
    dossierComplet?: boolean;
    modeTest?: boolean | undefined;

    constructor(data?: ISendDemandeRachatPartielRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rachatPartiel = _data["rachatPartiel"] ? DemandeRachatPartiel.fromJS(_data["rachatPartiel"]) : <any>undefined;
            if (Array.isArray(_data["piecesJointes"])) {
                this.piecesJointes = [] as any;
                for (let item of _data["piecesJointes"])
                    this.piecesJointes!.push(PieceJointe.fromJS(item));
            }
            this.societaire = _data["societaire"] ? Societaire.fromJS(_data["societaire"]) : <any>undefined;
            this.idCanal = _data["idCanal"];
            this.typeContrat = _data["typeContrat"];
            this.dossierComplet = _data["dossierComplet"];
            this.modeTest = _data["modeTest"];
        }
    }

    static fromJS(data: any): SendDemandeRachatPartielRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeRachatPartielRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rachatPartiel"] = this.rachatPartiel ? this.rachatPartiel.toJSON() : <any>undefined;
        if (Array.isArray(this.piecesJointes)) {
            data["piecesJointes"] = [];
            for (let item of this.piecesJointes)
                data["piecesJointes"].push(item.toJSON());
        }
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        data["idCanal"] = this.idCanal;
        data["typeContrat"] = this.typeContrat;
        data["dossierComplet"] = this.dossierComplet;
        data["modeTest"] = this.modeTest;
        return data;
    }
}

export interface ISendDemandeRachatPartielRequest {
    rachatPartiel?: DemandeRachatPartiel;
    piecesJointes?: PieceJointe[] | undefined;
    societaire?: Societaire;
    idCanal?: number;
    typeContrat?: string | undefined;
    dossierComplet?: boolean;
    modeTest?: boolean | undefined;
}

export class SendDemandeRachatPartielResponse implements ISendDemandeRachatPartielResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;

    constructor(data?: ISendDemandeRachatPartielResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.numeroDemande = _data["numeroDemande"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendDemandeRachatPartielResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDemandeRachatPartielResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["numeroDemande"] = this.numeroDemande;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISendDemandeRachatPartielResponse {
    codeRetour?: number | undefined;
    numeroDemande?: number;
    erreurs?: Erreur7[] | undefined;
}

export class Societaire implements ISocietaire {
    numeroInterne?: number;
    telephoneMobile?: string | undefined;
    email?: string | undefined;

    constructor(data?: ISocietaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Societaire {
        data = typeof data === 'object' ? data : {};
        let result = new Societaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["telephoneMobile"] = this.telephoneMobile;
        data["email"] = this.email;
        return data;
    }
}

export interface ISocietaire {
    numeroInterne?: number;
    telephoneMobile?: string | undefined;
    email?: string | undefined;
}

export class Support implements ISupport {
    codeISIN?: string | undefined;
    montant?: number;
    pourcentage?: number;

    constructor(data?: ISupport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeISIN = _data["codeISIN"];
            this.montant = _data["montant"];
            this.pourcentage = _data["pourcentage"];
        }
    }

    static fromJS(data: any): Support {
        data = typeof data === 'object' ? data : {};
        let result = new Support();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeISIN"] = this.codeISIN;
        data["montant"] = this.montant;
        data["pourcentage"] = this.pourcentage;
        return data;
    }
}

export interface ISupport {
    codeISIN?: string | undefined;
    montant?: number;
    pourcentage?: number;
}

export class TransfertPacte implements ITransfertPacte {
    contrat_origine?: string | undefined;

    constructor(data?: ITransfertPacte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contrat_origine = _data["contrat_origine"];
        }
    }

    static fromJS(data: any): TransfertPacte {
        data = typeof data === 'object' ? data : {};
        let result = new TransfertPacte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contrat_origine"] = this.contrat_origine;
        return data;
    }
}

export interface ITransfertPacte {
    contrat_origine?: string | undefined;
}

export class ContratInformations implements IContratInformations {
    numeroPolice?: number | undefined;
    codeProduit?: string | undefined;
    categorieContrat?: string | undefined;
    libelleContrat?: string | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    idModeGestion?: number | undefined;
    libelleModeGestion?: string | undefined;
    cotisation?: number | undefined;
    capital?: number | undefined;
    montantCapitalDeces?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatContrat?: number | undefined;
    libelleCategorieEtatContrat?: string | undefined;
    idEtatContratSocietaire?: number | undefined;
    libelleEtatContratSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateEffetFiscale?: Date | undefined;
    dateCloture?: Date | undefined;
    dateModificationCB?: Date | undefined;
    supports?: Support2[] | undefined;

    constructor(data?: IContratInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroPolice = _data["numeroPolice"];
            this.codeProduit = _data["codeProduit"];
            this.categorieContrat = _data["categorieContrat"];
            this.libelleContrat = _data["libelleContrat"];
            this.montantValeurRT = _data["montantValeurRT"];
            this.montantValeurRP = _data["montantValeurRP"];
            this.idModeGestion = _data["idModeGestion"];
            this.libelleModeGestion = _data["libelleModeGestion"];
            this.cotisation = _data["cotisation"];
            this.capital = _data["capital"];
            this.montantCapitalDeces = _data["montantCapitalDeces"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.idCategorieEtatContrat = _data["idCategorieEtatContrat"];
            this.libelleCategorieEtatContrat = _data["libelleCategorieEtatContrat"];
            this.idEtatContratSocietaire = _data["idEtatContratSocietaire"];
            this.libelleEtatContratSocietaire = _data["libelleEtatContratSocietaire"];
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : <any>undefined;
            this.dateEffetFiscale = _data["dateEffetFiscale"] ? new Date(_data["dateEffetFiscale"].toString()) : <any>undefined;
            this.dateCloture = _data["dateCloture"] ? new Date(_data["dateCloture"].toString()) : <any>undefined;
            this.dateModificationCB = _data["dateModificationCB"] ? new Date(_data["dateModificationCB"].toString()) : <any>undefined;
            if (Array.isArray(_data["supports"])) {
                this.supports = [] as any;
                for (let item of _data["supports"])
                    this.supports!.push(Support2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContratInformations {
        data = typeof data === 'object' ? data : {};
        let result = new ContratInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroPolice"] = this.numeroPolice;
        data["codeProduit"] = this.codeProduit;
        data["categorieContrat"] = this.categorieContrat;
        data["libelleContrat"] = this.libelleContrat;
        data["montantValeurRT"] = this.montantValeurRT;
        data["montantValeurRP"] = this.montantValeurRP;
        data["idModeGestion"] = this.idModeGestion;
        data["libelleModeGestion"] = this.libelleModeGestion;
        data["cotisation"] = this.cotisation;
        data["capital"] = this.capital;
        data["montantCapitalDeces"] = this.montantCapitalDeces;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["idCategorieEtatContrat"] = this.idCategorieEtatContrat;
        data["libelleCategorieEtatContrat"] = this.libelleCategorieEtatContrat;
        data["idEtatContratSocietaire"] = this.idEtatContratSocietaire;
        data["libelleEtatContratSocietaire"] = this.libelleEtatContratSocietaire;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : <any>undefined;
        data["dateEffetFiscale"] = this.dateEffetFiscale ? this.dateEffetFiscale.toISOString() : <any>undefined;
        data["dateCloture"] = this.dateCloture ? this.dateCloture.toISOString() : <any>undefined;
        data["dateModificationCB"] = this.dateModificationCB ? this.dateModificationCB.toISOString() : <any>undefined;
        if (Array.isArray(this.supports)) {
            data["supports"] = [];
            for (let item of this.supports)
                data["supports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContratInformations {
    numeroPolice?: number | undefined;
    codeProduit?: string | undefined;
    categorieContrat?: string | undefined;
    libelleContrat?: string | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    idModeGestion?: number | undefined;
    libelleModeGestion?: string | undefined;
    cotisation?: number | undefined;
    capital?: number | undefined;
    montantCapitalDeces?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatContrat?: number | undefined;
    libelleCategorieEtatContrat?: string | undefined;
    idEtatContratSocietaire?: number | undefined;
    libelleEtatContratSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateEffetFiscale?: Date | undefined;
    dateCloture?: Date | undefined;
    dateModificationCB?: Date | undefined;
    supports?: Support2[] | undefined;
}

export class Erreur8 implements IErreur8 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur8 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur8 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetPolicesRequest implements IGetPolicesRequest {
    noSocietaireInterne?: number | undefined;
    proposition?: Proposition;
    police?: Police2;

    constructor(data?: IGetPolicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.proposition = _data["proposition"] ? Proposition.fromJS(_data["proposition"]) : <any>undefined;
            this.police = _data["police"] ? Police2.fromJS(_data["police"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPolicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["proposition"] = this.proposition ? this.proposition.toJSON() : <any>undefined;
        data["police"] = this.police ? this.police.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPolicesRequest {
    noSocietaireInterne?: number | undefined;
    proposition?: Proposition;
    police?: Police2;
}

export class GetPolicesResponse implements IGetPolicesResponse {
    propositions?: Proposition2[] | undefined;
    police?: Police22;
    erreurs?: Erreur8[] | undefined;

    constructor(data?: IGetPolicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["propositions"])) {
                this.propositions = [] as any;
                for (let item of _data["propositions"])
                    this.propositions!.push(Proposition2.fromJS(item));
            }
            this.police = _data["police"] ? Police22.fromJS(_data["police"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur8.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPolicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propositions)) {
            data["propositions"] = [];
            for (let item of this.propositions)
                data["propositions"].push(item.toJSON());
        }
        data["police"] = this.police ? this.police.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPolicesResponse {
    propositions?: Proposition2[] | undefined;
    police?: Police22;
    erreurs?: Erreur8[] | undefined;
}

export class Police2 implements IPolice2 {
    getContrats?: boolean | undefined;
    getSupportsContrats?: boolean | undefined;
    getRentes?: boolean | undefined;

    constructor(data?: IPolice2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getContrats = _data["getContrats"];
            this.getSupportsContrats = _data["getSupportsContrats"];
            this.getRentes = _data["getRentes"];
        }
    }

    static fromJS(data: any): Police2 {
        data = typeof data === 'object' ? data : {};
        let result = new Police2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getContrats"] = this.getContrats;
        data["getSupportsContrats"] = this.getSupportsContrats;
        data["getRentes"] = this.getRentes;
        return data;
    }
}

export interface IPolice2 {
    getContrats?: boolean | undefined;
    getSupportsContrats?: boolean | undefined;
    getRentes?: boolean | undefined;
}

export class Police22 implements IPolice22 {
    contratInformations?: ContratInformations[] | undefined;
    renteInformations?: RenteInformations[] | undefined;

    constructor(data?: IPolice22) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contratInformations"])) {
                this.contratInformations = [] as any;
                for (let item of _data["contratInformations"])
                    this.contratInformations!.push(ContratInformations.fromJS(item));
            }
            if (Array.isArray(_data["renteInformations"])) {
                this.renteInformations = [] as any;
                for (let item of _data["renteInformations"])
                    this.renteInformations!.push(RenteInformations.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Police22 {
        data = typeof data === 'object' ? data : {};
        let result = new Police22();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contratInformations)) {
            data["contratInformations"] = [];
            for (let item of this.contratInformations)
                data["contratInformations"].push(item.toJSON());
        }
        if (Array.isArray(this.renteInformations)) {
            data["renteInformations"] = [];
            for (let item of this.renteInformations)
                data["renteInformations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPolice22 {
    contratInformations?: ContratInformations[] | undefined;
    renteInformations?: RenteInformations[] | undefined;
}

export class Proposition implements IProposition {
    getPropositions?: boolean | undefined;

    constructor(data?: IProposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.getPropositions = _data["getPropositions"];
        }
    }

    static fromJS(data: any): Proposition {
        data = typeof data === 'object' ? data : {};
        let result = new Proposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getPropositions"] = this.getPropositions;
        return data;
    }
}

export interface IProposition {
    getPropositions?: boolean | undefined;
}

export class Proposition2 implements IProposition2 {
    numeroProposition?: number | undefined;
    codeProduit?: string | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    codePromotion?: string | undefined;
    codeOperation?: string | undefined;
    codeApporteur?: string | undefined;
    dateCreation?: Date | undefined;
    dateEffet?: Date | undefined;
    dateSignature?: Date | undefined;

    constructor(data?: IProposition2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroProposition = _data["numeroProposition"];
            this.codeProduit = _data["codeProduit"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.codePromotion = _data["codePromotion"];
            this.codeOperation = _data["codeOperation"];
            this.codeApporteur = _data["codeApporteur"];
            this.dateCreation = _data["dateCreation"] ? new Date(_data["dateCreation"].toString()) : <any>undefined;
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : <any>undefined;
            this.dateSignature = _data["dateSignature"] ? new Date(_data["dateSignature"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Proposition2 {
        data = typeof data === 'object' ? data : {};
        let result = new Proposition2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroProposition"] = this.numeroProposition;
        data["codeProduit"] = this.codeProduit;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["codePromotion"] = this.codePromotion;
        data["codeOperation"] = this.codeOperation;
        data["codeApporteur"] = this.codeApporteur;
        data["dateCreation"] = this.dateCreation ? this.dateCreation.toISOString() : <any>undefined;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : <any>undefined;
        data["dateSignature"] = this.dateSignature ? this.dateSignature.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProposition2 {
    numeroProposition?: number | undefined;
    codeProduit?: string | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    codePromotion?: string | undefined;
    codeOperation?: string | undefined;
    codeApporteur?: string | undefined;
    dateCreation?: Date | undefined;
    dateEffet?: Date | undefined;
    dateSignature?: Date | undefined;
}

export class RenteInformations implements IRenteInformations {
    numeroRente?: number | undefined;
    codeProduit?: string | undefined;
    libelleContrat?: string | undefined;
    categorieContrat?: string | undefined;
    idOption?: number | undefined;
    libelleOption?: string | undefined;
    tauxReversion?: number | undefined;
    montantTrimestriel?: number | undefined;
    montantCapitalReserve?: number | undefined;
    valeurRachat?: number | undefined;
    numeroContratSource?: number | undefined;
    libelleContratSource?: string | undefined;
    dateOuvertureContratSource?: Date | undefined;
    numeroRentier?: number | undefined;
    numeroReversataire?: number | undefined;
    flagAC?: boolean | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatRente?: number | undefined;
    libelleCategorieEtatRente?: string | undefined;
    idEtatRenteSocietaire?: number | undefined;
    libelleEtatRenteSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;
    versementRente?: VersementRente[] | undefined;

    constructor(data?: IRenteInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroRente = _data["numeroRente"];
            this.codeProduit = _data["codeProduit"];
            this.libelleContrat = _data["libelleContrat"];
            this.categorieContrat = _data["categorieContrat"];
            this.idOption = _data["idOption"];
            this.libelleOption = _data["libelleOption"];
            this.tauxReversion = _data["tauxReversion"];
            this.montantTrimestriel = _data["montantTrimestriel"];
            this.montantCapitalReserve = _data["montantCapitalReserve"];
            this.valeurRachat = _data["valeurRachat"];
            this.numeroContratSource = _data["numeroContratSource"];
            this.libelleContratSource = _data["libelleContratSource"];
            this.dateOuvertureContratSource = _data["dateOuvertureContratSource"] ? new Date(_data["dateOuvertureContratSource"].toString()) : <any>undefined;
            this.numeroRentier = _data["numeroRentier"];
            this.numeroReversataire = _data["numeroReversataire"];
            this.flagAC = _data["flagAC"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.idCategorieEtatRente = _data["idCategorieEtatRente"];
            this.libelleCategorieEtatRente = _data["libelleCategorieEtatRente"];
            this.idEtatRenteSocietaire = _data["idEtatRenteSocietaire"];
            this.libelleEtatRenteSocietaire = _data["libelleEtatRenteSocietaire"];
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : <any>undefined;
            this.dateFinEffet = _data["dateFinEffet"] ? new Date(_data["dateFinEffet"].toString()) : <any>undefined;
            if (Array.isArray(_data["versementRente"])) {
                this.versementRente = [] as any;
                for (let item of _data["versementRente"])
                    this.versementRente!.push(VersementRente.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RenteInformations {
        data = typeof data === 'object' ? data : {};
        let result = new RenteInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroRente"] = this.numeroRente;
        data["codeProduit"] = this.codeProduit;
        data["libelleContrat"] = this.libelleContrat;
        data["categorieContrat"] = this.categorieContrat;
        data["idOption"] = this.idOption;
        data["libelleOption"] = this.libelleOption;
        data["tauxReversion"] = this.tauxReversion;
        data["montantTrimestriel"] = this.montantTrimestriel;
        data["montantCapitalReserve"] = this.montantCapitalReserve;
        data["valeurRachat"] = this.valeurRachat;
        data["numeroContratSource"] = this.numeroContratSource;
        data["libelleContratSource"] = this.libelleContratSource;
        data["dateOuvertureContratSource"] = this.dateOuvertureContratSource ? this.dateOuvertureContratSource.toISOString() : <any>undefined;
        data["numeroRentier"] = this.numeroRentier;
        data["numeroReversataire"] = this.numeroReversataire;
        data["flagAC"] = this.flagAC;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["idCategorieEtatRente"] = this.idCategorieEtatRente;
        data["libelleCategorieEtatRente"] = this.libelleCategorieEtatRente;
        data["idEtatRenteSocietaire"] = this.idEtatRenteSocietaire;
        data["libelleEtatRenteSocietaire"] = this.libelleEtatRenteSocietaire;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : <any>undefined;
        data["dateFinEffet"] = this.dateFinEffet ? this.dateFinEffet.toISOString() : <any>undefined;
        if (Array.isArray(this.versementRente)) {
            data["versementRente"] = [];
            for (let item of this.versementRente)
                data["versementRente"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRenteInformations {
    numeroRente?: number | undefined;
    codeProduit?: string | undefined;
    libelleContrat?: string | undefined;
    categorieContrat?: string | undefined;
    idOption?: number | undefined;
    libelleOption?: string | undefined;
    tauxReversion?: number | undefined;
    montantTrimestriel?: number | undefined;
    montantCapitalReserve?: number | undefined;
    valeurRachat?: number | undefined;
    numeroContratSource?: number | undefined;
    libelleContratSource?: string | undefined;
    dateOuvertureContratSource?: Date | undefined;
    numeroRentier?: number | undefined;
    numeroReversataire?: number | undefined;
    flagAC?: boolean | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    idCategorieEtatRente?: number | undefined;
    libelleCategorieEtatRente?: string | undefined;
    idEtatRenteSocietaire?: number | undefined;
    libelleEtatRenteSocietaire?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;
    versementRente?: VersementRente[] | undefined;
}

export class Support2 implements ISupport2 {
    codeGarantie?: string | undefined;
    codeIsin?: string | undefined;
    libelleSupport?: string | undefined;
    montant?: number | undefined;
    pourcentage?: number | undefined;

    constructor(data?: ISupport2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeGarantie = _data["codeGarantie"];
            this.codeIsin = _data["codeIsin"];
            this.libelleSupport = _data["libelleSupport"];
            this.montant = _data["montant"];
            this.pourcentage = _data["pourcentage"];
        }
    }

    static fromJS(data: any): Support2 {
        data = typeof data === 'object' ? data : {};
        let result = new Support2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeGarantie"] = this.codeGarantie;
        data["codeIsin"] = this.codeIsin;
        data["libelleSupport"] = this.libelleSupport;
        data["montant"] = this.montant;
        data["pourcentage"] = this.pourcentage;
        return data;
    }
}

export interface ISupport2 {
    codeGarantie?: string | undefined;
    codeIsin?: string | undefined;
    libelleSupport?: string | undefined;
    montant?: number | undefined;
    pourcentage?: number | undefined;
}

export class VersementRente implements IVersementRente {
    numeroVersement?: number | undefined;
    numeroInterne?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;

    constructor(data?: IVersementRente) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroVersement = _data["numeroVersement"];
            this.numeroInterne = _data["numeroInterne"];
            this.idEtat = _data["idEtat"];
            this.libelleEtat = _data["libelleEtat"];
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : <any>undefined;
            this.dateFinEffet = _data["dateFinEffet"] ? new Date(_data["dateFinEffet"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VersementRente {
        data = typeof data === 'object' ? data : {};
        let result = new VersementRente();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroVersement"] = this.numeroVersement;
        data["numeroInterne"] = this.numeroInterne;
        data["idEtat"] = this.idEtat;
        data["libelleEtat"] = this.libelleEtat;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : <any>undefined;
        data["dateFinEffet"] = this.dateFinEffet ? this.dateFinEffet.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVersementRente {
    numeroVersement?: number | undefined;
    numeroInterne?: number | undefined;
    idEtat?: number | undefined;
    libelleEtat?: string | undefined;
    dateEffet?: Date | undefined;
    dateFinEffet?: Date | undefined;
}

export class Apporteur implements IApporteur {
    numeroApporteur?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IApporteur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroApporteur = _data["numeroApporteur"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Apporteur {
        data = typeof data === 'object' ? data : {};
        let result = new Apporteur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroApporteur"] = this.numeroApporteur;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApporteur {
    numeroApporteur?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Assure1 implements IAssure1 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IAssure1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Assure1 {
        data = typeof data === 'object' ? data : {};
        let result = new Assure1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssure1 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Assure2 implements IAssure2 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IAssure2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Assure2 {
        data = typeof data === 'object' ? data : {};
        let result = new Assure2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssure2 {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Beneficiaire implements IBeneficiaire {
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;

    constructor(data?: IBeneficiaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noSocietaireExterne = _data["noSocietaireExterne"];
        }
    }

    static fromJS(data: any): Beneficiaire {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noSocietaireExterne"] = this.noSocietaireExterne;
        return data;
    }
}

export interface IBeneficiaire {
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
}

export class ContratTransferableFourgous implements IContratTransferableFourgous {
    numeroContrat?: number | undefined;
    libelleContrat?: string | undefined;
    dateEffet?: string | undefined;
    valeurRachat?: number | undefined;

    constructor(data?: IContratTransferableFourgous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.libelleContrat = _data["libelleContrat"];
            this.dateEffet = _data["dateEffet"];
            this.valeurRachat = _data["valeurRachat"];
        }
    }

    static fromJS(data: any): ContratTransferableFourgous {
        data = typeof data === 'object' ? data : {};
        let result = new ContratTransferableFourgous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["libelleContrat"] = this.libelleContrat;
        data["dateEffet"] = this.dateEffet;
        data["valeurRachat"] = this.valeurRachat;
        return data;
    }
}

export interface IContratTransferableFourgous {
    numeroContrat?: number | undefined;
    libelleContrat?: string | undefined;
    dateEffet?: string | undefined;
    valeurRachat?: number | undefined;
}

export class DemarcheEnCours implements IDemarcheEnCours {
    idDemarche?: number | undefined;
    numeroContrat?: number | undefined;
    numeroDemarche?: number | undefined;

    constructor(data?: IDemarcheEnCours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idDemarche = _data["idDemarche"];
            this.numeroContrat = _data["numeroContrat"];
            this.numeroDemarche = _data["numeroDemarche"];
        }
    }

    static fromJS(data: any): DemarcheEnCours {
        data = typeof data === 'object' ? data : {};
        let result = new DemarcheEnCours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idDemarche"] = this.idDemarche;
        data["numeroContrat"] = this.numeroContrat;
        data["numeroDemarche"] = this.numeroDemarche;
        return data;
    }
}

export interface IDemarcheEnCours {
    idDemarche?: number | undefined;
    numeroContrat?: number | undefined;
    numeroDemarche?: number | undefined;
}

export class Erreur9 implements IErreur9 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur9 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur9 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetClientByNumeroContratRequest implements IGetClientByNumeroContratRequest {
    noContrat?: number | undefined;

    constructor(data?: IGetClientByNumeroContratRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noContrat = _data["noContrat"];
        }
    }

    static fromJS(data: any): GetClientByNumeroContratRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroContratRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noContrat"] = this.noContrat;
        return data;
    }
}

export interface IGetClientByNumeroContratRequest {
    noContrat?: number | undefined;
}

export class GetClientByNumeroContratResponse implements IGetClientByNumeroContratResponse {
    numeroInterneSouscripteur?: number | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetClientByNumeroContratResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterneSouscripteur = _data["numeroInterneSouscripteur"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClientByNumeroContratResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientByNumeroContratResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterneSouscripteur"] = this.numeroInterneSouscripteur;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetClientByNumeroContratResponse {
    numeroInterneSouscripteur?: number | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetContratsTransferablesFourgousRequest implements IGetContratsTransferablesFourgousRequest {
    codeProduit?: string | undefined;
    numeroSocietaireInterne?: number;

    constructor(data?: IGetContratsTransferablesFourgousRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
        }
    }

    static fromJS(data: any): GetContratsTransferablesFourgousRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetContratsTransferablesFourgousRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        return data;
    }
}

export interface IGetContratsTransferablesFourgousRequest {
    codeProduit?: string | undefined;
    numeroSocietaireInterne?: number;
}

export class GetContratsTransferablesFourgousResponse implements IGetContratsTransferablesFourgousResponse {
    contratTransferableFourgous?: ContratTransferableFourgous[] | undefined;
    erreurs?: Erreur9[] | undefined;
    warnings?: Warning5[] | undefined;

    constructor(data?: IGetContratsTransferablesFourgousResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contratTransferableFourgous"])) {
                this.contratTransferableFourgous = [] as any;
                for (let item of _data["contratTransferableFourgous"])
                    this.contratTransferableFourgous!.push(ContratTransferableFourgous.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContratsTransferablesFourgousResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContratsTransferablesFourgousResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contratTransferableFourgous)) {
            data["contratTransferableFourgous"] = [];
            for (let item of this.contratTransferableFourgous)
                data["contratTransferableFourgous"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContratsTransferablesFourgousResponse {
    contratTransferableFourgous?: ContratTransferableFourgous[] | undefined;
    erreurs?: Erreur9[] | undefined;
    warnings?: Warning5[] | undefined;
}

export class GetDemarchesEnCoursRequest implements IGetDemarchesEnCoursRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;

    constructor(data?: IGetDemarchesEnCoursRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetDemarchesEnCoursRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDemarchesEnCoursRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetDemarchesEnCoursRequest {
    numeroInterne?: number | undefined;
    numeroContrat?: number | undefined;
}

export class GetDemarchesEnCoursResponse implements IGetDemarchesEnCoursResponse {
    demarcheEnCours?: DemarcheEnCours[] | undefined;
    erreurs?: Erreur9[] | undefined;
    warnings?: Warning5[] | undefined;

    constructor(data?: IGetDemarchesEnCoursResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["demarcheEnCours"])) {
                this.demarcheEnCours = [] as any;
                for (let item of _data["demarcheEnCours"])
                    this.demarcheEnCours!.push(DemarcheEnCours.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning5.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDemarchesEnCoursResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDemarchesEnCoursResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.demarcheEnCours)) {
            data["demarcheEnCours"] = [];
            for (let item of this.demarcheEnCours)
                data["demarcheEnCours"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDemarchesEnCoursResponse {
    demarcheEnCours?: DemarcheEnCours[] | undefined;
    erreurs?: Erreur9[] | undefined;
    warnings?: Warning5[] | undefined;
}

export class GetPolicesRequest2 implements IGetPolicesRequest2 {
    noIdentiteInterne?: number;
    numeroContrat?: number;

    constructor(data?: IGetPolicesRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noIdentiteInterne = _data["noIdentiteInterne"];
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetPolicesRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noIdentiteInterne"] = this.noIdentiteInterne;
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetPolicesRequest2 {
    noIdentiteInterne?: number;
    numeroContrat?: number;
}

export class GetPolicesResponse2 implements IGetPolicesResponse2 {
    police?: Police3[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetPolicesResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["police"])) {
                this.police = [] as any;
                for (let item of _data["police"])
                    this.police!.push(Police3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPolicesResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPolicesResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.police)) {
            data["police"] = [];
            for (let item of this.police)
                data["police"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPolicesResponse2 {
    police?: Police3[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetRepartitionContratMultisupportRequest implements IGetRepartitionContratMultisupportRequest {
    numeroContrat?: number;

    constructor(data?: IGetRepartitionContratMultisupportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetRepartitionContratMultisupportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepartitionContratMultisupportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetRepartitionContratMultisupportRequest {
    numeroContrat?: number;
}

export class GetRepartitionContratMultisupportResponse implements IGetRepartitionContratMultisupportResponse {
    support?: Support3[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetRepartitionContratMultisupportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["support"])) {
                this.support = [] as any;
                for (let item of _data["support"])
                    this.support!.push(Support3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRepartitionContratMultisupportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepartitionContratMultisupportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.support)) {
            data["support"] = [];
            for (let item of this.support)
                data["support"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRepartitionContratMultisupportResponse {
    support?: Support3[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class GetSupportsContratRequest implements IGetSupportsContratRequest {
    numeroContrat?: number;

    constructor(data?: IGetSupportsContratRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
        }
    }

    static fromJS(data: any): GetSupportsContratRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupportsContratRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        return data;
    }
}

export interface IGetSupportsContratRequest {
    numeroContrat?: number;
}

export class GetSupportsContratResponse implements IGetSupportsContratResponse {
    supportContrat?: SupportContrat[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IGetSupportsContratResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["supportContrat"])) {
                this.supportContrat = [] as any;
                for (let item of _data["supportContrat"])
                    this.supportContrat!.push(SupportContrat.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSupportsContratResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupportsContratResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supportContrat)) {
            data["supportContrat"] = [];
            for (let item of this.supportContrat)
                data["supportContrat"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSupportsContratResponse {
    supportContrat?: SupportContrat[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class Parrain implements IParrain {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IParrain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Parrain {
        data = typeof data === 'object' ? data : {};
        let result = new Parrain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParrain {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Payeur implements IPayeur {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: IPayeur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noSocietaireExterne = _data["noSocietaireExterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Payeur {
        data = typeof data === 'object' ? data : {};
        let result = new Payeur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noSocietaireExterne"] = this.noSocietaireExterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayeur {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Police3 implements IPolice3 {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    numeroContrat?: number | undefined;
    codeProduit?: string | undefined;
    typeContrat?: string | undefined;
    affichable?: string | undefined;
    consultable?: string | undefined;
    codeTypeVersement?: string | undefined;
    typeVersement?: string | undefined;
    solde01?: number | undefined;
    soldeEnCours?: number | undefined;
    cotisation?: number | undefined;
    augmCotis1?: number | undefined;
    augmCotis2?: number | undefined;
    augmCotis3?: number | undefined;
    coefRevalorisation?: number | undefined;
    dateOuverture?: Date | undefined;
    dateEffet?: Date | undefined;
    flagFourgous?: string | undefined;
    dateDernierVersementLibre?: Date | undefined;
    libelleEtat?: string | undefined;
    alimentation?: string | undefined;
    capital?: number | undefined;
    libelleAdq?: string | undefined;
    capitalAdq?: number | undefined;
    cotisationAdq?: number | undefined;
    dateFermeture?: Date | undefined;
    dateCloture?: Date | undefined;
    montantVersIni?: number | undefined;
    montantVersCumul?: number | undefined;
    montantVersCumul98?: number | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    montantValeurReduction?: number | undefined;
    bareme57ans?: number | undefined;
    montantCapitalDeces?: number | undefined;
    montantCapitalOption?: string | undefined;
    dateSouscription?: Date | undefined;
    cptrDateJouissance?: Date | undefined;
    cptrAgeLiquidation?: number | undefined;
    cptrOption?: string | undefined;
    cptrPartRenteAcquise?: number | undefined;
    dateAvenantMPRM?: Date | undefined;
    dateAvenantMMRV?: Date | undefined;
    versementMini?: number | undefined;
    montantAvenantMiniMPRM?: number | undefined;
    montantAvenantMaxiMPRM?: number | undefined;
    attenteMPRM?: number | undefined;
    dateEffetCtFuture?: Date | undefined;
    montantCtFuture?: number | undefined;
    duree?: string | undefined;
    libPromotion?: string | undefined;
    horizonPlacement?: number | undefined;
    idModeGestion?: number | undefined;
    typeGestion?: string | undefined;
    idMandatGestion?: number | undefined;
    libelleMandatGestion?: string | undefined;
    dateDernierArbitrage?: Date | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    cumulVersements?: number | undefined;
    cumulRachats?: number | undefined;
    dateEcheance?: Date | undefined;
    blocNote?: string | undefined;
    souscripteur?: Souscripteur;
    assure1?: Assure1;
    assure2?: Assure2;
    payeur?: Payeur;
    parrain?: Parrain;
    apporteur?: Apporteur;
    beneficiaire?: Beneficiaire;

    constructor(data?: IPolice3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noSocietaireExterne = _data["noSocietaireExterne"];
            this.numeroContrat = _data["numeroContrat"];
            this.codeProduit = _data["codeProduit"];
            this.typeContrat = _data["typeContrat"];
            this.affichable = _data["affichable"];
            this.consultable = _data["consultable"];
            this.codeTypeVersement = _data["codeTypeVersement"];
            this.typeVersement = _data["typeVersement"];
            this.solde01 = _data["solde01"];
            this.soldeEnCours = _data["soldeEnCours"];
            this.cotisation = _data["cotisation"];
            this.augmCotis1 = _data["augmCotis1"];
            this.augmCotis2 = _data["augmCotis2"];
            this.augmCotis3 = _data["augmCotis3"];
            this.coefRevalorisation = _data["coefRevalorisation"];
            this.dateOuverture = _data["dateOuverture"] ? new Date(_data["dateOuverture"].toString()) : <any>undefined;
            this.dateEffet = _data["dateEffet"] ? new Date(_data["dateEffet"].toString()) : <any>undefined;
            this.flagFourgous = _data["flagFourgous"];
            this.dateDernierVersementLibre = _data["dateDernierVersementLibre"] ? new Date(_data["dateDernierVersementLibre"].toString()) : <any>undefined;
            this.libelleEtat = _data["libelleEtat"];
            this.alimentation = _data["alimentation"];
            this.capital = _data["capital"];
            this.libelleAdq = _data["libelleAdq"];
            this.capitalAdq = _data["capitalAdq"];
            this.cotisationAdq = _data["cotisationAdq"];
            this.dateFermeture = _data["dateFermeture"] ? new Date(_data["dateFermeture"].toString()) : <any>undefined;
            this.dateCloture = _data["dateCloture"] ? new Date(_data["dateCloture"].toString()) : <any>undefined;
            this.montantVersIni = _data["montantVersIni"];
            this.montantVersCumul = _data["montantVersCumul"];
            this.montantVersCumul98 = _data["montantVersCumul98"];
            this.montantValeurRT = _data["montantValeurRT"];
            this.montantValeurRP = _data["montantValeurRP"];
            this.montantValeurReduction = _data["montantValeurReduction"];
            this.bareme57ans = _data["bareme57ans"];
            this.montantCapitalDeces = _data["montantCapitalDeces"];
            this.montantCapitalOption = _data["montantCapitalOption"];
            this.dateSouscription = _data["dateSouscription"] ? new Date(_data["dateSouscription"].toString()) : <any>undefined;
            this.cptrDateJouissance = _data["cptrDateJouissance"] ? new Date(_data["cptrDateJouissance"].toString()) : <any>undefined;
            this.cptrAgeLiquidation = _data["cptrAgeLiquidation"];
            this.cptrOption = _data["cptrOption"];
            this.cptrPartRenteAcquise = _data["cptrPartRenteAcquise"];
            this.dateAvenantMPRM = _data["dateAvenantMPRM"] ? new Date(_data["dateAvenantMPRM"].toString()) : <any>undefined;
            this.dateAvenantMMRV = _data["dateAvenantMMRV"] ? new Date(_data["dateAvenantMMRV"].toString()) : <any>undefined;
            this.versementMini = _data["versementMini"];
            this.montantAvenantMiniMPRM = _data["montantAvenantMiniMPRM"];
            this.montantAvenantMaxiMPRM = _data["montantAvenantMaxiMPRM"];
            this.attenteMPRM = _data["attenteMPRM"];
            this.dateEffetCtFuture = _data["dateEffetCtFuture"] ? new Date(_data["dateEffetCtFuture"].toString()) : <any>undefined;
            this.montantCtFuture = _data["montantCtFuture"];
            this.duree = _data["duree"];
            this.libPromotion = _data["libPromotion"];
            this.horizonPlacement = _data["horizonPlacement"];
            this.idModeGestion = _data["idModeGestion"];
            this.typeGestion = _data["typeGestion"];
            this.idMandatGestion = _data["idMandatGestion"];
            this.libelleMandatGestion = _data["libelleMandatGestion"];
            this.dateDernierArbitrage = _data["dateDernierArbitrage"] ? new Date(_data["dateDernierArbitrage"].toString()) : <any>undefined;
            this.plusMoinsValueValeur = _data["plusMoinsValueValeur"];
            this.plusMoinsValuePourcentage = _data["plusMoinsValuePourcentage"];
            this.cumulVersements = _data["cumulVersements"];
            this.cumulRachats = _data["cumulRachats"];
            this.dateEcheance = _data["dateEcheance"] ? new Date(_data["dateEcheance"].toString()) : <any>undefined;
            this.blocNote = _data["blocNote"];
            this.souscripteur = _data["souscripteur"] ? Souscripteur.fromJS(_data["souscripteur"]) : <any>undefined;
            this.assure1 = _data["assure1"] ? Assure1.fromJS(_data["assure1"]) : <any>undefined;
            this.assure2 = _data["assure2"] ? Assure2.fromJS(_data["assure2"]) : <any>undefined;
            this.payeur = _data["payeur"] ? Payeur.fromJS(_data["payeur"]) : <any>undefined;
            this.parrain = _data["parrain"] ? Parrain.fromJS(_data["parrain"]) : <any>undefined;
            this.apporteur = _data["apporteur"] ? Apporteur.fromJS(_data["apporteur"]) : <any>undefined;
            this.beneficiaire = _data["beneficiaire"] ? Beneficiaire.fromJS(_data["beneficiaire"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Police3 {
        data = typeof data === 'object' ? data : {};
        let result = new Police3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noSocietaireExterne"] = this.noSocietaireExterne;
        data["numeroContrat"] = this.numeroContrat;
        data["codeProduit"] = this.codeProduit;
        data["typeContrat"] = this.typeContrat;
        data["affichable"] = this.affichable;
        data["consultable"] = this.consultable;
        data["codeTypeVersement"] = this.codeTypeVersement;
        data["typeVersement"] = this.typeVersement;
        data["solde01"] = this.solde01;
        data["soldeEnCours"] = this.soldeEnCours;
        data["cotisation"] = this.cotisation;
        data["augmCotis1"] = this.augmCotis1;
        data["augmCotis2"] = this.augmCotis2;
        data["augmCotis3"] = this.augmCotis3;
        data["coefRevalorisation"] = this.coefRevalorisation;
        data["dateOuverture"] = this.dateOuverture ? this.dateOuverture.toISOString() : <any>undefined;
        data["dateEffet"] = this.dateEffet ? this.dateEffet.toISOString() : <any>undefined;
        data["flagFourgous"] = this.flagFourgous;
        data["dateDernierVersementLibre"] = this.dateDernierVersementLibre ? this.dateDernierVersementLibre.toISOString() : <any>undefined;
        data["libelleEtat"] = this.libelleEtat;
        data["alimentation"] = this.alimentation;
        data["capital"] = this.capital;
        data["libelleAdq"] = this.libelleAdq;
        data["capitalAdq"] = this.capitalAdq;
        data["cotisationAdq"] = this.cotisationAdq;
        data["dateFermeture"] = this.dateFermeture ? this.dateFermeture.toISOString() : <any>undefined;
        data["dateCloture"] = this.dateCloture ? this.dateCloture.toISOString() : <any>undefined;
        data["montantVersIni"] = this.montantVersIni;
        data["montantVersCumul"] = this.montantVersCumul;
        data["montantVersCumul98"] = this.montantVersCumul98;
        data["montantValeurRT"] = this.montantValeurRT;
        data["montantValeurRP"] = this.montantValeurRP;
        data["montantValeurReduction"] = this.montantValeurReduction;
        data["bareme57ans"] = this.bareme57ans;
        data["montantCapitalDeces"] = this.montantCapitalDeces;
        data["montantCapitalOption"] = this.montantCapitalOption;
        data["dateSouscription"] = this.dateSouscription ? this.dateSouscription.toISOString() : <any>undefined;
        data["cptrDateJouissance"] = this.cptrDateJouissance ? this.cptrDateJouissance.toISOString() : <any>undefined;
        data["cptrAgeLiquidation"] = this.cptrAgeLiquidation;
        data["cptrOption"] = this.cptrOption;
        data["cptrPartRenteAcquise"] = this.cptrPartRenteAcquise;
        data["dateAvenantMPRM"] = this.dateAvenantMPRM ? this.dateAvenantMPRM.toISOString() : <any>undefined;
        data["dateAvenantMMRV"] = this.dateAvenantMMRV ? this.dateAvenantMMRV.toISOString() : <any>undefined;
        data["versementMini"] = this.versementMini;
        data["montantAvenantMiniMPRM"] = this.montantAvenantMiniMPRM;
        data["montantAvenantMaxiMPRM"] = this.montantAvenantMaxiMPRM;
        data["attenteMPRM"] = this.attenteMPRM;
        data["dateEffetCtFuture"] = this.dateEffetCtFuture ? this.dateEffetCtFuture.toISOString() : <any>undefined;
        data["montantCtFuture"] = this.montantCtFuture;
        data["duree"] = this.duree;
        data["libPromotion"] = this.libPromotion;
        data["horizonPlacement"] = this.horizonPlacement;
        data["idModeGestion"] = this.idModeGestion;
        data["typeGestion"] = this.typeGestion;
        data["idMandatGestion"] = this.idMandatGestion;
        data["libelleMandatGestion"] = this.libelleMandatGestion;
        data["dateDernierArbitrage"] = this.dateDernierArbitrage ? this.dateDernierArbitrage.toISOString() : <any>undefined;
        data["plusMoinsValueValeur"] = this.plusMoinsValueValeur;
        data["plusMoinsValuePourcentage"] = this.plusMoinsValuePourcentage;
        data["cumulVersements"] = this.cumulVersements;
        data["cumulRachats"] = this.cumulRachats;
        data["dateEcheance"] = this.dateEcheance ? this.dateEcheance.toISOString() : <any>undefined;
        data["blocNote"] = this.blocNote;
        data["souscripteur"] = this.souscripteur ? this.souscripteur.toJSON() : <any>undefined;
        data["assure1"] = this.assure1 ? this.assure1.toJSON() : <any>undefined;
        data["assure2"] = this.assure2 ? this.assure2.toJSON() : <any>undefined;
        data["payeur"] = this.payeur ? this.payeur.toJSON() : <any>undefined;
        data["parrain"] = this.parrain ? this.parrain.toJSON() : <any>undefined;
        data["apporteur"] = this.apporteur ? this.apporteur.toJSON() : <any>undefined;
        data["beneficiaire"] = this.beneficiaire ? this.beneficiaire.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPolice3 {
    noSocietaireInterne?: number | undefined;
    noSocietaireExterne?: string | undefined;
    numeroContrat?: number | undefined;
    codeProduit?: string | undefined;
    typeContrat?: string | undefined;
    affichable?: string | undefined;
    consultable?: string | undefined;
    codeTypeVersement?: string | undefined;
    typeVersement?: string | undefined;
    solde01?: number | undefined;
    soldeEnCours?: number | undefined;
    cotisation?: number | undefined;
    augmCotis1?: number | undefined;
    augmCotis2?: number | undefined;
    augmCotis3?: number | undefined;
    coefRevalorisation?: number | undefined;
    dateOuverture?: Date | undefined;
    dateEffet?: Date | undefined;
    flagFourgous?: string | undefined;
    dateDernierVersementLibre?: Date | undefined;
    libelleEtat?: string | undefined;
    alimentation?: string | undefined;
    capital?: number | undefined;
    libelleAdq?: string | undefined;
    capitalAdq?: number | undefined;
    cotisationAdq?: number | undefined;
    dateFermeture?: Date | undefined;
    dateCloture?: Date | undefined;
    montantVersIni?: number | undefined;
    montantVersCumul?: number | undefined;
    montantVersCumul98?: number | undefined;
    montantValeurRT?: number | undefined;
    montantValeurRP?: number | undefined;
    montantValeurReduction?: number | undefined;
    bareme57ans?: number | undefined;
    montantCapitalDeces?: number | undefined;
    montantCapitalOption?: string | undefined;
    dateSouscription?: Date | undefined;
    cptrDateJouissance?: Date | undefined;
    cptrAgeLiquidation?: number | undefined;
    cptrOption?: string | undefined;
    cptrPartRenteAcquise?: number | undefined;
    dateAvenantMPRM?: Date | undefined;
    dateAvenantMMRV?: Date | undefined;
    versementMini?: number | undefined;
    montantAvenantMiniMPRM?: number | undefined;
    montantAvenantMaxiMPRM?: number | undefined;
    attenteMPRM?: number | undefined;
    dateEffetCtFuture?: Date | undefined;
    montantCtFuture?: number | undefined;
    duree?: string | undefined;
    libPromotion?: string | undefined;
    horizonPlacement?: number | undefined;
    idModeGestion?: number | undefined;
    typeGestion?: string | undefined;
    idMandatGestion?: number | undefined;
    libelleMandatGestion?: string | undefined;
    dateDernierArbitrage?: Date | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    cumulVersements?: number | undefined;
    cumulRachats?: number | undefined;
    dateEcheance?: Date | undefined;
    blocNote?: string | undefined;
    souscripteur?: Souscripteur;
    assure1?: Assure1;
    assure2?: Assure2;
    payeur?: Payeur;
    parrain?: Parrain;
    apporteur?: Apporteur;
    beneficiaire?: Beneficiaire;
}

export class RechercheAvenantNantissementRequest implements IRechercheAvenantNantissementRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;

    constructor(data?: IRechercheAvenantNantissementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noContrat = _data["noContrat"];
        }
    }

    static fromJS(data: any): RechercheAvenantNantissementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAvenantNantissementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noContrat"] = this.noContrat;
        return data;
    }
}

export interface IRechercheAvenantNantissementRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;
}

export class RechercheAvenantNantissementResponse implements IRechercheAvenantNantissementResponse {
    codeRetour?: number | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IRechercheAvenantNantissementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheAvenantNantissementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheAvenantNantissementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheAvenantNantissementResponse {
    codeRetour?: number | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class RechercheRachatRequest implements IRechercheRachatRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;
    dateReceptionRachat?: Date | undefined;
    nbMoisSuccessif?: number | undefined;
    nbRachat?: number | undefined;
    nbMoisLimite?: number | undefined;

    constructor(data?: IRechercheRachatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.noContrat = _data["noContrat"];
            this.dateReceptionRachat = _data["dateReceptionRachat"] ? new Date(_data["dateReceptionRachat"].toString()) : <any>undefined;
            this.nbMoisSuccessif = _data["nbMoisSuccessif"];
            this.nbRachat = _data["nbRachat"];
            this.nbMoisLimite = _data["nbMoisLimite"];
        }
    }

    static fromJS(data: any): RechercheRachatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRachatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["noContrat"] = this.noContrat;
        data["dateReceptionRachat"] = this.dateReceptionRachat ? this.dateReceptionRachat.toISOString() : <any>undefined;
        data["nbMoisSuccessif"] = this.nbMoisSuccessif;
        data["nbRachat"] = this.nbRachat;
        data["nbMoisLimite"] = this.nbMoisLimite;
        return data;
    }
}

export interface IRechercheRachatRequest {
    noSocietaireInterne?: number | undefined;
    noContrat?: string | undefined;
    dateReceptionRachat?: Date | undefined;
    nbMoisSuccessif?: number | undefined;
    nbRachat?: number | undefined;
    nbMoisLimite?: number | undefined;
}

export class RechercheRachatResponse implements IRechercheRachatResponse {
    retours?: Retour[] | undefined;
    erreurs?: Erreur9[] | undefined;

    constructor(data?: IRechercheRachatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["retours"])) {
                this.retours = [] as any;
                for (let item of _data["retours"])
                    this.retours!.push(Retour.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur9.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RechercheRachatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RechercheRachatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.retours)) {
            data["retours"] = [];
            for (let item of this.retours)
                data["retours"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRechercheRachatResponse {
    retours?: Retour[] | undefined;
    erreurs?: Erreur9[] | undefined;
}

export class Retour implements IRetour {
    codeRetour?: number | undefined;
    libelleRetour?: string | undefined;

    constructor(data?: IRetour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.libelleRetour = _data["libelleRetour"];
        }
    }

    static fromJS(data: any): Retour {
        data = typeof data === 'object' ? data : {};
        let result = new Retour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["libelleRetour"] = this.libelleRetour;
        return data;
    }
}

export interface IRetour {
    codeRetour?: number | undefined;
    libelleRetour?: string | undefined;
}

export class Souscripteur implements ISouscripteur {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;

    constructor(data?: ISouscripteur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSocietaireInterne = _data["noSocietaireInterne"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Souscripteur {
        data = typeof data === 'object' ? data : {};
        let result = new Souscripteur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSocietaireInterne"] = this.noSocietaireInterne;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISouscripteur {
    noSocietaireInterne?: number | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateNaissance?: Date | undefined;
}

export class Support3 implements ISupport3 {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    repartition?: number | undefined;

    constructor(data?: ISupport3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeISIN = _data["codeISIN"];
            this.libelle = _data["libelle"];
            this.repartition = _data["repartition"];
        }
    }

    static fromJS(data: any): Support3 {
        data = typeof data === 'object' ? data : {};
        let result = new Support3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeISIN"] = this.codeISIN;
        data["libelle"] = this.libelle;
        data["repartition"] = this.repartition;
        return data;
    }
}

export interface ISupport3 {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    repartition?: number | undefined;
}

export class SupportContrat implements ISupportContrat {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    montant?: number | undefined;
    montantInvesti?: number | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    valeurLiquidative?: number | undefined;
    dateMAJ?: Date | undefined;
    nombreParts?: number | undefined;
    repartition?: number | undefined;
    idSupport?: string | undefined;

    constructor(data?: ISupportContrat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeISIN = _data["codeISIN"];
            this.libelle = _data["libelle"];
            this.montant = _data["montant"];
            this.montantInvesti = _data["montantInvesti"];
            this.plusMoinsValueValeur = _data["plusMoinsValueValeur"];
            this.plusMoinsValuePourcentage = _data["plusMoinsValuePourcentage"];
            this.valeurLiquidative = _data["valeurLiquidative"];
            this.dateMAJ = _data["dateMAJ"] ? new Date(_data["dateMAJ"].toString()) : <any>undefined;
            this.nombreParts = _data["nombreParts"];
            this.repartition = _data["repartition"];
            this.idSupport = _data["idSupport"];
        }
    }

    static fromJS(data: any): SupportContrat {
        data = typeof data === 'object' ? data : {};
        let result = new SupportContrat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeISIN"] = this.codeISIN;
        data["libelle"] = this.libelle;
        data["montant"] = this.montant;
        data["montantInvesti"] = this.montantInvesti;
        data["plusMoinsValueValeur"] = this.plusMoinsValueValeur;
        data["plusMoinsValuePourcentage"] = this.plusMoinsValuePourcentage;
        data["valeurLiquidative"] = this.valeurLiquidative;
        data["dateMAJ"] = this.dateMAJ ? this.dateMAJ.toISOString() : <any>undefined;
        data["nombreParts"] = this.nombreParts;
        data["repartition"] = this.repartition;
        data["idSupport"] = this.idSupport;
        return data;
    }
}

export interface ISupportContrat {
    codeISIN?: string | undefined;
    libelle?: string | undefined;
    montant?: number | undefined;
    montantInvesti?: number | undefined;
    plusMoinsValueValeur?: number | undefined;
    plusMoinsValuePourcentage?: number | undefined;
    valeurLiquidative?: number | undefined;
    dateMAJ?: Date | undefined;
    nombreParts?: number | undefined;
    repartition?: number | undefined;
    idSupport?: string | undefined;
}

export class Warning5 implements IWarning5 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning5 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning5 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class Cotisation implements ICotisation {
    age?: number;
    mntCotisation?: number | undefined;

    constructor(data?: ICotisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.mntCotisation = _data["mntCotisation"];
        }
    }

    static fromJS(data: any): Cotisation {
        data = typeof data === 'object' ? data : {};
        let result = new Cotisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["mntCotisation"] = this.mntCotisation;
        return data;
    }
}

export interface ICotisation {
    age?: number;
    mntCotisation?: number | undefined;
}

export class Erreur10 implements IErreur10 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur10 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur10 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetTarifsPrevoyanceGFDRequest implements IGetTarifsPrevoyanceGFDRequest {
    prevoyanceGFD?: PrevoyanceGFD;

    constructor(data?: IGetTarifsPrevoyanceGFDRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prevoyanceGFD = _data["prevoyanceGFD"] ? PrevoyanceGFD.fromJS(_data["prevoyanceGFD"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGFDRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGFDRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prevoyanceGFD"] = this.prevoyanceGFD ? this.prevoyanceGFD.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTarifsPrevoyanceGFDRequest {
    prevoyanceGFD?: PrevoyanceGFD;
}

export class GetTarifsPrevoyanceGFDResponse implements IGetTarifsPrevoyanceGFDResponse {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation[] | undefined;
    erreurs?: Erreur10[] | undefined;
    warnings?: Warning6[] | undefined;

    constructor(data?: IGetTarifsPrevoyanceGFDResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.periodicitePaiement = _data["periodicitePaiement"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
            if (Array.isArray(_data["cotisation"])) {
                this.cotisation = [] as any;
                for (let item of _data["cotisation"])
                    this.cotisation!.push(Cotisation.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur10.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning6.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGFDResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGFDResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["periodicitePaiement"] = this.periodicitePaiement;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        if (Array.isArray(this.cotisation)) {
            data["cotisation"] = [];
            for (let item of this.cotisation)
                data["cotisation"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTarifsPrevoyanceGFDResponse {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation[] | undefined;
    erreurs?: Erreur10[] | undefined;
    warnings?: Warning6[] | undefined;
}

export class PrevoyanceGFD implements IPrevoyanceGFD {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;

    constructor(data?: IPrevoyanceGFD) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.periodicitePaiement = _data["periodicitePaiement"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
        }
    }

    static fromJS(data: any): PrevoyanceGFD {
        data = typeof data === 'object' ? data : {};
        let result = new PrevoyanceGFD();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["periodicitePaiement"] = this.periodicitePaiement;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        return data;
    }
}

export interface IPrevoyanceGFD {
    age?: number;
    periodicitePaiement?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
}

export class Warning6 implements IWarning6 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning6 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning6 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class Cotisation2 implements ICotisation2 {
    age?: number;
    mntCotisation?: number | undefined;

    constructor(data?: ICotisation2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.mntCotisation = _data["mntCotisation"];
        }
    }

    static fromJS(data: any): Cotisation2 {
        data = typeof data === 'object' ? data : {};
        let result = new Cotisation2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["mntCotisation"] = this.mntCotisation;
        return data;
    }
}

export interface ICotisation2 {
    age?: number;
    mntCotisation?: number | undefined;
}

export class Erreur11 implements IErreur11 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur11 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur11 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetTarifsPrevoyanceGPARequest implements IGetTarifsPrevoyanceGPARequest {
    prevoyanceGPA?: PrevoyanceGPA;

    constructor(data?: IGetTarifsPrevoyanceGPARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prevoyanceGPA = _data["prevoyanceGPA"] ? PrevoyanceGPA.fromJS(_data["prevoyanceGPA"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGPARequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGPARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prevoyanceGPA"] = this.prevoyanceGPA ? this.prevoyanceGPA.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTarifsPrevoyanceGPARequest {
    prevoyanceGPA?: PrevoyanceGPA;
}

export class GetTarifsPrevoyanceGPAResponse implements IGetTarifsPrevoyanceGPAResponse {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation2[] | undefined;
    erreurs?: Erreur11[] | undefined;
    warnings?: Warning7[] | undefined;

    constructor(data?: IGetTarifsPrevoyanceGPAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.option = _data["option"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
            if (Array.isArray(_data["cotisation"])) {
                this.cotisation = [] as any;
                for (let item of _data["cotisation"])
                    this.cotisation!.push(Cotisation2.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur11.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(Warning7.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTarifsPrevoyanceGPAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTarifsPrevoyanceGPAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["option"] = this.option;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        if (Array.isArray(this.cotisation)) {
            data["cotisation"] = [];
            for (let item of this.cotisation)
                data["cotisation"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTarifsPrevoyanceGPAResponse {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
    cotisation?: Cotisation2[] | undefined;
    erreurs?: Erreur11[] | undefined;
    warnings?: Warning7[] | undefined;
}

export class PrevoyanceGPA implements IPrevoyanceGPA {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;

    constructor(data?: IPrevoyanceGPA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.age = _data["age"];
            this.option = _data["option"];
            this.mntCapital = _data["mntCapital"];
            this.nbAnnees = _data["nbAnnees"];
        }
    }

    static fromJS(data: any): PrevoyanceGPA {
        data = typeof data === 'object' ? data : {};
        let result = new PrevoyanceGPA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["age"] = this.age;
        data["option"] = this.option;
        data["mntCapital"] = this.mntCapital;
        data["nbAnnees"] = this.nbAnnees;
        return data;
    }
}

export interface IPrevoyanceGPA {
    age?: number;
    option?: number;
    mntCapital?: number;
    nbAnnees?: number | undefined;
}

export class Warning7 implements IWarning7 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;

    constructor(data?: IWarning7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeWarning = _data["codeWarning"];
            this.libelleWarning = _data["libelleWarning"];
        }
    }

    static fromJS(data: any): Warning7 {
        data = typeof data === 'object' ? data : {};
        let result = new Warning7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeWarning"] = this.codeWarning;
        data["libelleWarning"] = this.libelleWarning;
        return data;
    }
}

export interface IWarning7 {
    codeWarning?: number | undefined;
    libelleWarning?: string | undefined;
}

export class ClasseActifs implements IClasseActifs {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: IClasseActifs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): ClasseActifs {
        data = typeof data === 'object' ? data : {};
        let result = new ClasseActifs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IClasseActifs {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class Document implements IDocument {
    id?: string | undefined;
    libelle?: string | undefined;
    produits?: Produit2[] | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            if (Array.isArray(_data["produits"])) {
                this.produits = [] as any;
                for (let item of _data["produits"])
                    this.produits!.push(Produit2.fromJS(item));
            }
            this.type = _data["type"] ? TypeDocument.fromJS(_data["type"]) : <any>undefined;
            this.cheminFichier = _data["cheminFichier"];
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        if (Array.isArray(this.produits)) {
            data["produits"] = [];
            for (let item of this.produits)
                data["produits"].push(item.toJSON());
        }
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["cheminFichier"] = this.cheminFichier;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IDocument {
    id?: string | undefined;
    libelle?: string | undefined;
    produits?: Produit2[] | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
}

export class Document2 implements IDocument2 {
    id?: number | undefined;
    libelle?: string | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
    statut?: boolean | undefined;
    dateMaj?: number | undefined;
    codeEditique?: string | undefined;

    constructor(data?: IDocument2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? TypeDocument.fromJS(_data["type"]) : <any>undefined;
            this.cheminFichier = _data["cheminFichier"];
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
            this.statut = _data["statut"];
            this.dateMaj = _data["dateMaj"];
            this.codeEditique = _data["codeEditique"];
        }
    }

    static fromJS(data: any): Document2 {
        data = typeof data === 'object' ? data : {};
        let result = new Document2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["cheminFichier"] = this.cheminFichier;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        data["statut"] = this.statut;
        data["dateMaj"] = this.dateMaj;
        data["codeEditique"] = this.codeEditique;
        return data;
    }
}

export interface IDocument2 {
    id?: number | undefined;
    libelle?: string | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
    statut?: boolean | undefined;
    dateMaj?: number | undefined;
    codeEditique?: string | undefined;
}

export class Document3 implements IDocument3 {
    id?: string | undefined;
    libelle?: string | undefined;
    libelleArticle?: string | undefined;
    libelleSuffixe?: string | undefined;
    ordre?: number | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;

    constructor(data?: IDocument3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.libelleArticle = _data["libelleArticle"];
            this.libelleSuffixe = _data["libelleSuffixe"];
            this.ordre = _data["ordre"];
            this.type = _data["type"] ? TypeDocument.fromJS(_data["type"]) : <any>undefined;
            this.cheminFichier = _data["cheminFichier"];
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): Document3 {
        data = typeof data === 'object' ? data : {};
        let result = new Document3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["libelleArticle"] = this.libelleArticle;
        data["libelleSuffixe"] = this.libelleSuffixe;
        data["ordre"] = this.ordre;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["cheminFichier"] = this.cheminFichier;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IDocument3 {
    id?: string | undefined;
    libelle?: string | undefined;
    libelleArticle?: string | undefined;
    libelleSuffixe?: string | undefined;
    ordre?: number | undefined;
    type?: TypeDocument;
    cheminFichier?: string | undefined;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
}

export class Document4 implements IDocument4 {
    id?: string | undefined;
    libelle?: string | undefined;
    type?: Type;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;

    constructor(data?: IDocument4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? Type.fromJS(_data["type"]) : <any>undefined;
            this.nomenclature = _data["nomenclature"];
            this.fichierAttache = _data["fichierAttache"];
        }
    }

    static fromJS(data: any): Document4 {
        data = typeof data === 'object' ? data : {};
        let result = new Document4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["nomenclature"] = this.nomenclature;
        data["fichierAttache"] = this.fichierAttache;
        return data;
    }
}

export interface IDocument4 {
    id?: string | undefined;
    libelle?: string | undefined;
    type?: Type;
    nomenclature?: string | undefined;
    fichierAttache?: string | undefined;
}

export class DocumentsProduitSignatureSouscriptionEnLigneRequest implements IDocumentsProduitSignatureSouscriptionEnLigneRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean | undefined;
    fonds?: number[] | undefined;

    constructor(data?: IDocumentsProduitSignatureSouscriptionEnLigneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
            if (Array.isArray(_data["fonds"])) {
                this.fonds = [] as any;
                for (let item of _data["fonds"])
                    this.fonds!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentsProduitSignatureSouscriptionEnLigneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsProduitSignatureSouscriptionEnLigneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        if (Array.isArray(this.fonds)) {
            data["fonds"] = [];
            for (let item of this.fonds)
                data["fonds"].push(item);
        }
        return data;
    }
}

export interface IDocumentsProduitSignatureSouscriptionEnLigneRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean | undefined;
    fonds?: number[] | undefined;
}

export class DocumentsProduitSignatureSouscriptionEnLigneResponse implements IDocumentsProduitSignatureSouscriptionEnLigneResponse {
    document?: Document3[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IDocumentsProduitSignatureSouscriptionEnLigneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentsProduitSignatureSouscriptionEnLigneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsProduitSignatureSouscriptionEnLigneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentsProduitSignatureSouscriptionEnLigneResponse {
    document?: Document3[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class EntetePDF implements IEntetePDF {
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;

    constructor(data?: IEntetePDF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeOperation = _data["codeOperation"];
            this.codePromotion = _data["codePromotion"];
            this.codeApporteur = _data["codeApporteur"];
        }
    }

    static fromJS(data: any): EntetePDF {
        data = typeof data === 'object' ? data : {};
        let result = new EntetePDF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeOperation"] = this.codeOperation;
        data["codePromotion"] = this.codePromotion;
        data["codeApporteur"] = this.codeApporteur;
        return data;
    }
}

export interface IEntetePDF {
    codeOperation?: string | undefined;
    codePromotion?: string | undefined;
    codeApporteur?: string | undefined;
}

export class Erreur12 implements IErreur12 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur12 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur12 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class Fonds implements IFonds {
    id?: number | undefined;
    libelle?: string | undefined;
    nomCommercial?: string | undefined;
    typeFonds?: TypeFonds;
    codeISIN?: string | undefined;
    niveauRisque?: number | undefined;
    codeGarantie?: string | undefined;
    ordre?: number | undefined;
    devise?: string | undefined;
    risqueChange?: string | undefined;
    fraisGestionMax?: number | undefined;
    signatairePRI?: string | undefined;
    classificationInvestissementResponsable?: string | undefined;
    estCommercialise?: boolean | undefined;
    estAffiche?: boolean | undefined;
    debutDateCommercialisation?: Date | undefined;
    finDateCommercialisation?: Date | undefined;
    typeRegle?: TypeRegle[] | undefined;
    document?: Document[] | undefined;
    classeActifs?: ClasseActifs;
    classeActifs2?: ClasseActifs;
    classeActifs3?: ClasseActifs;
    classeActifs4?: ClasseActifs;
    performance?: Performance[] | undefined;
    zoneGeographique?: ZoneGeographique[] | undefined;
    gestionnaire?: Gestionnaire;

    constructor(data?: IFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.nomCommercial = _data["nomCommercial"];
            this.typeFonds = _data["typeFonds"] ? TypeFonds.fromJS(_data["typeFonds"]) : <any>undefined;
            this.codeISIN = _data["codeISIN"];
            this.niveauRisque = _data["niveauRisque"];
            this.codeGarantie = _data["codeGarantie"];
            this.ordre = _data["ordre"];
            this.devise = _data["devise"];
            this.risqueChange = _data["risqueChange"];
            this.fraisGestionMax = _data["fraisGestionMax"];
            this.signatairePRI = _data["signatairePRI"];
            this.classificationInvestissementResponsable = _data["classificationInvestissementResponsable"];
            this.estCommercialise = _data["estCommercialise"];
            this.estAffiche = _data["estAffiche"];
            this.debutDateCommercialisation = _data["debutDateCommercialisation"] ? new Date(_data["debutDateCommercialisation"].toString()) : <any>undefined;
            this.finDateCommercialisation = _data["finDateCommercialisation"] ? new Date(_data["finDateCommercialisation"].toString()) : <any>undefined;
            if (Array.isArray(_data["typeRegle"])) {
                this.typeRegle = [] as any;
                for (let item of _data["typeRegle"])
                    this.typeRegle!.push(TypeRegle.fromJS(item));
            }
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            this.classeActifs = _data["classeActifs"] ? ClasseActifs.fromJS(_data["classeActifs"]) : <any>undefined;
            this.classeActifs2 = _data["classeActifs2"] ? ClasseActifs.fromJS(_data["classeActifs2"]) : <any>undefined;
            this.classeActifs3 = _data["classeActifs3"] ? ClasseActifs.fromJS(_data["classeActifs3"]) : <any>undefined;
            this.classeActifs4 = _data["classeActifs4"] ? ClasseActifs.fromJS(_data["classeActifs4"]) : <any>undefined;
            if (Array.isArray(_data["performance"])) {
                this.performance = [] as any;
                for (let item of _data["performance"])
                    this.performance!.push(Performance.fromJS(item));
            }
            if (Array.isArray(_data["zoneGeographique"])) {
                this.zoneGeographique = [] as any;
                for (let item of _data["zoneGeographique"])
                    this.zoneGeographique!.push(ZoneGeographique.fromJS(item));
            }
            this.gestionnaire = _data["gestionnaire"] ? Gestionnaire.fromJS(_data["gestionnaire"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Fonds {
        data = typeof data === 'object' ? data : {};
        let result = new Fonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["nomCommercial"] = this.nomCommercial;
        data["typeFonds"] = this.typeFonds ? this.typeFonds.toJSON() : <any>undefined;
        data["codeISIN"] = this.codeISIN;
        data["niveauRisque"] = this.niveauRisque;
        data["codeGarantie"] = this.codeGarantie;
        data["ordre"] = this.ordre;
        data["devise"] = this.devise;
        data["risqueChange"] = this.risqueChange;
        data["fraisGestionMax"] = this.fraisGestionMax;
        data["signatairePRI"] = this.signatairePRI;
        data["classificationInvestissementResponsable"] = this.classificationInvestissementResponsable;
        data["estCommercialise"] = this.estCommercialise;
        data["estAffiche"] = this.estAffiche;
        data["debutDateCommercialisation"] = this.debutDateCommercialisation ? this.debutDateCommercialisation.toISOString() : <any>undefined;
        data["finDateCommercialisation"] = this.finDateCommercialisation ? this.finDateCommercialisation.toISOString() : <any>undefined;
        if (Array.isArray(this.typeRegle)) {
            data["typeRegle"] = [];
            for (let item of this.typeRegle)
                data["typeRegle"].push(item.toJSON());
        }
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        data["classeActifs"] = this.classeActifs ? this.classeActifs.toJSON() : <any>undefined;
        data["classeActifs2"] = this.classeActifs2 ? this.classeActifs2.toJSON() : <any>undefined;
        data["classeActifs3"] = this.classeActifs3 ? this.classeActifs3.toJSON() : <any>undefined;
        data["classeActifs4"] = this.classeActifs4 ? this.classeActifs4.toJSON() : <any>undefined;
        if (Array.isArray(this.performance)) {
            data["performance"] = [];
            for (let item of this.performance)
                data["performance"].push(item.toJSON());
        }
        if (Array.isArray(this.zoneGeographique)) {
            data["zoneGeographique"] = [];
            for (let item of this.zoneGeographique)
                data["zoneGeographique"].push(item.toJSON());
        }
        data["gestionnaire"] = this.gestionnaire ? this.gestionnaire.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFonds {
    id?: number | undefined;
    libelle?: string | undefined;
    nomCommercial?: string | undefined;
    typeFonds?: TypeFonds;
    codeISIN?: string | undefined;
    niveauRisque?: number | undefined;
    codeGarantie?: string | undefined;
    ordre?: number | undefined;
    devise?: string | undefined;
    risqueChange?: string | undefined;
    fraisGestionMax?: number | undefined;
    signatairePRI?: string | undefined;
    classificationInvestissementResponsable?: string | undefined;
    estCommercialise?: boolean | undefined;
    estAffiche?: boolean | undefined;
    debutDateCommercialisation?: Date | undefined;
    finDateCommercialisation?: Date | undefined;
    typeRegle?: TypeRegle[] | undefined;
    document?: Document[] | undefined;
    classeActifs?: ClasseActifs;
    classeActifs2?: ClasseActifs;
    classeActifs3?: ClasseActifs;
    classeActifs4?: ClasseActifs;
    performance?: Performance[] | undefined;
    zoneGeographique?: ZoneGeographique[] | undefined;
    gestionnaire?: Gestionnaire;
}

export class FondsRepartition implements IFondsRepartition {
    fonds?: Fonds;
    repartition?: number | undefined;
    titre?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IFondsRepartition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fonds = _data["fonds"] ? Fonds.fromJS(_data["fonds"]) : <any>undefined;
            this.repartition = _data["repartition"];
            this.titre = _data["titre"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): FondsRepartition {
        data = typeof data === 'object' ? data : {};
        let result = new FondsRepartition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fonds"] = this.fonds ? this.fonds.toJSON() : <any>undefined;
        data["repartition"] = this.repartition;
        data["titre"] = this.titre;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IFondsRepartition {
    fonds?: Fonds;
    repartition?: number | undefined;
    titre?: string | undefined;
    libelle?: string | undefined;
}

export class Gestionnaire implements IGestionnaire {
    id?: number | undefined;
    libelle?: string | undefined;
    noteGestionnaireDonneeOFI?: number | undefined;
    noteISR?: number | undefined;

    constructor(data?: IGestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.noteGestionnaireDonneeOFI = _data["noteGestionnaireDonneeOFI"];
            this.noteISR = _data["noteISR"];
        }
    }

    static fromJS(data: any): Gestionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Gestionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["noteGestionnaireDonneeOFI"] = this.noteGestionnaireDonneeOFI;
        data["noteISR"] = this.noteISR;
        return data;
    }
}

export interface IGestionnaire {
    id?: number | undefined;
    libelle?: string | undefined;
    noteGestionnaireDonneeOFI?: number | undefined;
    noteISR?: number | undefined;
}

export class GetCodeCommuneRequest implements IGetCodeCommuneRequest {
    codeDepartement?: string | undefined;
    libelleCommune?: string | undefined;
    dateNaissance?: Date;

    constructor(data?: IGetCodeCommuneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeDepartement = _data["codeDepartement"];
            this.libelleCommune = _data["libelleCommune"];
            this.dateNaissance = _data["dateNaissance"] ? new Date(_data["dateNaissance"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCodeCommuneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodeCommuneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeDepartement"] = this.codeDepartement;
        data["libelleCommune"] = this.libelleCommune;
        data["dateNaissance"] = this.dateNaissance ? this.dateNaissance.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetCodeCommuneRequest {
    codeDepartement?: string | undefined;
    libelleCommune?: string | undefined;
    dateNaissance?: Date;
}

export class GetCodeCommuneResponse implements IGetCodeCommuneResponse {
    codeCommune?: string | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetCodeCommuneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeCommune = _data["codeCommune"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCodeCommuneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodeCommuneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeCommune"] = this.codeCommune;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCodeCommuneResponse {
    codeCommune?: string | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetDocumentPackProduitRequest implements IGetDocumentPackProduitRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentPackProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentPackProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentPackProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentPackProduitRequest {
    codeProduit?: string | undefined;
    lireDocuments?: boolean;
}

export class GetDocumentPackProduitResponse implements IGetDocumentPackProduitResponse {
    lienDocuments?: LienDocuments[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDocumentPackProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lienDocuments"])) {
                this.lienDocuments = [] as any;
                for (let item of _data["lienDocuments"])
                    this.lienDocuments!.push(LienDocuments.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentPackProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentPackProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lienDocuments)) {
            data["lienDocuments"] = [];
            for (let item of this.lienDocuments)
                data["lienDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocumentPackProduitResponse {
    lienDocuments?: LienDocuments[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetDocumentsFichierRequest implements IGetDocumentsFichierRequest {
    repertoireRefMetier?: string | undefined;
    cheminFichier?: string | undefined;
    idDocument?: number;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentsFichierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repertoireRefMetier = _data["repertoireRefMetier"];
            this.cheminFichier = _data["cheminFichier"];
            this.idDocument = _data["idDocument"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentsFichierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFichierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repertoireRefMetier"] = this.repertoireRefMetier;
        data["cheminFichier"] = this.cheminFichier;
        data["idDocument"] = this.idDocument;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentsFichierRequest {
    repertoireRefMetier?: string | undefined;
    cheminFichier?: string | undefined;
    idDocument?: number;
    lireDocuments?: boolean;
}

export class GetDocumentsFichierResponse implements IGetDocumentsFichierResponse {
    document?: Document2[] | undefined;
    repertoireRefMetier?: string | undefined;
    repertoiresRefMetier?: string | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDocumentsFichierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document2.fromJS(item));
            }
            this.repertoireRefMetier = _data["repertoireRefMetier"];
            this.repertoiresRefMetier = _data["repertoiresRefMetier"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsFichierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFichierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        data["repertoireRefMetier"] = this.repertoireRefMetier;
        data["repertoiresRefMetier"] = this.repertoiresRefMetier;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocumentsFichierResponse {
    document?: Document2[] | undefined;
    repertoireRefMetier?: string | undefined;
    repertoiresRefMetier?: string | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetDocumentsFondsRequest implements IGetDocumentsFondsRequest {
    idTypeDocument?: number | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentsFondsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
            this.idFonds = _data["idFonds"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentsFondsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFondsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        data["idFonds"] = this.idFonds;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentsFondsRequest {
    idTypeDocument?: number | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;
}

export class GetDocumentsFondsResponse implements IGetDocumentsFondsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDocumentsFondsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsFondsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsFondsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocumentsFondsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetDocumentsProduitRequest implements IGetDocumentsProduitRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IGetDocumentsProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): GetDocumentsProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IGetDocumentsProduitRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;
}

export class GetDocumentsProduitResponse implements IGetDocumentsProduitResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDocumentsProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentsProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentsProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDocumentsProduitResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetDonneesArbitrageRequest implements IGetDonneesArbitrageRequest {
    numeroContrat?: number | undefined;
    montantFondsEuroDesinvesti?: number;

    constructor(data?: IGetDonneesArbitrageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.montantFondsEuroDesinvesti = _data["montantFondsEuroDesinvesti"];
        }
    }

    static fromJS(data: any): GetDonneesArbitrageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesArbitrageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["montantFondsEuroDesinvesti"] = this.montantFondsEuroDesinvesti;
        return data;
    }
}

export interface IGetDonneesArbitrageRequest {
    numeroContrat?: number | undefined;
    montantFondsEuroDesinvesti?: number;
}

export class GetDonneesArbitrageResponse implements IGetDonneesArbitrageResponse {
    montantsSeuils?: MontantsSeuilsArbitrage;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDonneesArbitrageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantsSeuils = _data["montantsSeuils"] ? MontantsSeuilsArbitrage.fromJS(_data["montantsSeuils"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonneesArbitrageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesArbitrageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantsSeuils"] = this.montantsSeuils ? this.montantsSeuils.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDonneesArbitrageResponse {
    montantsSeuils?: MontantsSeuilsArbitrage;
    erreurs?: Erreur12[] | undefined;
}

export class GetDonneesRachatRequest implements IGetDonneesRachatRequest {
    numeroContrat?: number | undefined;
    montantRachat?: number;

    constructor(data?: IGetDonneesRachatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.montantRachat = _data["montantRachat"];
        }
    }

    static fromJS(data: any): GetDonneesRachatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesRachatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["montantRachat"] = this.montantRachat;
        return data;
    }
}

export interface IGetDonneesRachatRequest {
    numeroContrat?: number | undefined;
    montantRachat?: number;
}

export class GetDonneesRachatResponse implements IGetDonneesRachatResponse {
    montantsSeuils?: MontantsSeuilsRachat;
    motif?: MotifRachat[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDonneesRachatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantsSeuils = _data["montantsSeuils"] ? MontantsSeuilsRachat.fromJS(_data["montantsSeuils"]) : <any>undefined;
            if (Array.isArray(_data["motif"])) {
                this.motif = [] as any;
                for (let item of _data["motif"])
                    this.motif!.push(MotifRachat.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonneesRachatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesRachatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantsSeuils"] = this.montantsSeuils ? this.montantsSeuils.toJSON() : <any>undefined;
        if (Array.isArray(this.motif)) {
            data["motif"] = [];
            for (let item of this.motif)
                data["motif"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDonneesRachatResponse {
    montantsSeuils?: MontantsSeuilsRachat;
    motif?: MotifRachat[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetDonneesVersementRequest implements IGetDonneesVersementRequest {
    numeroContrat?: number | undefined;
    etapeContrat?: string | undefined;
    montantVersement?: number;
    montantRevenuNetMensuel?: number;
    montantPatrimoineFoyer?: number;

    constructor(data?: IGetDonneesVersementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.etapeContrat = _data["etapeContrat"];
            this.montantVersement = _data["montantVersement"];
            this.montantRevenuNetMensuel = _data["montantRevenuNetMensuel"];
            this.montantPatrimoineFoyer = _data["montantPatrimoineFoyer"];
        }
    }

    static fromJS(data: any): GetDonneesVersementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesVersementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["etapeContrat"] = this.etapeContrat;
        data["montantVersement"] = this.montantVersement;
        data["montantRevenuNetMensuel"] = this.montantRevenuNetMensuel;
        data["montantPatrimoineFoyer"] = this.montantPatrimoineFoyer;
        return data;
    }
}

export interface IGetDonneesVersementRequest {
    numeroContrat?: number | undefined;
    etapeContrat?: string | undefined;
    montantVersement?: number;
    montantRevenuNetMensuel?: number;
    montantPatrimoineFoyer?: number;
}

export class GetDonneesVersementResponse implements IGetDonneesVersementResponse {
    montantsSeuils?: MontantsSeuilsVersement;
    provenanceFonds?: ProvenanceFonds[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetDonneesVersementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantsSeuils = _data["montantsSeuils"] ? MontantsSeuilsVersement.fromJS(_data["montantsSeuils"]) : <any>undefined;
            if (Array.isArray(_data["provenanceFonds"])) {
                this.provenanceFonds = [] as any;
                for (let item of _data["provenanceFonds"])
                    this.provenanceFonds!.push(ProvenanceFonds.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDonneesVersementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDonneesVersementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantsSeuils"] = this.montantsSeuils ? this.montantsSeuils.toJSON() : <any>undefined;
        if (Array.isArray(this.provenanceFonds)) {
            data["provenanceFonds"] = [];
            for (let item of this.provenanceFonds)
                data["provenanceFonds"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDonneesVersementResponse {
    montantsSeuils?: MontantsSeuilsVersement;
    provenanceFonds?: ProvenanceFonds[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetFichierPDFRequest implements IGetFichierPDFRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    personne?: Personne;
    entetePDF?: EntetePDF;

    constructor(data?: IGetFichierPDFRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
            this.codeProduit = _data["codeProduit"];
            this.personne = _data["personne"] ? Personne.fromJS(_data["personne"]) : <any>undefined;
            this.entetePDF = _data["entetePDF"] ? EntetePDF.fromJS(_data["entetePDF"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFichierPDFRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFichierPDFRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        data["codeProduit"] = this.codeProduit;
        data["personne"] = this.personne ? this.personne.toJSON() : <any>undefined;
        data["entetePDF"] = this.entetePDF ? this.entetePDF.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFichierPDFRequest {
    idTypeDocument?: number | undefined;
    codeProduit?: string | undefined;
    personne?: Personne;
    entetePDF?: EntetePDF;
}

export class GetFichierPDFResponse implements IGetFichierPDFResponse {
    document?: Document;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetFichierPDFResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFichierPDFResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFichierPDFResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFichierPDFResponse {
    document?: Document;
    erreurs?: Erreur12[] | undefined;
}

export class GetFondsProduitRequest implements IGetFondsProduitRequest {
    codeProduit?: string | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;

    constructor(data?: IGetFondsProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.idFonds = _data["idFonds"];
            this.lireDocuments = _data["lireDocuments"];
            this.idCanal = _data["idCanal"];
            this.idDemarche = _data["idDemarche"];
        }
    }

    static fromJS(data: any): GetFondsProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFondsProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["idFonds"] = this.idFonds;
        data["lireDocuments"] = this.lireDocuments;
        data["idCanal"] = this.idCanal;
        data["idDemarche"] = this.idDemarche;
        return data;
    }
}

export interface IGetFondsProduitRequest {
    codeProduit?: string | undefined;
    idFonds?: string | undefined;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;
}

export class GetFondsProduitResponse implements IGetFondsProduitResponse {
    fonds?: Fonds[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetFondsProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fonds"])) {
                this.fonds = [] as any;
                for (let item of _data["fonds"])
                    this.fonds!.push(Fonds.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFondsProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFondsProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fonds)) {
            data["fonds"] = [];
            for (let item of this.fonds)
                data["fonds"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFondsProduitResponse {
    fonds?: Fonds[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetFraisVersementRequest implements IGetFraisVersementRequest {
    numeroContrat?: number;
    transfertPacte?: boolean;
    pourcentageVersementFondsEuro?: number;
    montantVerse?: number | undefined;

    constructor(data?: IGetFraisVersementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroContrat = _data["numeroContrat"];
            this.transfertPacte = _data["transfertPacte"];
            this.pourcentageVersementFondsEuro = _data["pourcentageVersementFondsEuro"];
            this.montantVerse = _data["montantVerse"];
        }
    }

    static fromJS(data: any): GetFraisVersementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFraisVersementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroContrat"] = this.numeroContrat;
        data["transfertPacte"] = this.transfertPacte;
        data["pourcentageVersementFondsEuro"] = this.pourcentageVersementFondsEuro;
        data["montantVerse"] = this.montantVerse;
        return data;
    }
}

export interface IGetFraisVersementRequest {
    numeroContrat?: number;
    transfertPacte?: boolean;
    pourcentageVersementFondsEuro?: number;
    montantVerse?: number | undefined;
}

export class GetFraisVersementResponse implements IGetFraisVersementResponse {
    versement?: Versement;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetFraisVersementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versement = _data["versement"] ? Versement.fromJS(_data["versement"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFraisVersementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFraisVersementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versement"] = this.versement ? this.versement.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFraisVersementResponse {
    versement?: Versement;
    erreurs?: Erreur12[] | undefined;
}

export class GetGrilleDesensibilisationCERURequest implements IGetGrilleDesensibilisationCERURequest {

    constructor(data?: IGetGrilleDesensibilisationCERURequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetGrilleDesensibilisationCERURequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGrilleDesensibilisationCERURequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetGrilleDesensibilisationCERURequest {
}

export class GetGrilleDesensibilisationCERUResponse implements IGetGrilleDesensibilisationCERUResponse {
    grilleDesensibilisation?: GrilleDesensibilisation;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetGrilleDesensibilisationCERUResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grilleDesensibilisation = _data["grilleDesensibilisation"] ? GrilleDesensibilisation.fromJS(_data["grilleDesensibilisation"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGrilleDesensibilisationCERUResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGrilleDesensibilisationCERUResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grilleDesensibilisation"] = this.grilleDesensibilisation ? this.grilleDesensibilisation.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGrilleDesensibilisationCERUResponse {
    grilleDesensibilisation?: GrilleDesensibilisation;
    erreurs?: Erreur12[] | undefined;
}

export class GetListeDocumentsRequest implements IGetListeDocumentsRequest {
    identifiant?: number;
    idTypeDocument?: number;
    modeLecture?: string | undefined;

    constructor(data?: IGetListeDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifiant = _data["identifiant"];
            this.idTypeDocument = _data["idTypeDocument"];
            this.modeLecture = _data["modeLecture"];
        }
    }

    static fromJS(data: any): GetListeDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListeDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifiant"] = this.identifiant;
        data["idTypeDocument"] = this.idTypeDocument;
        data["modeLecture"] = this.modeLecture;
        return data;
    }
}

export interface IGetListeDocumentsRequest {
    identifiant?: number;
    idTypeDocument?: number;
    modeLecture?: string | undefined;
}

export class GetListeDocumentsResponse implements IGetListeDocumentsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetListeDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListeDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListeDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetListeDocumentsResponse {
    document?: Document[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetOrigineDemandeRequest implements IGetOrigineDemandeRequest {

    constructor(data?: IGetOrigineDemandeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrigineDemandeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrigineDemandeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrigineDemandeRequest {
}

export class GetOrigineDemandeResponse implements IGetOrigineDemandeResponse {
    origineDemande?: OrigineDemande[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetOrigineDemandeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["origineDemande"])) {
                this.origineDemande = [] as any;
                for (let item of _data["origineDemande"])
                    this.origineDemande!.push(OrigineDemande.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrigineDemandeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrigineDemandeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.origineDemande)) {
            data["origineDemande"] = [];
            for (let item of this.origineDemande)
                data["origineDemande"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrigineDemandeResponse {
    origineDemande?: OrigineDemande[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetProduitsRequest implements IGetProduitsRequest {
    produitSouscriptionLigne?: boolean;

    constructor(data?: IGetProduitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.produitSouscriptionLigne = _data["produitSouscriptionLigne"];
        }
    }

    static fromJS(data: any): GetProduitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProduitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["produitSouscriptionLigne"] = this.produitSouscriptionLigne;
        return data;
    }
}

export interface IGetProduitsRequest {
    produitSouscriptionLigne?: boolean;
}

export class GetProduitsResponse implements IGetProduitsResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetProduitsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["produit"])) {
                this.produit = [] as any;
                for (let item of _data["produit"])
                    this.produit!.push(Produit3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProduitsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProduitsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.produit)) {
            data["produit"] = [];
            for (let item of this.produit)
                data["produit"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProduitsResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetProfils implements IGetProfils {

    constructor(data?: IGetProfils) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetProfils {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfils();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetProfils {
}

export class GetProfilsResponse implements IGetProfilsResponse {
    profils?: Profil[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetProfilsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profils"])) {
                this.profils = [] as any;
                for (let item of _data["profils"])
                    this.profils!.push(Profil.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfilsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profils)) {
            data["profils"] = [];
            for (let item of this.profils)
                data["profils"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProfilsResponse {
    profils?: Profil[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetRUMRequest implements IGetRUMRequest {

    constructor(data?: IGetRUMRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRUMRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRUMRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRUMRequest {
}

export class GetRUMResponse implements IGetRUMResponse {
    RUM?: string | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetRUMResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.RUM = _data["RUM"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRUMResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRUMResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RUM"] = this.RUM;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRUMResponse {
    RUM?: string | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetRecommandationRequest implements IGetRecommandationRequest {
    score?: number | undefined;
    codeProduit?: string | undefined;
    idDemarche?: number | undefined;
    montantVerse?: number | undefined;
    transfertPACTE?: boolean | undefined;
    echeancePrecise?: boolean | undefined;
    souscriptionProfitEnfant?: boolean | undefined;
    lireDocuments?: boolean | undefined;
    dateEstimationDepartRetraite?: Date;
    flagDurabilite?: boolean | undefined;

    constructor(data?: IGetRecommandationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.codeProduit = _data["codeProduit"];
            this.idDemarche = _data["idDemarche"];
            this.montantVerse = _data["montantVerse"];
            this.transfertPACTE = _data["transfertPACTE"];
            this.echeancePrecise = _data["echeancePrecise"];
            this.souscriptionProfitEnfant = _data["souscriptionProfitEnfant"];
            this.lireDocuments = _data["lireDocuments"];
            this.dateEstimationDepartRetraite = _data["dateEstimationDepartRetraite"] ? new Date(_data["dateEstimationDepartRetraite"].toString()) : <any>undefined;
            this.flagDurabilite = _data["flagDurabilite"];
        }
    }

    static fromJS(data: any): GetRecommandationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommandationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["codeProduit"] = this.codeProduit;
        data["idDemarche"] = this.idDemarche;
        data["montantVerse"] = this.montantVerse;
        data["transfertPACTE"] = this.transfertPACTE;
        data["echeancePrecise"] = this.echeancePrecise;
        data["souscriptionProfitEnfant"] = this.souscriptionProfitEnfant;
        data["lireDocuments"] = this.lireDocuments;
        data["dateEstimationDepartRetraite"] = this.dateEstimationDepartRetraite ? this.dateEstimationDepartRetraite.toISOString() : <any>undefined;
        data["flagDurabilite"] = this.flagDurabilite;
        return data;
    }
}

export interface IGetRecommandationRequest {
    score?: number | undefined;
    codeProduit?: string | undefined;
    idDemarche?: number | undefined;
    montantVerse?: number | undefined;
    transfertPACTE?: boolean | undefined;
    echeancePrecise?: boolean | undefined;
    souscriptionProfitEnfant?: boolean | undefined;
    lireDocuments?: boolean | undefined;
    dateEstimationDepartRetraite?: Date;
    flagDurabilite?: boolean | undefined;
}

export class GetRecommandationResponse implements IGetRecommandationResponse {
    recommandation?: Recommandation;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetRecommandationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommandation = _data["recommandation"] ? Recommandation.fromJS(_data["recommandation"]) : <any>undefined;
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecommandationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommandationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommandation"] = this.recommandation ? this.recommandation.toJSON() : <any>undefined;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecommandationResponse {
    recommandation?: Recommandation;
    erreurs?: Erreur12[] | undefined;
}

export class GetReglesMetierProduitRequest implements IGetReglesMetierProduitRequest {
    codeProduit?: string | undefined;
    idTypeProduit?: number;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;

    constructor(data?: IGetReglesMetierProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
            this.idTypeProduit = _data["idTypeProduit"];
            this.lireDocuments = _data["lireDocuments"];
            this.idCanal = _data["idCanal"];
            this.idDemarche = _data["idDemarche"];
        }
    }

    static fromJS(data: any): GetReglesMetierProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReglesMetierProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        data["idTypeProduit"] = this.idTypeProduit;
        data["lireDocuments"] = this.lireDocuments;
        data["idCanal"] = this.idCanal;
        data["idDemarche"] = this.idDemarche;
        return data;
    }
}

export interface IGetReglesMetierProduitRequest {
    codeProduit?: string | undefined;
    idTypeProduit?: number;
    lireDocuments?: boolean;
    idCanal?: number | undefined;
    idDemarche?: number | undefined;
}

export class GetReglesMetierProduitResponse implements IGetReglesMetierProduitResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetReglesMetierProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["produit"])) {
                this.produit = [] as any;
                for (let item of _data["produit"])
                    this.produit!.push(Produit3.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReglesMetierProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReglesMetierProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.produit)) {
            data["produit"] = [];
            for (let item of this.produit)
                data["produit"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReglesMetierProduitResponse {
    produit?: Produit3[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GetTypePDFDocumentProduitRequest implements IGetTypePDFDocumentProduitRequest {
    idTypeDocument?: number | undefined;

    constructor(data?: IGetTypePDFDocumentProduitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeDocument = _data["idTypeDocument"];
        }
    }

    static fromJS(data: any): GetTypePDFDocumentProduitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypePDFDocumentProduitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeDocument"] = this.idTypeDocument;
        return data;
    }
}

export interface IGetTypePDFDocumentProduitRequest {
    idTypeDocument?: number | undefined;
}

export class GetTypePDFDocumentProduitResponse implements IGetTypePDFDocumentProduitResponse {
    PDFDynamique?: boolean;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetTypePDFDocumentProduitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.PDFDynamique = _data["PDFDynamique"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTypePDFDocumentProduitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypePDFDocumentProduitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PDFDynamique"] = this.PDFDynamique;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTypePDFDocumentProduitResponse {
    PDFDynamique?: boolean;
    erreurs?: Erreur12[] | undefined;
}

export class GetTypesDocumentsRequest implements IGetTypesDocumentsRequest {
    codeProduit?: string | undefined;

    constructor(data?: IGetTypesDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeProduit = _data["codeProduit"];
        }
    }

    static fromJS(data: any): GetTypesDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeProduit"] = this.codeProduit;
        return data;
    }
}

export interface IGetTypesDocumentsRequest {
    codeProduit?: string | undefined;
}

export class GetTypesDocumentsResponse implements IGetTypesDocumentsResponse {
    typeDocument?: TypeDocument[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IGetTypesDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["typeDocument"])) {
                this.typeDocument = [] as any;
                for (let item of _data["typeDocument"])
                    this.typeDocument!.push(TypeDocument.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTypesDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypesDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.typeDocument)) {
            data["typeDocument"] = [];
            for (let item of this.typeDocument)
                data["typeDocument"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTypesDocumentsResponse {
    typeDocument?: TypeDocument[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class GrilleDesensibilisation implements IGrilleDesensibilisation {
    supportEuro?: string | undefined;
    supportUC?: string | undefined;
    repartition?: LigneRepartition[] | undefined;

    constructor(data?: IGrilleDesensibilisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportEuro = _data["supportEuro"];
            this.supportUC = _data["supportUC"];
            if (Array.isArray(_data["repartition"])) {
                this.repartition = [] as any;
                for (let item of _data["repartition"])
                    this.repartition!.push(LigneRepartition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GrilleDesensibilisation {
        data = typeof data === 'object' ? data : {};
        let result = new GrilleDesensibilisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportEuro"] = this.supportEuro;
        data["supportUC"] = this.supportUC;
        if (Array.isArray(this.repartition)) {
            data["repartition"] = [];
            for (let item of this.repartition)
                data["repartition"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGrilleDesensibilisation {
    supportEuro?: string | undefined;
    supportUC?: string | undefined;
    repartition?: LigneRepartition[] | undefined;
}

export class LienDocuments implements ILienDocuments {
    idPackDoc?: number | undefined;
    libelle?: string | undefined;
    document?: Document[] | undefined;

    constructor(data?: ILienDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idPackDoc = _data["idPackDoc"];
            this.libelle = _data["libelle"];
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LienDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new LienDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idPackDoc"] = this.idPackDoc;
        data["libelle"] = this.libelle;
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILienDocuments {
    idPackDoc?: number | undefined;
    libelle?: string | undefined;
    document?: Document[] | undefined;
}

export class LigneRepartition implements ILigneRepartition {
    nbAnneesRestantesHorizon?: number | undefined;
    repartitionSupportEuro?: number | undefined;
    repartitionSupportUC?: number | undefined;

    constructor(data?: ILigneRepartition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nbAnneesRestantesHorizon = _data["nbAnneesRestantesHorizon"];
            this.repartitionSupportEuro = _data["repartitionSupportEuro"];
            this.repartitionSupportUC = _data["repartitionSupportUC"];
        }
    }

    static fromJS(data: any): LigneRepartition {
        data = typeof data === 'object' ? data : {};
        let result = new LigneRepartition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nbAnneesRestantesHorizon"] = this.nbAnneesRestantesHorizon;
        data["repartitionSupportEuro"] = this.repartitionSupportEuro;
        data["repartitionSupportUC"] = this.repartitionSupportUC;
        return data;
    }
}

export interface ILigneRepartition {
    nbAnneesRestantesHorizon?: number | undefined;
    repartitionSupportEuro?: number | undefined;
    repartitionSupportUC?: number | undefined;
}

export class ListeReferencesMetierRequest implements IListeReferencesMetierRequest {
    idTypeReference?: number | undefined;

    constructor(data?: IListeReferencesMetierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeReference = _data["idTypeReference"];
        }
    }

    static fromJS(data: any): ListeReferencesMetierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListeReferencesMetierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeReference"] = this.idTypeReference;
        return data;
    }
}

export interface IListeReferencesMetierRequest {
    idTypeReference?: number | undefined;
}

export class ListeReferencesMetierResponse implements IListeReferencesMetierResponse {
    idTypeReference?: number | undefined;
    libelleTypeReference?: string | undefined;
    reference?: Reference[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IListeReferencesMetierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idTypeReference = _data["idTypeReference"];
            this.libelleTypeReference = _data["libelleTypeReference"];
            if (Array.isArray(_data["reference"])) {
                this.reference = [] as any;
                for (let item of _data["reference"])
                    this.reference!.push(Reference.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListeReferencesMetierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListeReferencesMetierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idTypeReference"] = this.idTypeReference;
        data["libelleTypeReference"] = this.libelleTypeReference;
        if (Array.isArray(this.reference)) {
            data["reference"] = [];
            for (let item of this.reference)
                data["reference"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListeReferencesMetierResponse {
    idTypeReference?: number | undefined;
    libelleTypeReference?: string | undefined;
    reference?: Reference[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class Mandat2 implements IMandat2 {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    pourcentageEuros?: number;
    pourcentageUC?: number;
    dureePlacementConseillee?: number;

    constructor(data?: IMandat2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.pourcentageEuros = _data["pourcentageEuros"];
            this.pourcentageUC = _data["pourcentageUC"];
            this.dureePlacementConseillee = _data["dureePlacementConseillee"];
        }
    }

    static fromJS(data: any): Mandat2 {
        data = typeof data === 'object' ? data : {};
        let result = new Mandat2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["pourcentageEuros"] = this.pourcentageEuros;
        data["pourcentageUC"] = this.pourcentageUC;
        data["dureePlacementConseillee"] = this.dureePlacementConseillee;
        return data;
    }
}

export interface IMandat2 {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    pourcentageEuros?: number;
    pourcentageUC?: number;
    dureePlacementConseillee?: number;
}

export class MandatGestion implements IMandatGestion {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;
    allocation?: FondsRepartition[] | undefined;

    constructor(data?: IMandatGestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.libelleRepartition = _data["libelleRepartition"];
            this.document = _data["document"] ? Document4.fromJS(_data["document"]) : <any>undefined;
            this.dureePlacementConseillee = _data["dureePlacementConseillee"];
            if (Array.isArray(_data["allocation"])) {
                this.allocation = [] as any;
                for (let item of _data["allocation"])
                    this.allocation!.push(FondsRepartition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MandatGestion {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["libelleRepartition"] = this.libelleRepartition;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["dureePlacementConseillee"] = this.dureePlacementConseillee;
        if (Array.isArray(this.allocation)) {
            data["allocation"] = [];
            for (let item of this.allocation)
                data["allocation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMandatGestion {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;
    allocation?: FondsRepartition[] | undefined;
}

export class MandatGestion2 implements IMandatGestion2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;

    constructor(data?: IMandatGestion2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.libelleRepartition = _data["libelleRepartition"];
            this.document = _data["document"] ? Document4.fromJS(_data["document"]) : <any>undefined;
            this.dureePlacementConseillee = _data["dureePlacementConseillee"];
        }
    }

    static fromJS(data: any): MandatGestion2 {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestion2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["libelleRepartition"] = this.libelleRepartition;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["dureePlacementConseillee"] = this.dureePlacementConseillee;
        return data;
    }
}

export interface IMandatGestion2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
    libelleRepartition?: string | undefined;
    document?: Document4;
    dureePlacementConseillee?: string | undefined;
}

export class MandatGestionRequest implements IMandatGestionRequest {
    idMandatGestion?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;

    constructor(data?: IMandatGestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idMandatGestion = _data["idMandatGestion"];
            this.codeProduit = _data["codeProduit"];
            this.lireDocuments = _data["lireDocuments"];
        }
    }

    static fromJS(data: any): MandatGestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idMandatGestion"] = this.idMandatGestion;
        data["codeProduit"] = this.codeProduit;
        data["lireDocuments"] = this.lireDocuments;
        return data;
    }
}

export interface IMandatGestionRequest {
    idMandatGestion?: number | undefined;
    codeProduit?: string | undefined;
    lireDocuments?: boolean;
}

export class MandatGestionResponse implements IMandatGestionResponse {
    mandatGestion?: MandatGestion[] | undefined;
    erreurs?: Erreur12[] | undefined;

    constructor(data?: IMandatGestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mandatGestion"])) {
                this.mandatGestion = [] as any;
                for (let item of _data["mandatGestion"])
                    this.mandatGestion!.push(MandatGestion.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur12.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MandatGestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MandatGestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mandatGestion)) {
            data["mandatGestion"] = [];
            for (let item of this.mandatGestion)
                data["mandatGestion"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMandatGestionResponse {
    mandatGestion?: MandatGestion[] | undefined;
    erreurs?: Erreur12[] | undefined;
}

export class ModeGestion implements IModeGestion {
    id?: number;
    libelle?: string | undefined;

    constructor(data?: IModeGestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): ModeGestion {
        data = typeof data === 'object' ? data : {};
        let result = new ModeGestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IModeGestion {
    id?: number;
    libelle?: string | undefined;
}

export class ModeGestionRecommandation implements IModeGestionRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: string | undefined;
    mandatGestion?: MandatGestion2;
    poche?: Poche[] | undefined;

    constructor(data?: IModeGestionRecommandation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
            this.mandatGestion = _data["mandatGestion"] ? MandatGestion2.fromJS(_data["mandatGestion"]) : <any>undefined;
            if (Array.isArray(_data["poche"])) {
                this.poche = [] as any;
                for (let item of _data["poche"])
                    this.poche!.push(Poche.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModeGestionRecommandation {
        data = typeof data === 'object' ? data : {};
        let result = new ModeGestionRecommandation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        data["mandatGestion"] = this.mandatGestion ? this.mandatGestion.toJSON() : <any>undefined;
        if (Array.isArray(this.poche)) {
            data["poche"] = [];
            for (let item of this.poche)
                data["poche"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModeGestionRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: string | undefined;
    mandatGestion?: MandatGestion2;
    poche?: Poche[] | undefined;
}

export class MontantsSeuilsArbitrage implements IMontantsSeuilsArbitrage {
    mntMaxSeuilFondsEuroDesinvesti?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;

    constructor(data?: IMontantsSeuilsArbitrage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mntMaxSeuilFondsEuroDesinvesti = _data["mntMaxSeuilFondsEuroDesinvesti"];
            this.seuilReglesDDCDepasse = _data["seuilReglesDDCDepasse"];
        }
    }

    static fromJS(data: any): MontantsSeuilsArbitrage {
        data = typeof data === 'object' ? data : {};
        let result = new MontantsSeuilsArbitrage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mntMaxSeuilFondsEuroDesinvesti"] = this.mntMaxSeuilFondsEuroDesinvesti;
        data["seuilReglesDDCDepasse"] = this.seuilReglesDDCDepasse;
        return data;
    }
}

export interface IMontantsSeuilsArbitrage {
    mntMaxSeuilFondsEuroDesinvesti?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
}

export class MontantsSeuilsRachat implements IMontantsSeuilsRachat {
    mntValeurRachatTotal?: number | undefined;
    mntValeurRachatPartiel?: number | undefined;
    mntMinRachat?: number | undefined;
    mntMaxSeuilRachat?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
    seuilReglesDDFDepasse?: boolean | undefined;
    optionFiscalePFLAutorisee?: boolean | undefined;

    constructor(data?: IMontantsSeuilsRachat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mntValeurRachatTotal = _data["mntValeurRachatTotal"];
            this.mntValeurRachatPartiel = _data["mntValeurRachatPartiel"];
            this.mntMinRachat = _data["mntMinRachat"];
            this.mntMaxSeuilRachat = _data["mntMaxSeuilRachat"];
            this.seuilReglesDDCDepasse = _data["seuilReglesDDCDepasse"];
            this.seuilReglesDDFDepasse = _data["seuilReglesDDFDepasse"];
            this.optionFiscalePFLAutorisee = _data["optionFiscalePFLAutorisee"];
        }
    }

    static fromJS(data: any): MontantsSeuilsRachat {
        data = typeof data === 'object' ? data : {};
        let result = new MontantsSeuilsRachat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mntValeurRachatTotal"] = this.mntValeurRachatTotal;
        data["mntValeurRachatPartiel"] = this.mntValeurRachatPartiel;
        data["mntMinRachat"] = this.mntMinRachat;
        data["mntMaxSeuilRachat"] = this.mntMaxSeuilRachat;
        data["seuilReglesDDCDepasse"] = this.seuilReglesDDCDepasse;
        data["seuilReglesDDFDepasse"] = this.seuilReglesDDFDepasse;
        data["optionFiscalePFLAutorisee"] = this.optionFiscalePFLAutorisee;
        return data;
    }
}

export interface IMontantsSeuilsRachat {
    mntValeurRachatTotal?: number | undefined;
    mntValeurRachatPartiel?: number | undefined;
    mntMinRachat?: number | undefined;
    mntMaxSeuilRachat?: number | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
    seuilReglesDDFDepasse?: boolean | undefined;
    optionFiscalePFLAutorisee?: boolean | undefined;
}

export class MontantsSeuilsVersement implements IMontantsSeuilsVersement {
    mntMinVersementLibre?: number | undefined;
    mntMinVersementProgramme?: number | undefined;
    mntMaxSeuilVersementLibre?: number | undefined;
    mntMaxSeuilVersementProgramme?: number | undefined;
    seuilReglesPOFDepasse?: boolean | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;

    constructor(data?: IMontantsSeuilsVersement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mntMinVersementLibre = _data["mntMinVersementLibre"];
            this.mntMinVersementProgramme = _data["mntMinVersementProgramme"];
            this.mntMaxSeuilVersementLibre = _data["mntMaxSeuilVersementLibre"];
            this.mntMaxSeuilVersementProgramme = _data["mntMaxSeuilVersementProgramme"];
            this.seuilReglesPOFDepasse = _data["seuilReglesPOFDepasse"];
            this.seuilReglesDDCDepasse = _data["seuilReglesDDCDepasse"];
        }
    }

    static fromJS(data: any): MontantsSeuilsVersement {
        data = typeof data === 'object' ? data : {};
        let result = new MontantsSeuilsVersement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mntMinVersementLibre"] = this.mntMinVersementLibre;
        data["mntMinVersementProgramme"] = this.mntMinVersementProgramme;
        data["mntMaxSeuilVersementLibre"] = this.mntMaxSeuilVersementLibre;
        data["mntMaxSeuilVersementProgramme"] = this.mntMaxSeuilVersementProgramme;
        data["seuilReglesPOFDepasse"] = this.seuilReglesPOFDepasse;
        data["seuilReglesDDCDepasse"] = this.seuilReglesDDCDepasse;
        return data;
    }
}

export interface IMontantsSeuilsVersement {
    mntMinVersementLibre?: number | undefined;
    mntMinVersementProgramme?: number | undefined;
    mntMaxSeuilVersementLibre?: number | undefined;
    mntMaxSeuilVersementProgramme?: number | undefined;
    seuilReglesPOFDepasse?: boolean | undefined;
    seuilReglesDDCDepasse?: boolean | undefined;
}

export class MotifRachat implements IMotifRachat {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IMotifRachat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.valeur = _data["valeur"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): MotifRachat {
        data = typeof data === 'object' ? data : {};
        let result = new MotifRachat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["valeur"] = this.valeur;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IMotifRachat {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;
}

export class OrigineDemande implements IOrigineDemande {
    id?: string | undefined;
    libelle?: string | undefined;

    constructor(data?: IOrigineDemande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): OrigineDemande {
        data = typeof data === 'object' ? data : {};
        let result = new OrigineDemande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface IOrigineDemande {
    id?: string | undefined;
    libelle?: string | undefined;
}

export class Performance implements IPerformance {
    id?: number | undefined;
    libelle?: string | undefined;
    taux?: number | undefined;
    annee?: number | undefined;
    typeUC?: boolean | undefined;
    ordre?: number | undefined;

    constructor(data?: IPerformance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.taux = _data["taux"];
            this.annee = _data["annee"];
            this.typeUC = _data["typeUC"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): Performance {
        data = typeof data === 'object' ? data : {};
        let result = new Performance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["taux"] = this.taux;
        data["annee"] = this.annee;
        data["typeUC"] = this.typeUC;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IPerformance {
    id?: number | undefined;
    libelle?: string | undefined;
    taux?: number | undefined;
    annee?: number | undefined;
    typeUC?: boolean | undefined;
    ordre?: number | undefined;
}

export class Personne implements IPersonne {
    numeroSocietaire?: string | undefined;
    noContrat?: number;
    dateNaissance?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneFixe?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPersonne) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroSocietaire = _data["numeroSocietaire"];
            this.noContrat = _data["noContrat"];
            this.dateNaissance = _data["dateNaissance"];
            this.civilite = _data["civilite"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.telephoneMobile = _data["telephoneMobile"];
            this.telephoneFixe = _data["telephoneFixe"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Personne {
        data = typeof data === 'object' ? data : {};
        let result = new Personne();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroSocietaire"] = this.numeroSocietaire;
        data["noContrat"] = this.noContrat;
        data["dateNaissance"] = this.dateNaissance;
        data["civilite"] = this.civilite;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["telephoneMobile"] = this.telephoneMobile;
        data["telephoneFixe"] = this.telephoneFixe;
        data["email"] = this.email;
        return data;
    }
}

export interface IPersonne {
    numeroSocietaire?: string | undefined;
    noContrat?: number;
    dateNaissance?: string | undefined;
    civilite?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    telephoneMobile?: string | undefined;
    telephoneFixe?: string | undefined;
    email?: string | undefined;
}

export class Poche implements IPoche {
    id?: string | undefined;
    libelle?: string | undefined;
    repartition?: string | undefined;
    fondsRepartition?: FondsRepartition[] | undefined;

    constructor(data?: IPoche) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.repartition = _data["repartition"];
            if (Array.isArray(_data["fondsRepartition"])) {
                this.fondsRepartition = [] as any;
                for (let item of _data["fondsRepartition"])
                    this.fondsRepartition!.push(FondsRepartition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Poche {
        data = typeof data === 'object' ? data : {};
        let result = new Poche();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["repartition"] = this.repartition;
        if (Array.isArray(this.fondsRepartition)) {
            data["fondsRepartition"] = [];
            for (let item of this.fondsRepartition)
                data["fondsRepartition"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPoche {
    id?: string | undefined;
    libelle?: string | undefined;
    repartition?: string | undefined;
    fondsRepartition?: FondsRepartition[] | undefined;
}

export class Produit2 implements IProduit2 {
    id?: number;

    constructor(data?: IProduit2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Produit2 {
        data = typeof data === 'object' ? data : {};
        let result = new Produit2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IProduit2 {
    id?: number;
}

export class Produit3 implements IProduit3 {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestion[] | undefined;
    typeRegle?: TypeRegle[] | undefined;
    fonds?: Fonds[] | undefined;
    document?: Document[] | undefined;

    constructor(data?: IProduit3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? TypeProduit.fromJS(_data["type"]) : <any>undefined;
            this.statut = _data["statut"];
            this.souscriptionLigne = _data["souscriptionLigne"];
            if (Array.isArray(_data["modeGestion"])) {
                this.modeGestion = [] as any;
                for (let item of _data["modeGestion"])
                    this.modeGestion!.push(ModeGestion.fromJS(item));
            }
            if (Array.isArray(_data["typeRegle"])) {
                this.typeRegle = [] as any;
                for (let item of _data["typeRegle"])
                    this.typeRegle!.push(TypeRegle.fromJS(item));
            }
            if (Array.isArray(_data["fonds"])) {
                this.fonds = [] as any;
                for (let item of _data["fonds"])
                    this.fonds!.push(Fonds.fromJS(item));
            }
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Produit3 {
        data = typeof data === 'object' ? data : {};
        let result = new Produit3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["statut"] = this.statut;
        data["souscriptionLigne"] = this.souscriptionLigne;
        if (Array.isArray(this.modeGestion)) {
            data["modeGestion"] = [];
            for (let item of this.modeGestion)
                data["modeGestion"].push(item.toJSON());
        }
        if (Array.isArray(this.typeRegle)) {
            data["typeRegle"] = [];
            for (let item of this.typeRegle)
                data["typeRegle"].push(item.toJSON());
        }
        if (Array.isArray(this.fonds)) {
            data["fonds"] = [];
            for (let item of this.fonds)
                data["fonds"].push(item.toJSON());
        }
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProduit3 {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestion[] | undefined;
    typeRegle?: TypeRegle[] | undefined;
    fonds?: Fonds[] | undefined;
    document?: Document[] | undefined;
}

export class ProduitRecommande implements IProduitRecommande {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestionRecommandation[] | undefined;

    constructor(data?: IProduitRecommande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.libelle = _data["libelle"];
            this.type = _data["type"] ? TypeProduit.fromJS(_data["type"]) : <any>undefined;
            this.statut = _data["statut"];
            this.souscriptionLigne = _data["souscriptionLigne"];
            if (Array.isArray(_data["modeGestion"])) {
                this.modeGestion = [] as any;
                for (let item of _data["modeGestion"])
                    this.modeGestion!.push(ModeGestionRecommandation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProduitRecommande {
        data = typeof data === 'object' ? data : {};
        let result = new ProduitRecommande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["libelle"] = this.libelle;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["statut"] = this.statut;
        data["souscriptionLigne"] = this.souscriptionLigne;
        if (Array.isArray(this.modeGestion)) {
            data["modeGestion"] = [];
            for (let item of this.modeGestion)
                data["modeGestion"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProduitRecommande {
    id?: number | undefined;
    code?: string | undefined;
    libelle?: string | undefined;
    type?: TypeProduit;
    statut?: boolean;
    souscriptionLigne?: boolean;
    modeGestion?: ModeGestionRecommandation[] | undefined;
}

export class Profil implements IProfil {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    scoreMin?: number;
    scoreMax?: number;
    mandat?: Mandat2;

    constructor(data?: IProfil) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
            this.scoreMin = _data["scoreMin"];
            this.scoreMax = _data["scoreMax"];
            this.mandat = _data["mandat"] ? Mandat2.fromJS(_data["mandat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Profil {
        data = typeof data === 'object' ? data : {};
        let result = new Profil();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        data["scoreMin"] = this.scoreMin;
        data["scoreMax"] = this.scoreMax;
        data["mandat"] = this.mandat ? this.mandat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProfil {
    id?: number;
    libelle?: string | undefined;
    description?: string | undefined;
    scoreMin?: number;
    scoreMax?: number;
    mandat?: Mandat2;
}

export class Profil2 implements IProfil2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;

    constructor(data?: IProfil2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Profil2 {
        data = typeof data === 'object' ? data : {};
        let result = new Profil2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["description"] = this.description;
        return data;
    }
}

export interface IProfil2 {
    id?: number | undefined;
    libelle?: string | undefined;
    description?: string | undefined;
}

export class ProvenanceFonds implements IProvenanceFonds {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IProvenanceFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.valeur = _data["valeur"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): ProvenanceFonds {
        data = typeof data === 'object' ? data : {};
        let result = new ProvenanceFonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["valeur"] = this.valeur;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IProvenanceFonds {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;
}

export class Recommandation implements IRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    horizonMin?: number | undefined;
    horizonMax?: number | undefined;
    profil?: Profil2;
    produitRecommande?: ProduitRecommande;

    constructor(data?: IRecommandation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.horizonMin = _data["horizonMin"];
            this.horizonMax = _data["horizonMax"];
            this.profil = _data["profil"] ? Profil2.fromJS(_data["profil"]) : <any>undefined;
            this.produitRecommande = _data["produitRecommande"] ? ProduitRecommande.fromJS(_data["produitRecommande"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Recommandation {
        data = typeof data === 'object' ? data : {};
        let result = new Recommandation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["horizonMin"] = this.horizonMin;
        data["horizonMax"] = this.horizonMax;
        data["profil"] = this.profil ? this.profil.toJSON() : <any>undefined;
        data["produitRecommande"] = this.produitRecommande ? this.produitRecommande.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRecommandation {
    id?: number | undefined;
    libelle?: string | undefined;
    horizonMin?: number | undefined;
    horizonMax?: number | undefined;
    profil?: Profil2;
    produitRecommande?: ProduitRecommande;
}

export class Reference implements IReference {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelleCourt = _data["libelleCourt"];
            this.libelleLong = _data["libelleLong"];
            this.valeur = _data["valeur"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelleCourt"] = this.libelleCourt;
        data["libelleLong"] = this.libelleLong;
        data["valeur"] = this.valeur;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IReference {
    id?: number | undefined;
    libelleCourt?: string | undefined;
    libelleLong?: string | undefined;
    valeur?: string | undefined;
    ordre?: number | undefined;
}

export class Regle implements IRegle {
    code?: string | undefined;
    type?: number;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    ordre?: number | undefined;
    idCategorie?: number | undefined;
    reponsePossible?: ReponsePossible[] | undefined;
    reponseAttendue?: ReponseAttendue[] | undefined;

    constructor(data?: IRegle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.libelle = _data["libelle"];
            this.valeur = _data["valeur"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
            this.ordre = _data["ordre"];
            this.idCategorie = _data["idCategorie"];
            if (Array.isArray(_data["reponsePossible"])) {
                this.reponsePossible = [] as any;
                for (let item of _data["reponsePossible"])
                    this.reponsePossible!.push(ReponsePossible.fromJS(item));
            }
            if (Array.isArray(_data["reponseAttendue"])) {
                this.reponseAttendue = [] as any;
                for (let item of _data["reponseAttendue"])
                    this.reponseAttendue!.push(ReponseAttendue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Regle {
        data = typeof data === 'object' ? data : {};
        let result = new Regle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["libelle"] = this.libelle;
        data["valeur"] = this.valeur;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        data["ordre"] = this.ordre;
        data["idCategorie"] = this.idCategorie;
        if (Array.isArray(this.reponsePossible)) {
            data["reponsePossible"] = [];
            for (let item of this.reponsePossible)
                data["reponsePossible"].push(item.toJSON());
        }
        if (Array.isArray(this.reponseAttendue)) {
            data["reponseAttendue"] = [];
            for (let item of this.reponseAttendue)
                data["reponseAttendue"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegle {
    code?: string | undefined;
    type?: number;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    ordre?: number | undefined;
    idCategorie?: number | undefined;
    reponsePossible?: ReponsePossible[] | undefined;
    reponseAttendue?: ReponseAttendue[] | undefined;
}

export class ReponseAttendue implements IReponseAttendue {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;

    constructor(data?: IReponseAttendue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.num = _data["num"];
            this.libelle = _data["libelle"];
            this.valeur = _data["valeur"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
        }
    }

    static fromJS(data: any): ReponseAttendue {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseAttendue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["num"] = this.num;
        data["libelle"] = this.libelle;
        data["valeur"] = this.valeur;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        return data;
    }
}

export interface IReponseAttendue {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
}

export class ReponsePossible implements IReponsePossible {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;

    constructor(data?: IReponsePossible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.num = _data["num"];
            this.libelle = _data["libelle"];
            this.valeur = _data["valeur"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
        }
    }

    static fromJS(data: any): ReponsePossible {
        data = typeof data === 'object' ? data : {};
        let result = new ReponsePossible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["num"] = this.num;
        data["libelle"] = this.libelle;
        data["valeur"] = this.valeur;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        return data;
    }
}

export interface IReponsePossible {
    code?: string | undefined;
    num?: number | undefined;
    libelle?: string | undefined;
    valeur?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
}

export class Type implements IType {
    id?: string | undefined;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IType {
    id?: string | undefined;
}

export class TypeDocument implements ITypeDocument {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: ITypeDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): TypeDocument {
        data = typeof data === 'object' ? data : {};
        let result = new TypeDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface ITypeDocument {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class TypeFonds implements ITypeFonds {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: ITypeFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): TypeFonds {
        data = typeof data === 'object' ? data : {};
        let result = new TypeFonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface ITypeFonds {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class TypeProduit implements ITypeProduit {
    id?: number | undefined;
    libelle?: string | undefined;

    constructor(data?: ITypeProduit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
        }
    }

    static fromJS(data: any): TypeProduit {
        data = typeof data === 'object' ? data : {};
        let result = new TypeProduit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        return data;
    }
}

export interface ITypeProduit {
    id?: number | undefined;
    libelle?: string | undefined;
}

export class TypeRegle implements ITypeRegle {
    id?: number | undefined;
    libelle?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    statut?: boolean;
    regle?: Regle[] | undefined;

    constructor(data?: ITypeRegle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.format = _data["format"];
            this.longueur = _data["longueur"];
            this.statut = _data["statut"];
            if (Array.isArray(_data["regle"])) {
                this.regle = [] as any;
                for (let item of _data["regle"])
                    this.regle!.push(Regle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeRegle {
        data = typeof data === 'object' ? data : {};
        let result = new TypeRegle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["format"] = this.format;
        data["longueur"] = this.longueur;
        data["statut"] = this.statut;
        if (Array.isArray(this.regle)) {
            data["regle"] = [];
            for (let item of this.regle)
                data["regle"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeRegle {
    id?: number | undefined;
    libelle?: string | undefined;
    format?: string | undefined;
    longueur?: number | undefined;
    statut?: boolean;
    regle?: Regle[] | undefined;
}

export class Versement implements IVersement {
    montantBrutVerseFondsEuro?: number | undefined;
    montantFraisVersementFondsEuro?: number | undefined;
    montantNetVerseFondsEuro?: number | undefined;
    montantBrutVerseFondsUC?: number | undefined;
    montantFraisVersementFondsUC?: number | undefined;
    montantNetVerseFondsUC?: number | undefined;

    constructor(data?: IVersement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.montantBrutVerseFondsEuro = _data["montantBrutVerseFondsEuro"];
            this.montantFraisVersementFondsEuro = _data["montantFraisVersementFondsEuro"];
            this.montantNetVerseFondsEuro = _data["montantNetVerseFondsEuro"];
            this.montantBrutVerseFondsUC = _data["montantBrutVerseFondsUC"];
            this.montantFraisVersementFondsUC = _data["montantFraisVersementFondsUC"];
            this.montantNetVerseFondsUC = _data["montantNetVerseFondsUC"];
        }
    }

    static fromJS(data: any): Versement {
        data = typeof data === 'object' ? data : {};
        let result = new Versement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["montantBrutVerseFondsEuro"] = this.montantBrutVerseFondsEuro;
        data["montantFraisVersementFondsEuro"] = this.montantFraisVersementFondsEuro;
        data["montantNetVerseFondsEuro"] = this.montantNetVerseFondsEuro;
        data["montantBrutVerseFondsUC"] = this.montantBrutVerseFondsUC;
        data["montantFraisVersementFondsUC"] = this.montantFraisVersementFondsUC;
        data["montantNetVerseFondsUC"] = this.montantNetVerseFondsUC;
        return data;
    }
}

export interface IVersement {
    montantBrutVerseFondsEuro?: number | undefined;
    montantFraisVersementFondsEuro?: number | undefined;
    montantNetVerseFondsEuro?: number | undefined;
    montantBrutVerseFondsUC?: number | undefined;
    montantFraisVersementFondsUC?: number | undefined;
    montantNetVerseFondsUC?: number | undefined;
}

export class ZoneGeographique implements IZoneGeographique {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: number | undefined;

    constructor(data?: IZoneGeographique) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.ordre = _data["ordre"];
        }
    }

    static fromJS(data: any): ZoneGeographique {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneGeographique();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["ordre"] = this.ordre;
        return data;
    }
}

export interface IZoneGeographique {
    id?: number | undefined;
    libelle?: string | undefined;
    ordre?: number | undefined;
}

export class CoordonneesBancaires implements ICoordonneesBancaires {
    RUM?: string | undefined;
    IBAN?: string | undefined;
    codeBIC?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateSignature?: string | undefined;
    numeroInterneSocietaire?: number | undefined;
    polices?: Police4[] | undefined;

    constructor(data?: ICoordonneesBancaires) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.RUM = _data["RUM"];
            this.IBAN = _data["IBAN"];
            this.codeBIC = _data["codeBIC"];
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.dateSignature = _data["dateSignature"];
            this.numeroInterneSocietaire = _data["numeroInterneSocietaire"];
            if (Array.isArray(_data["polices"])) {
                this.polices = [] as any;
                for (let item of _data["polices"])
                    this.polices!.push(Police4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoordonneesBancaires {
        data = typeof data === 'object' ? data : {};
        let result = new CoordonneesBancaires();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RUM"] = this.RUM;
        data["IBAN"] = this.IBAN;
        data["codeBIC"] = this.codeBIC;
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["dateSignature"] = this.dateSignature;
        data["numeroInterneSocietaire"] = this.numeroInterneSocietaire;
        if (Array.isArray(this.polices)) {
            data["polices"] = [];
            for (let item of this.polices)
                data["polices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoordonneesBancaires {
    RUM?: string | undefined;
    IBAN?: string | undefined;
    codeBIC?: string | undefined;
    nom?: string | undefined;
    prenom?: string | undefined;
    dateSignature?: string | undefined;
    numeroInterneSocietaire?: number | undefined;
    polices?: Police4[] | undefined;
}

export class CreateMandatRequest implements ICreateMandatRequest {
    mandat?: Mandat3;

    constructor(data?: ICreateMandatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandat = _data["mandat"] ? Mandat3.fromJS(_data["mandat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMandatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMandatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandat"] = this.mandat ? this.mandat.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateMandatRequest {
    mandat?: Mandat3;
}

export class CreateMandatResponse implements ICreateMandatResponse {
    codeRetour?: number | undefined;
    message?: string | undefined;
    erreurs?: Erreur13[] | undefined;

    constructor(data?: ICreateMandatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeRetour = _data["codeRetour"];
            this.message = _data["message"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur13.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMandatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMandatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRetour"] = this.codeRetour;
        data["message"] = this.message;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMandatResponse {
    codeRetour?: number | undefined;
    message?: string | undefined;
    erreurs?: Erreur13[] | undefined;
}

export class Debiteur implements IDebiteur {
    nom?: string | undefined;
    prenom?: string | undefined;
    IBAN?: string | undefined;
    codeBIC?: string | undefined;
    adresse?: string | undefined;
    adresseComp?: string | undefined;
    adresseComp2?: string | undefined;
    lieuDit?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IDebiteur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nom = _data["nom"];
            this.prenom = _data["prenom"];
            this.IBAN = _data["IBAN"];
            this.codeBIC = _data["codeBIC"];
            this.adresse = _data["adresse"];
            this.adresseComp = _data["adresseComp"];
            this.adresseComp2 = _data["adresseComp2"];
            this.lieuDit = _data["lieuDit"];
            this.codePostal = _data["codePostal"];
            this.ville = _data["ville"];
            this.pays = _data["pays"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Debiteur {
        data = typeof data === 'object' ? data : {};
        let result = new Debiteur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nom"] = this.nom;
        data["prenom"] = this.prenom;
        data["IBAN"] = this.IBAN;
        data["codeBIC"] = this.codeBIC;
        data["adresse"] = this.adresse;
        data["adresseComp"] = this.adresseComp;
        data["adresseComp2"] = this.adresseComp2;
        data["lieuDit"] = this.lieuDit;
        data["codePostal"] = this.codePostal;
        data["ville"] = this.ville;
        data["pays"] = this.pays;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        return data;
    }
}

export interface IDebiteur {
    nom?: string | undefined;
    prenom?: string | undefined;
    IBAN?: string | undefined;
    codeBIC?: string | undefined;
    adresse?: string | undefined;
    adresseComp?: string | undefined;
    adresseComp2?: string | undefined;
    lieuDit?: string | undefined;
    codePostal?: string | undefined;
    ville?: string | undefined;
    pays?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
}

export class Erreur13 implements IErreur13 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;

    constructor(data?: IErreur13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeErreur = _data["codeErreur"];
            this.libelleErreur = _data["libelleErreur"];
        }
    }

    static fromJS(data: any): Erreur13 {
        data = typeof data === 'object' ? data : {};
        let result = new Erreur13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeErreur"] = this.codeErreur;
        data["libelleErreur"] = this.libelleErreur;
        return data;
    }
}

export interface IErreur13 {
    codeErreur?: number | undefined;
    libelleErreur?: string | undefined;
}

export class GetBICFromIBANRequest implements IGetBICFromIBANRequest {
    IBAN?: string | undefined;

    constructor(data?: IGetBICFromIBANRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.IBAN = _data["IBAN"];
        }
    }

    static fromJS(data: any): GetBICFromIBANRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetBICFromIBANRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IBAN"] = this.IBAN;
        return data;
    }
}

export interface IGetBICFromIBANRequest {
    IBAN?: string | undefined;
}

export class GetBICFromIBANResponse implements IGetBICFromIBANResponse {
    BIC?: string | undefined;
    erreurs?: Erreur13[] | undefined;

    constructor(data?: IGetBICFromIBANResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.BIC = _data["BIC"];
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur13.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBICFromIBANResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBICFromIBANResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BIC"] = this.BIC;
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBICFromIBANResponse {
    BIC?: string | undefined;
    erreurs?: Erreur13[] | undefined;
}

export class Mandat3 implements IMandat3 {
    idCrediteur?: string | undefined;
    nomCrediteur?: string | undefined;
    RUM?: string | undefined;
    dateSignature?: string | undefined;
    lieuSignature?: string | undefined;
    numeroSocietaireInterne?: number;
    numeroSocietaireExterne?: string | undefined;
    IBANSocInt?: string | undefined;
    debiteur?: Debiteur;
    polices?: Police4[] | undefined;

    constructor(data?: IMandat3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idCrediteur = _data["idCrediteur"];
            this.nomCrediteur = _data["nomCrediteur"];
            this.RUM = _data["RUM"];
            this.dateSignature = _data["dateSignature"];
            this.lieuSignature = _data["lieuSignature"];
            this.numeroSocietaireInterne = _data["numeroSocietaireInterne"];
            this.numeroSocietaireExterne = _data["numeroSocietaireExterne"];
            this.IBANSocInt = _data["IBANSocInt"];
            this.debiteur = _data["debiteur"] ? Debiteur.fromJS(_data["debiteur"]) : <any>undefined;
            if (Array.isArray(_data["polices"])) {
                this.polices = [] as any;
                for (let item of _data["polices"])
                    this.polices!.push(Police4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Mandat3 {
        data = typeof data === 'object' ? data : {};
        let result = new Mandat3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idCrediteur"] = this.idCrediteur;
        data["nomCrediteur"] = this.nomCrediteur;
        data["RUM"] = this.RUM;
        data["dateSignature"] = this.dateSignature;
        data["lieuSignature"] = this.lieuSignature;
        data["numeroSocietaireInterne"] = this.numeroSocietaireInterne;
        data["numeroSocietaireExterne"] = this.numeroSocietaireExterne;
        data["IBANSocInt"] = this.IBANSocInt;
        data["debiteur"] = this.debiteur ? this.debiteur.toJSON() : <any>undefined;
        if (Array.isArray(this.polices)) {
            data["polices"] = [];
            for (let item of this.polices)
                data["polices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMandat3 {
    idCrediteur?: string | undefined;
    nomCrediteur?: string | undefined;
    RUM?: string | undefined;
    dateSignature?: string | undefined;
    lieuSignature?: string | undefined;
    numeroSocietaireInterne?: number;
    numeroSocietaireExterne?: string | undefined;
    IBANSocInt?: string | undefined;
    debiteur?: Debiteur;
    polices?: Police4[] | undefined;
}

export class Police4 implements IPolice4 {
    noContrat?: number;

    constructor(data?: IPolice4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noContrat = _data["noContrat"];
        }
    }

    static fromJS(data: any): Police4 {
        data = typeof data === 'object' ? data : {};
        let result = new Police4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noContrat"] = this.noContrat;
        return data;
    }
}

export interface IPolice4 {
    noContrat?: number;
}

export class SearchMandatRequest implements ISearchMandatRequest {
    societaire?: Societaire2;

    constructor(data?: ISearchMandatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.societaire = _data["societaire"] ? Societaire2.fromJS(_data["societaire"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchMandatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMandatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["societaire"] = this.societaire ? this.societaire.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchMandatRequest {
    societaire?: Societaire2;
}

export class SearchMandatResponse implements ISearchMandatResponse {
    coordonneesBancaires?: CoordonneesBancaires[] | undefined;
    erreurs?: Erreur13[] | undefined;

    constructor(data?: ISearchMandatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["coordonneesBancaires"])) {
                this.coordonneesBancaires = [] as any;
                for (let item of _data["coordonneesBancaires"])
                    this.coordonneesBancaires!.push(CoordonneesBancaires.fromJS(item));
            }
            if (Array.isArray(_data["erreurs"])) {
                this.erreurs = [] as any;
                for (let item of _data["erreurs"])
                    this.erreurs!.push(Erreur13.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchMandatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMandatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coordonneesBancaires)) {
            data["coordonneesBancaires"] = [];
            for (let item of this.coordonneesBancaires)
                data["coordonneesBancaires"].push(item.toJSON());
        }
        if (Array.isArray(this.erreurs)) {
            data["erreurs"] = [];
            for (let item of this.erreurs)
                data["erreurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchMandatResponse {
    coordonneesBancaires?: CoordonneesBancaires[] | undefined;
    erreurs?: Erreur13[] | undefined;
}

export class Societaire2 implements ISocietaire2 {
    numeroInterne?: number;
    IBAN?: string | undefined;
    tousMandats?: boolean | undefined;

    constructor(data?: ISocietaire2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeroInterne = _data["numeroInterne"];
            this.IBAN = _data["IBAN"];
            this.tousMandats = _data["tousMandats"];
        }
    }

    static fromJS(data: any): Societaire2 {
        data = typeof data === 'object' ? data : {};
        let result = new Societaire2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeroInterne"] = this.numeroInterne;
        data["IBAN"] = this.IBAN;
        data["tousMandats"] = this.tousMandats;
        return data;
    }
}

export interface ISocietaire2 {
    numeroInterne?: number;
    IBAN?: string | undefined;
    tousMandats?: boolean | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
